// src/modules/portal/data/brazilianMunicipalities.ts
// Dados completos de municípios brasileiros por estado
// Gerado automaticamente em 22/12/2025
// Fonte: API do IBGE (https://servicodados.ibge.gov.br/api/v1/localidades/municipios)

export interface Municipality {
  code: string; // Código IBGE
  name: string;
  state: string;
  touristicRegion?: string;
  tourismCategory?: string; // A, B, C, D, E
  isTouristic?: boolean;
}

export const BRAZILIAN_MUNICIPALITIES: Record<string, Municipality[]> = {
  // ACRE (AC) - 22 municípios
  AC: [
    { code: '1200013', name: "Acrelândia", state: 'AC' },
    { code: '1200054', name: "Assis Brasil", state: 'AC' },
    { code: '1200104', name: "Brasiléia", state: 'AC' },
    { code: '1200138', name: "Bujari", state: 'AC' },
    { code: '1200179', name: "Capixaba", state: 'AC' },
    { code: '1200203', name: "Cruzeiro do Sul", state: 'AC' },
    { code: '1200252', name: "Epitaciolândia", state: 'AC' },
    { code: '1200302', name: "Feijó", state: 'AC' },
    { code: '1200328', name: "Jordão", state: 'AC' },
    { code: '1200336', name: "Mâncio Lima", state: 'AC' },
    { code: '1200344', name: "Manoel Urbano", state: 'AC' },
    { code: '1200351', name: "Marechal Thaumaturgo", state: 'AC' },
    { code: '1200385', name: "Plácido de Castro", state: 'AC' },
    { code: '1200807', name: "Porto Acre", state: 'AC' },
    { code: '1200393', name: "Porto Walter", state: 'AC' },
    { code: '1200401', name: "Rio Branco", state: 'AC' },
    { code: '1200427', name: "Rodrigues Alves", state: 'AC' },
    { code: '1200435', name: "Santa Rosa do Purus", state: 'AC' },
    { code: '1200500', name: "Sena Madureira", state: 'AC' },
    { code: '1200450', name: "Senador Guiomard", state: 'AC' },
    { code: '1200609', name: "Tarauacá", state: 'AC' },
    { code: '1200708', name: "Xapuri", state: 'AC' }
  ],

  // ALAGOAS (AL) - 102 municípios
  AL: [
    { code: '2700102', name: "Água Branca", state: 'AL' },
    { code: '2700201', name: "Anadia", state: 'AL' },
    { code: '2700300', name: "Arapiraca", state: 'AL' },
    { code: '2700409', name: "Atalaia", state: 'AL' },
    { code: '2700508', name: "Barra de Santo Antônio", state: 'AL' },
    { code: '2700607', name: "Barra de São Miguel", state: 'AL' },
    { code: '2700706', name: "Batalha", state: 'AL' },
    { code: '2700805', name: "Belém", state: 'AL' },
    { code: '2700904', name: "Belo Monte", state: 'AL' },
    { code: '2701001', name: "Boca da Mata", state: 'AL' },
    { code: '2701100', name: "Branquinha", state: 'AL' },
    { code: '2701209', name: "Cacimbinhas", state: 'AL' },
    { code: '2701308', name: "Cajueiro", state: 'AL' },
    { code: '2701357', name: "Campestre", state: 'AL' },
    { code: '2701407', name: "Campo Alegre", state: 'AL' },
    { code: '2701506', name: "Campo Grande", state: 'AL' },
    { code: '2701605', name: "Canapi", state: 'AL' },
    { code: '2701704', name: "Capela", state: 'AL' },
    { code: '2701803', name: "Carneiros", state: 'AL' },
    { code: '2701902', name: "Chã Preta", state: 'AL' },
    { code: '2702009', name: "Coité do Nóia", state: 'AL' },
    { code: '2702108', name: "Colônia Leopoldina", state: 'AL' },
    { code: '2702207', name: "Coqueiro Seco", state: 'AL' },
    { code: '2702306', name: "Coruripe", state: 'AL' },
    { code: '2702355', name: "Craíbas", state: 'AL' },
    { code: '2702405', name: "Delmiro Gouveia", state: 'AL' },
    { code: '2702504', name: "Dois Riachos", state: 'AL' },
    { code: '2702553', name: "Estrela de Alagoas", state: 'AL' },
    { code: '2702603', name: "Feira Grande", state: 'AL' },
    { code: '2702702', name: "Feliz Deserto", state: 'AL' },
    { code: '2702801', name: "Flexeiras", state: 'AL' },
    { code: '2702900', name: "Girau do Ponciano", state: 'AL' },
    { code: '2703007', name: "Ibateguara", state: 'AL' },
    { code: '2703106', name: "Igaci", state: 'AL' },
    { code: '2703205', name: "Igreja Nova", state: 'AL' },
    { code: '2703304', name: "Inhapi", state: 'AL' },
    { code: '2703403', name: "Jacaré dos Homens", state: 'AL' },
    { code: '2703502', name: "Jacuípe", state: 'AL' },
    { code: '2703601', name: "Japaratinga", state: 'AL' },
    { code: '2703700', name: "Jaramataia", state: 'AL' },
    { code: '2703759', name: "Jequiá da Praia", state: 'AL' },
    { code: '2703809', name: "Joaquim Gomes", state: 'AL' },
    { code: '2703908', name: "Jundiá", state: 'AL' },
    { code: '2704005', name: "Junqueiro", state: 'AL' },
    { code: '2704104', name: "Lagoa da Canoa", state: 'AL' },
    { code: '2704203', name: "Limoeiro de Anadia", state: 'AL' },
    { code: '2704302', name: "Maceió", state: 'AL' },
    { code: '2704401', name: "Major Isidoro", state: 'AL' },
    { code: '2704906', name: "Mar Vermelho", state: 'AL' },
    { code: '2704500', name: "Maragogi", state: 'AL' },
    { code: '2704609', name: "Maravilha", state: 'AL' },
    { code: '2704708', name: "Marechal Deodoro", state: 'AL' },
    { code: '2704807', name: "Maribondo", state: 'AL' },
    { code: '2705002', name: "Mata Grande", state: 'AL' },
    { code: '2705101', name: "Matriz de Camaragibe", state: 'AL' },
    { code: '2705200', name: "Messias", state: 'AL' },
    { code: '2705309', name: "Minador do Negrão", state: 'AL' },
    { code: '2705408', name: "Monteirópolis", state: 'AL' },
    { code: '2705507', name: "Murici", state: 'AL' },
    { code: '2705606', name: "Novo Lino", state: 'AL' },
    { code: '2705705', name: "Olho d'Água das Flores", state: 'AL' },
    { code: '2705804', name: "Olho d'Água do Casado", state: 'AL' },
    { code: '2705903', name: "Olho d'Água Grande", state: 'AL' },
    { code: '2706000', name: "Olivença", state: 'AL' },
    { code: '2706109', name: "Ouro Branco", state: 'AL' },
    { code: '2706208', name: "Palestina", state: 'AL' },
    { code: '2706307', name: "Palmeira dos Índios", state: 'AL' },
    { code: '2706406', name: "Pão de Açúcar", state: 'AL' },
    { code: '2706422', name: "Pariconha", state: 'AL' },
    { code: '2706448', name: "Paripueira", state: 'AL' },
    { code: '2706505', name: "Passo de Camaragibe", state: 'AL' },
    { code: '2706604', name: "Paulo Jacinto", state: 'AL' },
    { code: '2706703', name: "Penedo", state: 'AL' },
    { code: '2706802', name: "Piaçabuçu", state: 'AL' },
    { code: '2706901', name: "Pilar", state: 'AL' },
    { code: '2707008', name: "Pindoba", state: 'AL' },
    { code: '2707107', name: "Piranhas", state: 'AL' },
    { code: '2707206', name: "Poço das Trincheiras", state: 'AL' },
    { code: '2707305', name: "Porto Calvo", state: 'AL' },
    { code: '2707404', name: "Porto de Pedras", state: 'AL' },
    { code: '2707503', name: "Porto Real do Colégio", state: 'AL' },
    { code: '2707602', name: "Quebrangulo", state: 'AL' },
    { code: '2707701', name: "Rio Largo", state: 'AL' },
    { code: '2707800', name: "Roteiro", state: 'AL' },
    { code: '2707909', name: "Santa Luzia do Norte", state: 'AL' },
    { code: '2708006', name: "Santana do Ipanema", state: 'AL' },
    { code: '2708105', name: "Santana do Mundaú", state: 'AL' },
    { code: '2708204', name: "São Brás", state: 'AL' },
    { code: '2708303', name: "São José da Laje", state: 'AL' },
    { code: '2708402', name: "São José da Tapera", state: 'AL' },
    { code: '2708501', name: "São Luís do Quitunde", state: 'AL' },
    { code: '2708600', name: "São Miguel dos Campos", state: 'AL' },
    { code: '2708709', name: "São Miguel dos Milagres", state: 'AL' },
    { code: '2708808', name: "São Sebastião", state: 'AL' },
    { code: '2708907', name: "Satuba", state: 'AL' },
    { code: '2708956', name: "Senador Rui Palmeira", state: 'AL' },
    { code: '2709004', name: "Tanque d'Arca", state: 'AL' },
    { code: '2709103', name: "Taquarana", state: 'AL' },
    { code: '2709152', name: "Teotônio Vilela", state: 'AL' },
    { code: '2709202', name: "Traipu", state: 'AL' },
    { code: '2709301', name: "União dos Palmares", state: 'AL' },
    { code: '2709400', name: "Viçosa", state: 'AL' }
  ],

  // AMAZONAS (AM) - 62 municípios
  AM: [
    { code: '1300029', name: "Alvarães", state: 'AM' },
    { code: '1300060', name: "Amaturá", state: 'AM' },
    { code: '1300086', name: "Anamã", state: 'AM' },
    { code: '1300102', name: "Anori", state: 'AM' },
    { code: '1300144', name: "Apuí", state: 'AM' },
    { code: '1300201', name: "Atalaia do Norte", state: 'AM' },
    { code: '1300300', name: "Autazes", state: 'AM' },
    { code: '1300409', name: "Barcelos", state: 'AM' },
    { code: '1300508', name: "Barreirinha", state: 'AM' },
    { code: '1300607', name: "Benjamin Constant", state: 'AM' },
    { code: '1300631', name: "Beruri", state: 'AM' },
    { code: '1300680', name: "Boa Vista do Ramos", state: 'AM' },
    { code: '1300706', name: "Boca do Acre", state: 'AM' },
    { code: '1300805', name: "Borba", state: 'AM' },
    { code: '1300839', name: "Caapiranga", state: 'AM' },
    { code: '1300904', name: "Canutama", state: 'AM' },
    { code: '1301001', name: "Carauari", state: 'AM' },
    { code: '1301100', name: "Careiro", state: 'AM' },
    { code: '1301159', name: "Careiro da Várzea", state: 'AM' },
    { code: '1301209', name: "Coari", state: 'AM' },
    { code: '1301308', name: "Codajás", state: 'AM' },
    { code: '1301407', name: "Eirunepé", state: 'AM' },
    { code: '1301506', name: "Envira", state: 'AM' },
    { code: '1301605', name: "Fonte Boa", state: 'AM' },
    { code: '1301654', name: "Guajará", state: 'AM' },
    { code: '1301704', name: "Humaitá", state: 'AM' },
    { code: '1301803', name: "Ipixuna", state: 'AM' },
    { code: '1301852', name: "Iranduba", state: 'AM' },
    { code: '1301902', name: "Itacoatiara", state: 'AM' },
    { code: '1301951', name: "Itamarati", state: 'AM' },
    { code: '1302009', name: "Itapiranga", state: 'AM' },
    { code: '1302108', name: "Japurá", state: 'AM' },
    { code: '1302207', name: "Juruá", state: 'AM' },
    { code: '1302306', name: "Jutaí", state: 'AM' },
    { code: '1302405', name: "Lábrea", state: 'AM' },
    { code: '1302504', name: "Manacapuru", state: 'AM' },
    { code: '1302553', name: "Manaquiri", state: 'AM' },
    { code: '1302603', name: "Manaus", state: 'AM' },
    { code: '1302702', name: "Manicoré", state: 'AM' },
    { code: '1302801', name: "Maraã", state: 'AM' },
    { code: '1302900', name: "Maués", state: 'AM' },
    { code: '1303007', name: "Nhamundá", state: 'AM' },
    { code: '1303106', name: "Nova Olinda do Norte", state: 'AM' },
    { code: '1303205', name: "Novo Airão", state: 'AM' },
    { code: '1303304', name: "Novo Aripuanã", state: 'AM' },
    { code: '1303403', name: "Parintins", state: 'AM' },
    { code: '1303502', name: "Pauini", state: 'AM' },
    { code: '1303536', name: "Presidente Figueiredo", state: 'AM' },
    { code: '1303569', name: "Rio Preto da Eva", state: 'AM' },
    { code: '1303601', name: "Santa Isabel do Rio Negro", state: 'AM' },
    { code: '1303700', name: "Santo Antônio do Içá", state: 'AM' },
    { code: '1303809', name: "São Gabriel da Cachoeira", state: 'AM' },
    { code: '1303908', name: "São Paulo de Olivença", state: 'AM' },
    { code: '1303957', name: "São Sebastião do Uatumã", state: 'AM' },
    { code: '1304005', name: "Silves", state: 'AM' },
    { code: '1304062', name: "Tabatinga", state: 'AM' },
    { code: '1304104', name: "Tapauá", state: 'AM' },
    { code: '1304203', name: "Tefé", state: 'AM' },
    { code: '1304237', name: "Tonantins", state: 'AM' },
    { code: '1304260', name: "Uarini", state: 'AM' },
    { code: '1304302', name: "Urucará", state: 'AM' },
    { code: '1304401', name: "Urucurituba", state: 'AM' }
  ],

  // AMAPÁ (AP) - 16 municípios
  AP: [
    { code: '1600105', name: "Amapá", state: 'AP' },
    { code: '1600204', name: "Calçoene", state: 'AP' },
    { code: '1600212', name: "Cutias", state: 'AP' },
    { code: '1600238', name: "Ferreira Gomes", state: 'AP' },
    { code: '1600253', name: "Itaubal", state: 'AP' },
    { code: '1600279', name: "Laranjal do Jari", state: 'AP' },
    { code: '1600303', name: "Macapá", state: 'AP' },
    { code: '1600402', name: "Mazagão", state: 'AP' },
    { code: '1600501', name: "Oiapoque", state: 'AP' },
    { code: '1600154', name: "Pedra Branca do Amapari", state: 'AP' },
    { code: '1600535', name: "Porto Grande", state: 'AP' },
    { code: '1600550', name: "Pracuúba", state: 'AP' },
    { code: '1600600', name: "Santana", state: 'AP' },
    { code: '1600055', name: "Serra do Navio", state: 'AP' },
    { code: '1600709', name: "Tartarugalzinho", state: 'AP' },
    { code: '1600808', name: "Vitória do Jari", state: 'AP' }
  ],

  // BAHIA (BA) - 417 municípios
  BA: [
    { code: '2900108', name: "Abaíra", state: 'BA' },
    { code: '2900207', name: "Abaré", state: 'BA' },
    { code: '2900306', name: "Acajutiba", state: 'BA' },
    { code: '2900355', name: "Adustina", state: 'BA' },
    { code: '2900405', name: "Água Fria", state: 'BA' },
    { code: '2900603', name: "Aiquara", state: 'BA' },
    { code: '2900702', name: "Alagoinhas", state: 'BA' },
    { code: '2900801', name: "Alcobaça", state: 'BA' },
    { code: '2900900', name: "Almadina", state: 'BA' },
    { code: '2901007', name: "Amargosa", state: 'BA' },
    { code: '2901106', name: "Amélia Rodrigues", state: 'BA' },
    { code: '2901155', name: "América Dourada", state: 'BA' },
    { code: '2901205', name: "Anagé", state: 'BA' },
    { code: '2901304', name: "Andaraí", state: 'BA' },
    { code: '2901353', name: "Andorinha", state: 'BA' },
    { code: '2901403', name: "Angical", state: 'BA' },
    { code: '2901502', name: "Anguera", state: 'BA' },
    { code: '2901601', name: "Antas", state: 'BA' },
    { code: '2901700', name: "Antônio Cardoso", state: 'BA' },
    { code: '2901809', name: "Antônio Gonçalves", state: 'BA' },
    { code: '2901908', name: "Aporá", state: 'BA' },
    { code: '2901957', name: "Apuarema", state: 'BA' },
    { code: '2902054', name: "Araçás", state: 'BA' },
    { code: '2902005', name: "Aracatu", state: 'BA' },
    { code: '2902104', name: "Araci", state: 'BA' },
    { code: '2902203', name: "Aramari", state: 'BA' },
    { code: '2902252', name: "Arataca", state: 'BA' },
    { code: '2902302', name: "Aratuípe", state: 'BA' },
    { code: '2902401', name: "Aurelino Leal", state: 'BA' },
    { code: '2902500', name: "Baianópolis", state: 'BA' },
    { code: '2902609', name: "Baixa Grande", state: 'BA' },
    { code: '2902658', name: "Banzaê", state: 'BA' },
    { code: '2902708', name: "Barra", state: 'BA' },
    { code: '2902807', name: "Barra da Estiva", state: 'BA' },
    { code: '2902906', name: "Barra do Choça", state: 'BA' },
    { code: '2903003', name: "Barra do Mendes", state: 'BA' },
    { code: '2903102', name: "Barra do Rocha", state: 'BA' },
    { code: '2903201', name: "Barreiras", state: 'BA' },
    { code: '2903235', name: "Barro Alto", state: 'BA' },
    { code: '2903300', name: "Barro Preto", state: 'BA' },
    { code: '2903276', name: "Barrocas", state: 'BA' },
    { code: '2903409', name: "Belmonte", state: 'BA' },
    { code: '2903508', name: "Belo Campo", state: 'BA' },
    { code: '2903607', name: "Biritinga", state: 'BA' },
    { code: '2903706', name: "Boa Nova", state: 'BA' },
    { code: '2903805', name: "Boa Vista do Tupim", state: 'BA' },
    { code: '2903904', name: "Bom Jesus da Lapa", state: 'BA' },
    { code: '2903953', name: "Bom Jesus da Serra", state: 'BA' },
    { code: '2904001', name: "Boninal", state: 'BA' },
    { code: '2904050', name: "Bonito", state: 'BA' },
    { code: '2904100', name: "Boquira", state: 'BA' },
    { code: '2904209', name: "Botuporã", state: 'BA' },
    { code: '2904308', name: "Brejões", state: 'BA' },
    { code: '2904407', name: "Brejolândia", state: 'BA' },
    { code: '2904506', name: "Brotas de Macaúbas", state: 'BA' },
    { code: '2904605', name: "Brumado", state: 'BA' },
    { code: '2904704', name: "Buerarema", state: 'BA' },
    { code: '2904753', name: "Buritirama", state: 'BA' },
    { code: '2904803', name: "Caatiba", state: 'BA' },
    { code: '2904852', name: "Cabaceiras do Paraguaçu", state: 'BA' },
    { code: '2904902', name: "Cachoeira", state: 'BA' },
    { code: '2905008', name: "Caculé", state: 'BA' },
    { code: '2905107', name: "Caém", state: 'BA' },
    { code: '2905156', name: "Caetanos", state: 'BA' },
    { code: '2905206', name: "Caetité", state: 'BA' },
    { code: '2905305', name: "Cafarnaum", state: 'BA' },
    { code: '2905404', name: "Cairu", state: 'BA' },
    { code: '2905503', name: "Caldeirão Grande", state: 'BA' },
    { code: '2905602', name: "Camacan", state: 'BA' },
    { code: '2905701', name: "Camaçari", state: 'BA' },
    { code: '2905800', name: "Camamu", state: 'BA' },
    { code: '2905909', name: "Campo Alegre de Lourdes", state: 'BA' },
    { code: '2906006', name: "Campo Formoso", state: 'BA' },
    { code: '2906105', name: "Canápolis", state: 'BA' },
    { code: '2906204', name: "Canarana", state: 'BA' },
    { code: '2906303', name: "Canavieiras", state: 'BA' },
    { code: '2906402', name: "Candeal", state: 'BA' },
    { code: '2906501', name: "Candeias", state: 'BA' },
    { code: '2906600', name: "Candiba", state: 'BA' },
    { code: '2906709', name: "Cândido Sales", state: 'BA' },
    { code: '2906808', name: "Cansanção", state: 'BA' },
    { code: '2906824', name: "Canudos", state: 'BA' },
    { code: '2906857', name: "Capela do Alto Alegre", state: 'BA' },
    { code: '2906873', name: "Capim Grosso", state: 'BA' },
    { code: '2906899', name: "Caraíbas", state: 'BA' },
    { code: '2906907', name: "Caravelas", state: 'BA' },
    { code: '2907004', name: "Cardeal da Silva", state: 'BA' },
    { code: '2907103', name: "Carinhanha", state: 'BA' },
    { code: '2907202', name: "Casa Nova", state: 'BA' },
    { code: '2907301', name: "Castro Alves", state: 'BA' },
    { code: '2907400', name: "Catolândia", state: 'BA' },
    { code: '2907509', name: "Catu", state: 'BA' },
    { code: '2907558', name: "Caturama", state: 'BA' },
    { code: '2907608', name: "Central", state: 'BA' },
    { code: '2907707', name: "Chorrochó", state: 'BA' },
    { code: '2907806', name: "Cícero Dantas", state: 'BA' },
    { code: '2907905', name: "Cipó", state: 'BA' },
    { code: '2908002', name: "Coaraci", state: 'BA' },
    { code: '2908101', name: "Cocos", state: 'BA' },
    { code: '2908200', name: "Conceição da Feira", state: 'BA' },
    { code: '2908309', name: "Conceição do Almeida", state: 'BA' },
    { code: '2908408', name: "Conceição do Coité", state: 'BA' },
    { code: '2908507', name: "Conceição do Jacuípe", state: 'BA' },
    { code: '2908606', name: "Conde", state: 'BA' },
    { code: '2908705', name: "Condeúba", state: 'BA' },
    { code: '2908804', name: "Contendas do Sincorá", state: 'BA' },
    { code: '2908903', name: "Coração de Maria", state: 'BA' },
    { code: '2909000', name: "Cordeiros", state: 'BA' },
    { code: '2909109', name: "Coribe", state: 'BA' },
    { code: '2909208', name: "Coronel João Sá", state: 'BA' },
    { code: '2909307', name: "Correntina", state: 'BA' },
    { code: '2909406', name: "Cotegipe", state: 'BA' },
    { code: '2909505', name: "Cravolândia", state: 'BA' },
    { code: '2909604', name: "Crisópolis", state: 'BA' },
    { code: '2909703', name: "Cristópolis", state: 'BA' },
    { code: '2909802', name: "Cruz das Almas", state: 'BA' },
    { code: '2909901', name: "Curaçá", state: 'BA' },
    { code: '2910008', name: "Dário Meira", state: 'BA' },
    { code: '2910057', name: "Dias d'Ávila", state: 'BA' },
    { code: '2910107', name: "Dom Basílio", state: 'BA' },
    { code: '2910206', name: "Dom Macedo Costa", state: 'BA' },
    { code: '2910305', name: "Elísio Medrado", state: 'BA' },
    { code: '2910404', name: "Encruzilhada", state: 'BA' },
    { code: '2910503', name: "Entre Rios", state: 'BA' },
    { code: '2900504', name: "Érico Cardoso", state: 'BA' },
    { code: '2910602', name: "Esplanada", state: 'BA' },
    { code: '2910701', name: "Euclides da Cunha", state: 'BA' },
    { code: '2910727', name: "Eunápolis", state: 'BA' },
    { code: '2910750', name: "Fátima", state: 'BA' },
    { code: '2910776', name: "Feira da Mata", state: 'BA' },
    { code: '2910800', name: "Feira de Santana", state: 'BA' },
    { code: '2910859', name: "Filadélfia", state: 'BA' },
    { code: '2910909', name: "Firmino Alves", state: 'BA' },
    { code: '2911006', name: "Floresta Azul", state: 'BA' },
    { code: '2911105', name: "Formosa do Rio Preto", state: 'BA' },
    { code: '2911204', name: "Gandu", state: 'BA' },
    { code: '2911253', name: "Gavião", state: 'BA' },
    { code: '2911303', name: "Gentio do Ouro", state: 'BA' },
    { code: '2911402', name: "Glória", state: 'BA' },
    { code: '2911501', name: "Gongogi", state: 'BA' },
    { code: '2911600', name: "Governador Mangabeira", state: 'BA' },
    { code: '2911659', name: "Guajeru", state: 'BA' },
    { code: '2911709', name: "Guanambi", state: 'BA' },
    { code: '2911808', name: "Guaratinga", state: 'BA' },
    { code: '2911857', name: "Heliópolis", state: 'BA' },
    { code: '2911907', name: "Iaçu", state: 'BA' },
    { code: '2912004', name: "Ibiassucê", state: 'BA' },
    { code: '2912103', name: "Ibicaraí", state: 'BA' },
    { code: '2912202', name: "Ibicoara", state: 'BA' },
    { code: '2912301', name: "Ibicuí", state: 'BA' },
    { code: '2912400', name: "Ibipeba", state: 'BA' },
    { code: '2912509', name: "Ibipitanga", state: 'BA' },
    { code: '2912608', name: "Ibiquera", state: 'BA' },
    { code: '2912707', name: "Ibirapitanga", state: 'BA' },
    { code: '2912806', name: "Ibirapuã", state: 'BA' },
    { code: '2912905', name: "Ibirataia", state: 'BA' },
    { code: '2913002', name: "Ibitiara", state: 'BA' },
    { code: '2913101', name: "Ibititá", state: 'BA' },
    { code: '2913200', name: "Ibotirama", state: 'BA' },
    { code: '2913309', name: "Ichu", state: 'BA' },
    { code: '2913408', name: "Igaporã", state: 'BA' },
    { code: '2913457', name: "Igrapiúna", state: 'BA' },
    { code: '2913507', name: "Iguaí", state: 'BA' },
    { code: '2913606', name: "Ilhéus", state: 'BA' },
    { code: '2913705', name: "Inhambupe", state: 'BA' },
    { code: '2913804', name: "Ipecaetá", state: 'BA' },
    { code: '2913903', name: "Ipiaú", state: 'BA' },
    { code: '2914000', name: "Ipirá", state: 'BA' },
    { code: '2914109', name: "Ipupiara", state: 'BA' },
    { code: '2914208', name: "Irajuba", state: 'BA' },
    { code: '2914307', name: "Iramaia", state: 'BA' },
    { code: '2914406', name: "Iraquara", state: 'BA' },
    { code: '2914505', name: "Irará", state: 'BA' },
    { code: '2914604', name: "Irecê", state: 'BA' },
    { code: '2914653', name: "Itabela", state: 'BA' },
    { code: '2914703', name: "Itaberaba", state: 'BA' },
    { code: '2914802', name: "Itabuna", state: 'BA' },
    { code: '2914901', name: "Itacaré", state: 'BA' },
    { code: '2915007', name: "Itaeté", state: 'BA' },
    { code: '2915106', name: "Itagi", state: 'BA' },
    { code: '2915205', name: "Itagibá", state: 'BA' },
    { code: '2915304', name: "Itagimirim", state: 'BA' },
    { code: '2915353', name: "Itaguaçu da Bahia", state: 'BA' },
    { code: '2915403', name: "Itaju do Colônia", state: 'BA' },
    { code: '2915502', name: "Itajuípe", state: 'BA' },
    { code: '2915601', name: "Itamaraju", state: 'BA' },
    { code: '2915700', name: "Itamari", state: 'BA' },
    { code: '2915809', name: "Itambé", state: 'BA' },
    { code: '2915908', name: "Itanagra", state: 'BA' },
    { code: '2916005', name: "Itanhém", state: 'BA' },
    { code: '2916104', name: "Itaparica", state: 'BA' },
    { code: '2916203', name: "Itapé", state: 'BA' },
    { code: '2916302', name: "Itapebi", state: 'BA' },
    { code: '2916401', name: "Itapetinga", state: 'BA' },
    { code: '2916500', name: "Itapicuru", state: 'BA' },
    { code: '2916609', name: "Itapitanga", state: 'BA' },
    { code: '2916708', name: "Itaquara", state: 'BA' },
    { code: '2916807', name: "Itarantim", state: 'BA' },
    { code: '2916856', name: "Itatim", state: 'BA' },
    { code: '2916906', name: "Itiruçu", state: 'BA' },
    { code: '2917003', name: "Itiúba", state: 'BA' },
    { code: '2917102', name: "Itororó", state: 'BA' },
    { code: '2917201', name: "Ituaçu", state: 'BA' },
    { code: '2917300', name: "Ituberá", state: 'BA' },
    { code: '2917334', name: "Iuiu", state: 'BA' },
    { code: '2917359', name: "Jaborandi", state: 'BA' },
    { code: '2917409', name: "Jacaraci", state: 'BA' },
    { code: '2917508', name: "Jacobina", state: 'BA' },
    { code: '2917607', name: "Jaguaquara", state: 'BA' },
    { code: '2917706', name: "Jaguarari", state: 'BA' },
    { code: '2917805', name: "Jaguaripe", state: 'BA' },
    { code: '2917904', name: "Jandaíra", state: 'BA' },
    { code: '2918001', name: "Jequié", state: 'BA' },
    { code: '2918100', name: "Jeremoabo", state: 'BA' },
    { code: '2918209', name: "Jiquiriçá", state: 'BA' },
    { code: '2918308', name: "Jitaúna", state: 'BA' },
    { code: '2918357', name: "João Dourado", state: 'BA' },
    { code: '2918407', name: "Juazeiro", state: 'BA' },
    { code: '2918456', name: "Jucuruçu", state: 'BA' },
    { code: '2918506', name: "Jussara", state: 'BA' },
    { code: '2918555', name: "Jussari", state: 'BA' },
    { code: '2918605', name: "Jussiape", state: 'BA' },
    { code: '2918704', name: "Lafaiete Coutinho", state: 'BA' },
    { code: '2918753', name: "Lagoa Real", state: 'BA' },
    { code: '2918803', name: "Laje", state: 'BA' },
    { code: '2918902', name: "Lajedão", state: 'BA' },
    { code: '2919009', name: "Lajedinho", state: 'BA' },
    { code: '2919058', name: "Lajedo do Tabocal", state: 'BA' },
    { code: '2919108', name: "Lamarão", state: 'BA' },
    { code: '2919157', name: "Lapão", state: 'BA' },
    { code: '2919207', name: "Lauro de Freitas", state: 'BA' },
    { code: '2919306', name: "Lençóis", state: 'BA' },
    { code: '2919405', name: "Licínio de Almeida", state: 'BA' },
    { code: '2919504', name: "Livramento de Nossa Senhora", state: 'BA' },
    { code: '2919553', name: "Luís Eduardo Magalhães", state: 'BA' },
    { code: '2919603', name: "Macajuba", state: 'BA' },
    { code: '2919702', name: "Macarani", state: 'BA' },
    { code: '2919801', name: "Macaúbas", state: 'BA' },
    { code: '2919900', name: "Macururé", state: 'BA' },
    { code: '2919926', name: "Madre de Deus", state: 'BA' },
    { code: '2919959', name: "Maetinga", state: 'BA' },
    { code: '2920007', name: "Maiquinique", state: 'BA' },
    { code: '2920106', name: "Mairi", state: 'BA' },
    { code: '2920205', name: "Malhada", state: 'BA' },
    { code: '2920304', name: "Malhada de Pedras", state: 'BA' },
    { code: '2920403', name: "Manoel Vitorino", state: 'BA' },
    { code: '2920452', name: "Mansidão", state: 'BA' },
    { code: '2920502', name: "Maracás", state: 'BA' },
    { code: '2920601', name: "Maragogipe", state: 'BA' },
    { code: '2920700', name: "Maraú", state: 'BA' },
    { code: '2920809', name: "Marcionílio Souza", state: 'BA' },
    { code: '2920908', name: "Mascote", state: 'BA' },
    { code: '2921005', name: "Mata de São João", state: 'BA' },
    { code: '2921054', name: "Matina", state: 'BA' },
    { code: '2921104', name: "Medeiros Neto", state: 'BA' },
    { code: '2921203', name: "Miguel Calmon", state: 'BA' },
    { code: '2921302', name: "Milagres", state: 'BA' },
    { code: '2921401', name: "Mirangaba", state: 'BA' },
    { code: '2921450', name: "Mirante", state: 'BA' },
    { code: '2921500', name: "Monte Santo", state: 'BA' },
    { code: '2921609', name: "Morpará", state: 'BA' },
    { code: '2921708', name: "Morro do Chapéu", state: 'BA' },
    { code: '2921807', name: "Mortugaba", state: 'BA' },
    { code: '2921906', name: "Mucugê", state: 'BA' },
    { code: '2922003', name: "Mucuri", state: 'BA' },
    { code: '2922052', name: "Mulungu do Morro", state: 'BA' },
    { code: '2922102', name: "Mundo Novo", state: 'BA' },
    { code: '2922201', name: "Muniz Ferreira", state: 'BA' },
    { code: '2922250', name: "Muquém do São Francisco", state: 'BA' },
    { code: '2922300', name: "Muritiba", state: 'BA' },
    { code: '2922409', name: "Mutuípe", state: 'BA' },
    { code: '2922508', name: "Nazaré", state: 'BA' },
    { code: '2922607', name: "Nilo Peçanha", state: 'BA' },
    { code: '2922656', name: "Nordestina", state: 'BA' },
    { code: '2922706', name: "Nova Canaã", state: 'BA' },
    { code: '2922730', name: "Nova Fátima", state: 'BA' },
    { code: '2922755', name: "Nova Ibiá", state: 'BA' },
    { code: '2922805', name: "Nova Itarana", state: 'BA' },
    { code: '2922854', name: "Nova Redenção", state: 'BA' },
    { code: '2922904', name: "Nova Soure", state: 'BA' },
    { code: '2923001', name: "Nova Viçosa", state: 'BA' },
    { code: '2923035', name: "Novo Horizonte", state: 'BA' },
    { code: '2923050', name: "Novo Triunfo", state: 'BA' },
    { code: '2923100', name: "Olindina", state: 'BA' },
    { code: '2923209', name: "Oliveira dos Brejinhos", state: 'BA' },
    { code: '2923308', name: "Ouriçangas", state: 'BA' },
    { code: '2923357', name: "Ourolândia", state: 'BA' },
    { code: '2923407', name: "Palmas de Monte Alto", state: 'BA' },
    { code: '2923506', name: "Palmeiras", state: 'BA' },
    { code: '2923605', name: "Paramirim", state: 'BA' },
    { code: '2923704', name: "Paratinga", state: 'BA' },
    { code: '2923803', name: "Paripiranga", state: 'BA' },
    { code: '2923902', name: "Pau Brasil", state: 'BA' },
    { code: '2924009', name: "Paulo Afonso", state: 'BA' },
    { code: '2924058', name: "Pé de Serra", state: 'BA' },
    { code: '2924108', name: "Pedrão", state: 'BA' },
    { code: '2924207', name: "Pedro Alexandre", state: 'BA' },
    { code: '2924306', name: "Piatã", state: 'BA' },
    { code: '2924405', name: "Pilão Arcado", state: 'BA' },
    { code: '2924504', name: "Pindaí", state: 'BA' },
    { code: '2924603', name: "Pindobaçu", state: 'BA' },
    { code: '2924652', name: "Pintadas", state: 'BA' },
    { code: '2924678', name: "Piraí do Norte", state: 'BA' },
    { code: '2924702', name: "Piripá", state: 'BA' },
    { code: '2924801', name: "Piritiba", state: 'BA' },
    { code: '2924900', name: "Planaltino", state: 'BA' },
    { code: '2925006', name: "Planalto", state: 'BA' },
    { code: '2925105', name: "Poções", state: 'BA' },
    { code: '2925204', name: "Pojuca", state: 'BA' },
    { code: '2925253', name: "Ponto Novo", state: 'BA' },
    { code: '2925303', name: "Porto Seguro", state: 'BA' },
    { code: '2925402', name: "Potiraguá", state: 'BA' },
    { code: '2925501', name: "Prado", state: 'BA' },
    { code: '2925600', name: "Presidente Dutra", state: 'BA' },
    { code: '2925709', name: "Presidente Jânio Quadros", state: 'BA' },
    { code: '2925758', name: "Presidente Tancredo Neves", state: 'BA' },
    { code: '2925808', name: "Queimadas", state: 'BA' },
    { code: '2925907', name: "Quijingue", state: 'BA' },
    { code: '2925931', name: "Quixabeira", state: 'BA' },
    { code: '2925956', name: "Rafael Jambeiro", state: 'BA' },
    { code: '2926004', name: "Remanso", state: 'BA' },
    { code: '2926103', name: "Retirolândia", state: 'BA' },
    { code: '2926202', name: "Riachão das Neves", state: 'BA' },
    { code: '2926301', name: "Riachão do Jacuípe", state: 'BA' },
    { code: '2926400', name: "Riacho de Santana", state: 'BA' },
    { code: '2926509', name: "Ribeira do Amparo", state: 'BA' },
    { code: '2926608', name: "Ribeira do Pombal", state: 'BA' },
    { code: '2926657', name: "Ribeirão do Largo", state: 'BA' },
    { code: '2926707', name: "Rio de Contas", state: 'BA' },
    { code: '2926806', name: "Rio do Antônio", state: 'BA' },
    { code: '2926905', name: "Rio do Pires", state: 'BA' },
    { code: '2927002', name: "Rio Real", state: 'BA' },
    { code: '2927101', name: "Rodelas", state: 'BA' },
    { code: '2927200', name: "Ruy Barbosa", state: 'BA' },
    { code: '2927309', name: "Salinas da Margarida", state: 'BA' },
    { code: '2927408', name: "Salvador", state: 'BA' },
    { code: '2927507', name: "Santa Bárbara", state: 'BA' },
    { code: '2927606', name: "Santa Brígida", state: 'BA' },
    { code: '2927705', name: "Santa Cruz Cabrália", state: 'BA' },
    { code: '2927804', name: "Santa Cruz da Vitória", state: 'BA' },
    { code: '2927903', name: "Santa Inês", state: 'BA' },
    { code: '2928059', name: "Santa Luzia", state: 'BA' },
    { code: '2928109', name: "Santa Maria da Vitória", state: 'BA' },
    { code: '2928406', name: "Santa Rita de Cássia", state: 'BA' },
    { code: '2928505', name: "Santa Terezinha", state: 'BA' },
    { code: '2928000', name: "Santaluz", state: 'BA' },
    { code: '2928208', name: "Santana", state: 'BA' },
    { code: '2928307', name: "Santanópolis", state: 'BA' },
    { code: '2928604', name: "Santo Amaro", state: 'BA' },
    { code: '2928703', name: "Santo Antônio de Jesus", state: 'BA' },
    { code: '2928802', name: "Santo Estêvão", state: 'BA' },
    { code: '2928901', name: "São Desidério", state: 'BA' },
    { code: '2928950', name: "São Domingos", state: 'BA' },
    { code: '2929107', name: "São Felipe", state: 'BA' },
    { code: '2929008', name: "São Félix", state: 'BA' },
    { code: '2929057', name: "São Félix do Coribe", state: 'BA' },
    { code: '2929206', name: "São Francisco do Conde", state: 'BA' },
    { code: '2929255', name: "São Gabriel", state: 'BA' },
    { code: '2929305', name: "São Gonçalo dos Campos", state: 'BA' },
    { code: '2929354', name: "São José da Vitória", state: 'BA' },
    { code: '2929370', name: "São José do Jacuípe", state: 'BA' },
    { code: '2929404', name: "São Miguel das Matas", state: 'BA' },
    { code: '2929503', name: "São Sebastião do Passé", state: 'BA' },
    { code: '2929602', name: "Sapeaçu", state: 'BA' },
    { code: '2929701', name: "Sátiro Dias", state: 'BA' },
    { code: '2929750', name: "Saubara", state: 'BA' },
    { code: '2929800', name: "Saúde", state: 'BA' },
    { code: '2929909', name: "Seabra", state: 'BA' },
    { code: '2930006', name: "Sebastião Laranjeiras", state: 'BA' },
    { code: '2930105', name: "Senhor do Bonfim", state: 'BA' },
    { code: '2930204', name: "Sento Sé", state: 'BA' },
    { code: '2930154', name: "Serra do Ramalho", state: 'BA' },
    { code: '2930303', name: "Serra Dourada", state: 'BA' },
    { code: '2930402', name: "Serra Preta", state: 'BA' },
    { code: '2930501', name: "Serrinha", state: 'BA' },
    { code: '2930600', name: "Serrolândia", state: 'BA' },
    { code: '2930709', name: "Simões Filho", state: 'BA' },
    { code: '2930758', name: "Sítio do Mato", state: 'BA' },
    { code: '2930766', name: "Sítio do Quinto", state: 'BA' },
    { code: '2930774', name: "Sobradinho", state: 'BA' },
    { code: '2930808', name: "Souto Soares", state: 'BA' },
    { code: '2930907', name: "Tabocas do Brejo Velho", state: 'BA' },
    { code: '2931004', name: "Tanhaçu", state: 'BA' },
    { code: '2931053', name: "Tanque Novo", state: 'BA' },
    { code: '2931103', name: "Tanquinho", state: 'BA' },
    { code: '2931202', name: "Taperoá", state: 'BA' },
    { code: '2931301', name: "Tapiramutá", state: 'BA' },
    { code: '2931350', name: "Teixeira de Freitas", state: 'BA' },
    { code: '2931400', name: "Teodoro Sampaio", state: 'BA' },
    { code: '2931509', name: "Teofilândia", state: 'BA' },
    { code: '2931608', name: "Teolândia", state: 'BA' },
    { code: '2931707', name: "Terra Nova", state: 'BA' },
    { code: '2931806', name: "Tremedal", state: 'BA' },
    { code: '2931905', name: "Tucano", state: 'BA' },
    { code: '2932002', name: "Uauá", state: 'BA' },
    { code: '2932101', name: "Ubaíra", state: 'BA' },
    { code: '2932200', name: "Ubaitaba", state: 'BA' },
    { code: '2932309', name: "Ubatã", state: 'BA' },
    { code: '2932408', name: "Uibaí", state: 'BA' },
    { code: '2932457', name: "Umburanas", state: 'BA' },
    { code: '2932507', name: "Una", state: 'BA' },
    { code: '2932606', name: "Urandi", state: 'BA' },
    { code: '2932705', name: "Uruçuca", state: 'BA' },
    { code: '2932804', name: "Utinga", state: 'BA' },
    { code: '2932903', name: "Valença", state: 'BA' },
    { code: '2933000', name: "Valente", state: 'BA' },
    { code: '2933059', name: "Várzea da Roça", state: 'BA' },
    { code: '2933109', name: "Várzea do Poço", state: 'BA' },
    { code: '2933158', name: "Várzea Nova", state: 'BA' },
    { code: '2933174', name: "Varzedo", state: 'BA' },
    { code: '2933208', name: "Vera Cruz", state: 'BA' },
    { code: '2933257', name: "Vereda", state: 'BA' },
    { code: '2933307', name: "Vitória da Conquista", state: 'BA' },
    { code: '2933406', name: "Wagner", state: 'BA' },
    { code: '2933455', name: "Wanderley", state: 'BA' },
    { code: '2933505', name: "Wenceslau Guimarães", state: 'BA' },
    { code: '2933604', name: "Xique-Xique", state: 'BA' }
  ],

  // CEARÁ (CE) - 184 municípios
  CE: [
    { code: '2300101', name: "Abaiara", state: 'CE' },
    { code: '2300150', name: "Acarape", state: 'CE' },
    { code: '2300200', name: "Acaraú", state: 'CE' },
    { code: '2300309', name: "Acopiara", state: 'CE' },
    { code: '2300408', name: "Aiuaba", state: 'CE' },
    { code: '2300507', name: "Alcântaras", state: 'CE' },
    { code: '2300606', name: "Altaneira", state: 'CE' },
    { code: '2300705', name: "Alto Santo", state: 'CE' },
    { code: '2300754', name: "Amontada", state: 'CE' },
    { code: '2300804', name: "Antonina do Norte", state: 'CE' },
    { code: '2300903', name: "Apuiarés", state: 'CE' },
    { code: '2301000', name: "Aquiraz", state: 'CE' },
    { code: '2301109', name: "Aracati", state: 'CE' },
    { code: '2301208', name: "Aracoiaba", state: 'CE' },
    { code: '2301257', name: "Ararendá", state: 'CE' },
    { code: '2301307', name: "Araripe", state: 'CE' },
    { code: '2301406', name: "Aratuba", state: 'CE' },
    { code: '2301505', name: "Arneiroz", state: 'CE' },
    { code: '2301604', name: "Assaré", state: 'CE' },
    { code: '2301703', name: "Aurora", state: 'CE' },
    { code: '2301802', name: "Baixio", state: 'CE' },
    { code: '2301851', name: "Banabuiú", state: 'CE' },
    { code: '2301901', name: "Barbalha", state: 'CE' },
    { code: '2301950', name: "Barreira", state: 'CE' },
    { code: '2302008', name: "Barro", state: 'CE' },
    { code: '2302057', name: "Barroquinha", state: 'CE' },
    { code: '2302107', name: "Baturité", state: 'CE' },
    { code: '2302206', name: "Beberibe", state: 'CE' },
    { code: '2302305', name: "Bela Cruz", state: 'CE' },
    { code: '2302404', name: "Boa Viagem", state: 'CE' },
    { code: '2302503', name: "Brejo Santo", state: 'CE' },
    { code: '2302602', name: "Camocim", state: 'CE' },
    { code: '2302701', name: "Campos Sales", state: 'CE' },
    { code: '2302800', name: "Canindé", state: 'CE' },
    { code: '2302909', name: "Capistrano", state: 'CE' },
    { code: '2303006', name: "Caridade", state: 'CE' },
    { code: '2303105', name: "Cariré", state: 'CE' },
    { code: '2303204', name: "Caririaçu", state: 'CE' },
    { code: '2303303', name: "Cariús", state: 'CE' },
    { code: '2303402', name: "Carnaubal", state: 'CE' },
    { code: '2303501', name: "Cascavel", state: 'CE' },
    { code: '2303600', name: "Catarina", state: 'CE' },
    { code: '2303659', name: "Catunda", state: 'CE' },
    { code: '2303709', name: "Caucaia", state: 'CE' },
    { code: '2303808', name: "Cedro", state: 'CE' },
    { code: '2303907', name: "Chaval", state: 'CE' },
    { code: '2303931', name: "Choró", state: 'CE' },
    { code: '2303956', name: "Chorozinho", state: 'CE' },
    { code: '2304004', name: "Coreaú", state: 'CE' },
    { code: '2304103', name: "Crateús", state: 'CE' },
    { code: '2304202', name: "Crato", state: 'CE' },
    { code: '2304236', name: "Croatá", state: 'CE' },
    { code: '2304251', name: "Cruz", state: 'CE' },
    { code: '2304269', name: "Deputado Irapuan Pinheiro", state: 'CE' },
    { code: '2304277', name: "Ereré", state: 'CE' },
    { code: '2304285', name: "Eusébio", state: 'CE' },
    { code: '2304301', name: "Farias Brito", state: 'CE' },
    { code: '2304350', name: "Forquilha", state: 'CE' },
    { code: '2304400', name: "Fortaleza", state: 'CE' },
    { code: '2304459', name: "Fortim", state: 'CE' },
    { code: '2304509', name: "Frecheirinha", state: 'CE' },
    { code: '2304608', name: "General Sampaio", state: 'CE' },
    { code: '2304657', name: "Graça", state: 'CE' },
    { code: '2304707', name: "Granja", state: 'CE' },
    { code: '2304806', name: "Granjeiro", state: 'CE' },
    { code: '2304905', name: "Groaíras", state: 'CE' },
    { code: '2304954', name: "Guaiúba", state: 'CE' },
    { code: '2305001', name: "Guaraciaba do Norte", state: 'CE' },
    { code: '2305100', name: "Guaramiranga", state: 'CE' },
    { code: '2305209', name: "Hidrolândia", state: 'CE' },
    { code: '2305233', name: "Horizonte", state: 'CE' },
    { code: '2305266', name: "Ibaretama", state: 'CE' },
    { code: '2305308', name: "Ibiapina", state: 'CE' },
    { code: '2305332', name: "Ibicuitinga", state: 'CE' },
    { code: '2305357', name: "Icapuí", state: 'CE' },
    { code: '2305407', name: "Icó", state: 'CE' },
    { code: '2305506', name: "Iguatu", state: 'CE' },
    { code: '2305605', name: "Independência", state: 'CE' },
    { code: '2305654', name: "Ipaporanga", state: 'CE' },
    { code: '2305704', name: "Ipaumirim", state: 'CE' },
    { code: '2305803', name: "Ipu", state: 'CE' },
    { code: '2305902', name: "Ipueiras", state: 'CE' },
    { code: '2306009', name: "Iracema", state: 'CE' },
    { code: '2306108', name: "Irauçuba", state: 'CE' },
    { code: '2306207', name: "Itaiçaba", state: 'CE' },
    { code: '2306256', name: "Itaitinga", state: 'CE' },
    { code: '2306306', name: "Itapajé", state: 'CE' },
    { code: '2306405', name: "Itapipoca", state: 'CE' },
    { code: '2306504', name: "Itapiúna", state: 'CE' },
    { code: '2306553', name: "Itarema", state: 'CE' },
    { code: '2306603', name: "Itatira", state: 'CE' },
    { code: '2306702', name: "Jaguaretama", state: 'CE' },
    { code: '2306801', name: "Jaguaribara", state: 'CE' },
    { code: '2306900', name: "Jaguaribe", state: 'CE' },
    { code: '2307007', name: "Jaguaruana", state: 'CE' },
    { code: '2307106', name: "Jardim", state: 'CE' },
    { code: '2307205', name: "Jati", state: 'CE' },
    { code: '2307254', name: "Jijoca de Jericoacoara", state: 'CE' },
    { code: '2307304', name: "Juazeiro do Norte", state: 'CE' },
    { code: '2307403', name: "Jucás", state: 'CE' },
    { code: '2307502', name: "Lavras da Mangabeira", state: 'CE' },
    { code: '2307601', name: "Limoeiro do Norte", state: 'CE' },
    { code: '2307635', name: "Madalena", state: 'CE' },
    { code: '2307650', name: "Maracanaú", state: 'CE' },
    { code: '2307700', name: "Maranguape", state: 'CE' },
    { code: '2307809', name: "Marco", state: 'CE' },
    { code: '2307908', name: "Martinópole", state: 'CE' },
    { code: '2308005', name: "Massapê", state: 'CE' },
    { code: '2308104', name: "Mauriti", state: 'CE' },
    { code: '2308203', name: "Meruoca", state: 'CE' },
    { code: '2308302', name: "Milagres", state: 'CE' },
    { code: '2308351', name: "Milhã", state: 'CE' },
    { code: '2308377', name: "Miraíma", state: 'CE' },
    { code: '2308401', name: "Missão Velha", state: 'CE' },
    { code: '2308500', name: "Mombaça", state: 'CE' },
    { code: '2308609', name: "Monsenhor Tabosa", state: 'CE' },
    { code: '2308708', name: "Morada Nova", state: 'CE' },
    { code: '2308807', name: "Moraújo", state: 'CE' },
    { code: '2308906', name: "Morrinhos", state: 'CE' },
    { code: '2309003', name: "Mucambo", state: 'CE' },
    { code: '2309102', name: "Mulungu", state: 'CE' },
    { code: '2309201', name: "Nova Olinda", state: 'CE' },
    { code: '2309300', name: "Nova Russas", state: 'CE' },
    { code: '2309409', name: "Novo Oriente", state: 'CE' },
    { code: '2309458', name: "Ocara", state: 'CE' },
    { code: '2309508', name: "Orós", state: 'CE' },
    { code: '2309607', name: "Pacajus", state: 'CE' },
    { code: '2309706', name: "Pacatuba", state: 'CE' },
    { code: '2309805', name: "Pacoti", state: 'CE' },
    { code: '2309904', name: "Pacujá", state: 'CE' },
    { code: '2310001', name: "Palhano", state: 'CE' },
    { code: '2310100', name: "Palmácia", state: 'CE' },
    { code: '2310209', name: "Paracuru", state: 'CE' },
    { code: '2310258', name: "Paraipaba", state: 'CE' },
    { code: '2310308', name: "Parambu", state: 'CE' },
    { code: '2310407', name: "Paramoti", state: 'CE' },
    { code: '2310506', name: "Pedra Branca", state: 'CE' },
    { code: '2310605', name: "Penaforte", state: 'CE' },
    { code: '2310704', name: "Pentecoste", state: 'CE' },
    { code: '2310803', name: "Pereiro", state: 'CE' },
    { code: '2310852', name: "Pindoretama", state: 'CE' },
    { code: '2310902', name: "Piquet Carneiro", state: 'CE' },
    { code: '2310951', name: "Pires Ferreira", state: 'CE' },
    { code: '2311009', name: "Poranga", state: 'CE' },
    { code: '2311108', name: "Porteiras", state: 'CE' },
    { code: '2311207', name: "Potengi", state: 'CE' },
    { code: '2311231', name: "Potiretama", state: 'CE' },
    { code: '2311264', name: "Quiterianópolis", state: 'CE' },
    { code: '2311306', name: "Quixadá", state: 'CE' },
    { code: '2311355', name: "Quixelô", state: 'CE' },
    { code: '2311405', name: "Quixeramobim", state: 'CE' },
    { code: '2311504', name: "Quixeré", state: 'CE' },
    { code: '2311603', name: "Redenção", state: 'CE' },
    { code: '2311702', name: "Reriutaba", state: 'CE' },
    { code: '2311801', name: "Russas", state: 'CE' },
    { code: '2311900', name: "Saboeiro", state: 'CE' },
    { code: '2311959', name: "Salitre", state: 'CE' },
    { code: '2312205', name: "Santa Quitéria", state: 'CE' },
    { code: '2312007', name: "Santana do Acaraú", state: 'CE' },
    { code: '2312106', name: "Santana do Cariri", state: 'CE' },
    { code: '2312304', name: "São Benedito", state: 'CE' },
    { code: '2312403', name: "São Gonçalo do Amarante", state: 'CE' },
    { code: '2312502', name: "São João do Jaguaribe", state: 'CE' },
    { code: '2312601', name: "São Luís do Curu", state: 'CE' },
    { code: '2312700', name: "Senador Pompeu", state: 'CE' },
    { code: '2312809', name: "Senador Sá", state: 'CE' },
    { code: '2312908', name: "Sobral", state: 'CE' },
    { code: '2313005', name: "Solonópole", state: 'CE' },
    { code: '2313104', name: "Tabuleiro do Norte", state: 'CE' },
    { code: '2313203', name: "Tamboril", state: 'CE' },
    { code: '2313252', name: "Tarrafas", state: 'CE' },
    { code: '2313302', name: "Tauá", state: 'CE' },
    { code: '2313351', name: "Tejuçuoca", state: 'CE' },
    { code: '2313401', name: "Tianguá", state: 'CE' },
    { code: '2313500', name: "Trairi", state: 'CE' },
    { code: '2313559', name: "Tururu", state: 'CE' },
    { code: '2313609', name: "Ubajara", state: 'CE' },
    { code: '2313708', name: "Umari", state: 'CE' },
    { code: '2313757', name: "Umirim", state: 'CE' },
    { code: '2313807', name: "Uruburetama", state: 'CE' },
    { code: '2313906', name: "Uruoca", state: 'CE' },
    { code: '2313955', name: "Varjota", state: 'CE' },
    { code: '2314003', name: "Várzea Alegre", state: 'CE' },
    { code: '2314102', name: "Viçosa do Ceará", state: 'CE' }
  ],

  // DISTRITO FEDERAL (DF) - 1 municípios
  DF: [
    { code: '5300108', name: "Brasília", state: 'DF' }
  ],

  // ESPÍRITO SANTO (ES) - 78 municípios
  ES: [
    { code: '3200102', name: "Afonso Cláudio", state: 'ES' },
    { code: '3200169', name: "Água Doce do Norte", state: 'ES' },
    { code: '3200136', name: "Águia Branca", state: 'ES' },
    { code: '3200201', name: "Alegre", state: 'ES' },
    { code: '3200300', name: "Alfredo Chaves", state: 'ES' },
    { code: '3200359', name: "Alto Rio Novo", state: 'ES' },
    { code: '3200409', name: "Anchieta", state: 'ES' },
    { code: '3200508', name: "Apiacá", state: 'ES' },
    { code: '3200607', name: "Aracruz", state: 'ES' },
    { code: '3200706', name: "Atílio Vivácqua", state: 'ES' },
    { code: '3200805', name: "Baixo Guandu", state: 'ES' },
    { code: '3200904', name: "Barra de São Francisco", state: 'ES' },
    { code: '3201001', name: "Boa Esperança", state: 'ES' },
    { code: '3201100', name: "Bom Jesus do Norte", state: 'ES' },
    { code: '3201159', name: "Brejetuba", state: 'ES' },
    { code: '3201209', name: "Cachoeiro de Itapemirim", state: 'ES' },
    { code: '3201308', name: "Cariacica", state: 'ES' },
    { code: '3201407', name: "Castelo", state: 'ES' },
    { code: '3201506', name: "Colatina", state: 'ES' },
    { code: '3201605', name: "Conceição da Barra", state: 'ES' },
    { code: '3201704', name: "Conceição do Castelo", state: 'ES' },
    { code: '3201803', name: "Divino de São Lourenço", state: 'ES' },
    { code: '3201902', name: "Domingos Martins", state: 'ES' },
    { code: '3202009', name: "Dores do Rio Preto", state: 'ES' },
    { code: '3202108', name: "Ecoporanga", state: 'ES' },
    { code: '3202207', name: "Fundão", state: 'ES' },
    { code: '3202256', name: "Governador Lindenberg", state: 'ES' },
    { code: '3202306', name: "Guaçuí", state: 'ES' },
    { code: '3202405', name: "Guarapari", state: 'ES' },
    { code: '3202454', name: "Ibatiba", state: 'ES' },
    { code: '3202504', name: "Ibiraçu", state: 'ES' },
    { code: '3202553', name: "Ibitirama", state: 'ES' },
    { code: '3202603', name: "Iconha", state: 'ES' },
    { code: '3202652', name: "Irupi", state: 'ES' },
    { code: '3202702', name: "Itaguaçu", state: 'ES' },
    { code: '3202801', name: "Itapemirim", state: 'ES' },
    { code: '3202900', name: "Itarana", state: 'ES' },
    { code: '3203007', name: "Iúna", state: 'ES' },
    { code: '3203056', name: "Jaguaré", state: 'ES' },
    { code: '3203106', name: "Jerônimo Monteiro", state: 'ES' },
    { code: '3203130', name: "João Neiva", state: 'ES' },
    { code: '3203163', name: "Laranja da Terra", state: 'ES' },
    { code: '3203205', name: "Linhares", state: 'ES' },
    { code: '3203304', name: "Mantenópolis", state: 'ES' },
    { code: '3203320', name: "Marataízes", state: 'ES' },
    { code: '3203346', name: "Marechal Floriano", state: 'ES' },
    { code: '3203353', name: "Marilândia", state: 'ES' },
    { code: '3203403', name: "Mimoso do Sul", state: 'ES' },
    { code: '3203502', name: "Montanha", state: 'ES' },
    { code: '3203601', name: "Mucurici", state: 'ES' },
    { code: '3203700', name: "Muniz Freire", state: 'ES' },
    { code: '3203809', name: "Muqui", state: 'ES' },
    { code: '3203908', name: "Nova Venécia", state: 'ES' },
    { code: '3204005', name: "Pancas", state: 'ES' },
    { code: '3204054', name: "Pedro Canário", state: 'ES' },
    { code: '3204104', name: "Pinheiros", state: 'ES' },
    { code: '3204203', name: "Piúma", state: 'ES' },
    { code: '3204252', name: "Ponto Belo", state: 'ES' },
    { code: '3204302', name: "Presidente Kennedy", state: 'ES' },
    { code: '3204351', name: "Rio Bananal", state: 'ES' },
    { code: '3204401', name: "Rio Novo do Sul", state: 'ES' },
    { code: '3204500', name: "Santa Leopoldina", state: 'ES' },
    { code: '3204559', name: "Santa Maria de Jetibá", state: 'ES' },
    { code: '3204609', name: "Santa Teresa", state: 'ES' },
    { code: '3204658', name: "São Domingos do Norte", state: 'ES' },
    { code: '3204708', name: "São Gabriel da Palha", state: 'ES' },
    { code: '3204807', name: "São José do Calçado", state: 'ES' },
    { code: '3204906', name: "São Mateus", state: 'ES' },
    { code: '3204955', name: "São Roque do Canaã", state: 'ES' },
    { code: '3205002', name: "Serra", state: 'ES' },
    { code: '3205010', name: "Sooretama", state: 'ES' },
    { code: '3205036', name: "Vargem Alta", state: 'ES' },
    { code: '3205069', name: "Venda Nova do Imigrante", state: 'ES' },
    { code: '3205101', name: "Viana", state: 'ES' },
    { code: '3205150', name: "Vila Pavão", state: 'ES' },
    { code: '3205176', name: "Vila Valério", state: 'ES' },
    { code: '3205200', name: "Vila Velha", state: 'ES' },
    { code: '3205309', name: "Vitória", state: 'ES' }
  ],

  // GOIÁS (GO) - 246 municípios
  GO: [
    { code: '5200050', name: "Abadia de Goiás", state: 'GO' },
    { code: '5200100', name: "Abadiânia", state: 'GO' },
    { code: '5200134', name: "Acreúna", state: 'GO' },
    { code: '5200159', name: "Adelândia", state: 'GO' },
    { code: '5200175', name: "Água Fria de Goiás", state: 'GO' },
    { code: '5200209', name: "Água Limpa", state: 'GO' },
    { code: '5200258', name: "Águas Lindas de Goiás", state: 'GO' },
    { code: '5200308', name: "Alexânia", state: 'GO' },
    { code: '5200506', name: "Aloândia", state: 'GO' },
    { code: '5200555', name: "Alto Horizonte", state: 'GO' },
    { code: '5200605', name: "Alto Paraíso de Goiás", state: 'GO' },
    { code: '5200803', name: "Alvorada do Norte", state: 'GO' },
    { code: '5200829', name: "Amaralina", state: 'GO' },
    { code: '5200852', name: "Americano do Brasil", state: 'GO' },
    { code: '5200902', name: "Amorinópolis", state: 'GO' },
    { code: '5201108', name: "Anápolis", state: 'GO' },
    { code: '5201207', name: "Anhanguera", state: 'GO' },
    { code: '5201306', name: "Anicuns", state: 'GO' },
    { code: '5201405', name: "Aparecida de Goiânia", state: 'GO' },
    { code: '5201454', name: "Aparecida do Rio Doce", state: 'GO' },
    { code: '5201504', name: "Aporé", state: 'GO' },
    { code: '5201603', name: "Araçu", state: 'GO' },
    { code: '5201702', name: "Aragarças", state: 'GO' },
    { code: '5201801', name: "Aragoiânia", state: 'GO' },
    { code: '5202155', name: "Araguapaz", state: 'GO' },
    { code: '5202353', name: "Arenópolis", state: 'GO' },
    { code: '5202502', name: "Aruanã", state: 'GO' },
    { code: '5202601', name: "Aurilândia", state: 'GO' },
    { code: '5202809', name: "Avelinópolis", state: 'GO' },
    { code: '5203104', name: "Baliza", state: 'GO' },
    { code: '5203203', name: "Barro Alto", state: 'GO' },
    { code: '5203302', name: "Bela Vista de Goiás", state: 'GO' },
    { code: '5203401', name: "Bom Jardim de Goiás", state: 'GO' },
    { code: '5203500', name: "Bom Jesus de Goiás", state: 'GO' },
    { code: '5203559', name: "Bonfinópolis", state: 'GO' },
    { code: '5203575', name: "Bonópolis", state: 'GO' },
    { code: '5203609', name: "Brazabrantes", state: 'GO' },
    { code: '5203807', name: "Britânia", state: 'GO' },
    { code: '5203906', name: "Buriti Alegre", state: 'GO' },
    { code: '5203939', name: "Buriti de Goiás", state: 'GO' },
    { code: '5203962', name: "Buritinópolis", state: 'GO' },
    { code: '5204003', name: "Cabeceiras", state: 'GO' },
    { code: '5204102', name: "Cachoeira Alta", state: 'GO' },
    { code: '5204201', name: "Cachoeira de Goiás", state: 'GO' },
    { code: '5204250', name: "Cachoeira Dourada", state: 'GO' },
    { code: '5204300', name: "Caçu", state: 'GO' },
    { code: '5204409', name: "Caiapônia", state: 'GO' },
    { code: '5204508', name: "Caldas Novas", state: 'GO' },
    { code: '5204557', name: "Caldazinha", state: 'GO' },
    { code: '5204607', name: "Campestre de Goiás", state: 'GO' },
    { code: '5204656', name: "Campinaçu", state: 'GO' },
    { code: '5204706', name: "Campinorte", state: 'GO' },
    { code: '5204805', name: "Campo Alegre de Goiás", state: 'GO' },
    { code: '5204854', name: "Campo Limpo de Goiás", state: 'GO' },
    { code: '5204904', name: "Campos Belos", state: 'GO' },
    { code: '5204953', name: "Campos Verdes", state: 'GO' },
    { code: '5205000', name: "Carmo do Rio Verde", state: 'GO' },
    { code: '5205059', name: "Castelândia", state: 'GO' },
    { code: '5205109', name: "Catalão", state: 'GO' },
    { code: '5205208', name: "Caturaí", state: 'GO' },
    { code: '5205307', name: "Cavalcante", state: 'GO' },
    { code: '5205406', name: "Ceres", state: 'GO' },
    { code: '5205455', name: "Cezarina", state: 'GO' },
    { code: '5205471', name: "Chapadão do Céu", state: 'GO' },
    { code: '5205497', name: "Cidade Ocidental", state: 'GO' },
    { code: '5205513', name: "Cocalzinho de Goiás", state: 'GO' },
    { code: '5205521', name: "Colinas do Sul", state: 'GO' },
    { code: '5205703', name: "Córrego do Ouro", state: 'GO' },
    { code: '5205802', name: "Corumbá de Goiás", state: 'GO' },
    { code: '5205901', name: "Corumbaíba", state: 'GO' },
    { code: '5206206', name: "Cristalina", state: 'GO' },
    { code: '5206305', name: "Cristianópolis", state: 'GO' },
    { code: '5206404', name: "Crixás", state: 'GO' },
    { code: '5206503', name: "Cromínia", state: 'GO' },
    { code: '5206602', name: "Cumari", state: 'GO' },
    { code: '5206701', name: "Damianópolis", state: 'GO' },
    { code: '5206800', name: "Damolândia", state: 'GO' },
    { code: '5206909', name: "Davinópolis", state: 'GO' },
    { code: '5207105', name: "Diorama", state: 'GO' },
    { code: '5208301', name: "Divinópolis de Goiás", state: 'GO' },
    { code: '5207253', name: "Doverlândia", state: 'GO' },
    { code: '5207352', name: "Edealina", state: 'GO' },
    { code: '5207402', name: "Edéia", state: 'GO' },
    { code: '5207501', name: "Estrela do Norte", state: 'GO' },
    { code: '5207535', name: "Faina", state: 'GO' },
    { code: '5207600', name: "Fazenda Nova", state: 'GO' },
    { code: '5207808', name: "Firminópolis", state: 'GO' },
    { code: '5207907', name: "Flores de Goiás", state: 'GO' },
    { code: '5208004', name: "Formosa", state: 'GO' },
    { code: '5208103', name: "Formoso", state: 'GO' },
    { code: '5208152', name: "Gameleira de Goiás", state: 'GO' },
    { code: '5208400', name: "Goianápolis", state: 'GO' },
    { code: '5208509', name: "Goiandira", state: 'GO' },
    { code: '5208608', name: "Goianésia", state: 'GO' },
    { code: '5208707', name: "Goiânia", state: 'GO' },
    { code: '5208806', name: "Goianira", state: 'GO' },
    { code: '5208905', name: "Goiás", state: 'GO' },
    { code: '5209101', name: "Goiatuba", state: 'GO' },
    { code: '5209150', name: "Gouvelândia", state: 'GO' },
    { code: '5209200', name: "Guapó", state: 'GO' },
    { code: '5209291', name: "Guaraíta", state: 'GO' },
    { code: '5209408', name: "Guarani de Goiás", state: 'GO' },
    { code: '5209457', name: "Guarinos", state: 'GO' },
    { code: '5209606', name: "Heitoraí", state: 'GO' },
    { code: '5209705', name: "Hidrolândia", state: 'GO' },
    { code: '5209804', name: "Hidrolina", state: 'GO' },
    { code: '5209903', name: "Iaciara", state: 'GO' },
    { code: '5209937', name: "Inaciolândia", state: 'GO' },
    { code: '5209952', name: "Indiara", state: 'GO' },
    { code: '5210000', name: "Inhumas", state: 'GO' },
    { code: '5210109', name: "Ipameri", state: 'GO' },
    { code: '5210158', name: "Ipiranga de Goiás", state: 'GO' },
    { code: '5210208', name: "Iporá", state: 'GO' },
    { code: '5210307', name: "Israelândia", state: 'GO' },
    { code: '5210406', name: "Itaberaí", state: 'GO' },
    { code: '5210562', name: "Itaguari", state: 'GO' },
    { code: '5210604', name: "Itaguaru", state: 'GO' },
    { code: '5210802', name: "Itajá", state: 'GO' },
    { code: '5210901', name: "Itapaci", state: 'GO' },
    { code: '5211008', name: "Itapirapuã", state: 'GO' },
    { code: '5211206', name: "Itapuranga", state: 'GO' },
    { code: '5211305', name: "Itarumã", state: 'GO' },
    { code: '5211404', name: "Itauçu", state: 'GO' },
    { code: '5211503', name: "Itumbiara", state: 'GO' },
    { code: '5211602', name: "Ivolândia", state: 'GO' },
    { code: '5211701', name: "Jandaia", state: 'GO' },
    { code: '5211800', name: "Jaraguá", state: 'GO' },
    { code: '5211909', name: "Jataí", state: 'GO' },
    { code: '5212006', name: "Jaupaci", state: 'GO' },
    { code: '5212055', name: "Jesúpolis", state: 'GO' },
    { code: '5212105', name: "Joviânia", state: 'GO' },
    { code: '5212204', name: "Jussara", state: 'GO' },
    { code: '5212253', name: "Lagoa Santa", state: 'GO' },
    { code: '5212303', name: "Leopoldo de Bulhões", state: 'GO' },
    { code: '5212501', name: "Luziânia", state: 'GO' },
    { code: '5212600', name: "Mairipotaba", state: 'GO' },
    { code: '5212709', name: "Mambaí", state: 'GO' },
    { code: '5212808', name: "Mara Rosa", state: 'GO' },
    { code: '5212907', name: "Marzagão", state: 'GO' },
    { code: '5212956', name: "Matrinchã", state: 'GO' },
    { code: '5213004', name: "Maurilândia", state: 'GO' },
    { code: '5213053', name: "Mimoso de Goiás", state: 'GO' },
    { code: '5213087', name: "Minaçu", state: 'GO' },
    { code: '5213103', name: "Mineiros", state: 'GO' },
    { code: '5213400', name: "Moiporá", state: 'GO' },
    { code: '5213509', name: "Monte Alegre de Goiás", state: 'GO' },
    { code: '5213707', name: "Montes Claros de Goiás", state: 'GO' },
    { code: '5213756', name: "Montividiu", state: 'GO' },
    { code: '5213772', name: "Montividiu do Norte", state: 'GO' },
    { code: '5213806', name: "Morrinhos", state: 'GO' },
    { code: '5213855', name: "Morro Agudo de Goiás", state: 'GO' },
    { code: '5213905', name: "Mossâmedes", state: 'GO' },
    { code: '5214002', name: "Mozarlândia", state: 'GO' },
    { code: '5214051', name: "Mundo Novo", state: 'GO' },
    { code: '5214101', name: "Mutunópolis", state: 'GO' },
    { code: '5214408', name: "Nazário", state: 'GO' },
    { code: '5214507', name: "Nerópolis", state: 'GO' },
    { code: '5214606', name: "Niquelândia", state: 'GO' },
    { code: '5214705', name: "Nova América", state: 'GO' },
    { code: '5214804', name: "Nova Aurora", state: 'GO' },
    { code: '5214838', name: "Nova Crixás", state: 'GO' },
    { code: '5214861', name: "Nova Glória", state: 'GO' },
    { code: '5214879', name: "Nova Iguaçu de Goiás", state: 'GO' },
    { code: '5214903', name: "Nova Roma", state: 'GO' },
    { code: '5215009', name: "Nova Veneza", state: 'GO' },
    { code: '5215207', name: "Novo Brasil", state: 'GO' },
    { code: '5215231', name: "Novo Gama", state: 'GO' },
    { code: '5215256', name: "Novo Planalto", state: 'GO' },
    { code: '5215306', name: "Orizona", state: 'GO' },
    { code: '5215405', name: "Ouro Verde de Goiás", state: 'GO' },
    { code: '5215504', name: "Ouvidor", state: 'GO' },
    { code: '5215603', name: "Padre Bernardo", state: 'GO' },
    { code: '5215652', name: "Palestina de Goiás", state: 'GO' },
    { code: '5215702', name: "Palmeiras de Goiás", state: 'GO' },
    { code: '5215801', name: "Palmelo", state: 'GO' },
    { code: '5215900', name: "Palminópolis", state: 'GO' },
    { code: '5216007', name: "Panamá", state: 'GO' },
    { code: '5216304', name: "Paranaiguara", state: 'GO' },
    { code: '5216403', name: "Paraúna", state: 'GO' },
    { code: '5216452', name: "Perolândia", state: 'GO' },
    { code: '5216809', name: "Petrolina de Goiás", state: 'GO' },
    { code: '5216908', name: "Pilar de Goiás", state: 'GO' },
    { code: '5217104', name: "Piracanjuba", state: 'GO' },
    { code: '5217203', name: "Piranhas", state: 'GO' },
    { code: '5217302', name: "Pirenópolis", state: 'GO' },
    { code: '5217401', name: "Pires do Rio", state: 'GO' },
    { code: '5217609', name: "Planaltina", state: 'GO' },
    { code: '5217708', name: "Pontalina", state: 'GO' },
    { code: '5218003', name: "Porangatu", state: 'GO' },
    { code: '5218052', name: "Porteirão", state: 'GO' },
    { code: '5218102', name: "Portelândia", state: 'GO' },
    { code: '5218300', name: "Posse", state: 'GO' },
    { code: '5218391', name: "Professor Jamil", state: 'GO' },
    { code: '5218508', name: "Quirinópolis", state: 'GO' },
    { code: '5218607', name: "Rialma", state: 'GO' },
    { code: '5218706', name: "Rianápolis", state: 'GO' },
    { code: '5218789', name: "Rio Quente", state: 'GO' },
    { code: '5218805', name: "Rio Verde", state: 'GO' },
    { code: '5218904', name: "Rubiataba", state: 'GO' },
    { code: '5219001', name: "Sanclerlândia", state: 'GO' },
    { code: '5219100', name: "Santa Bárbara de Goiás", state: 'GO' },
    { code: '5219209', name: "Santa Cruz de Goiás", state: 'GO' },
    { code: '5219258', name: "Santa Fé de Goiás", state: 'GO' },
    { code: '5219308', name: "Santa Helena de Goiás", state: 'GO' },
    { code: '5219357', name: "Santa Isabel", state: 'GO' },
    { code: '5219407', name: "Santa Rita do Araguaia", state: 'GO' },
    { code: '5219456', name: "Santa Rita do Novo Destino", state: 'GO' },
    { code: '5219506', name: "Santa Rosa de Goiás", state: 'GO' },
    { code: '5219605', name: "Santa Tereza de Goiás", state: 'GO' },
    { code: '5219704', name: "Santa Terezinha de Goiás", state: 'GO' },
    { code: '5219712', name: "Santo Antônio da Barra", state: 'GO' },
    { code: '5219738', name: "Santo Antônio de Goiás", state: 'GO' },
    { code: '5219753', name: "Santo Antônio do Descoberto", state: 'GO' },
    { code: '5219803', name: "São Domingos", state: 'GO' },
    { code: '5219902', name: "São Francisco de Goiás", state: 'GO' },
    { code: '5220009', name: "São João d'Aliança", state: 'GO' },
    { code: '5220058', name: "São João da Paraúna", state: 'GO' },
    { code: '5220108', name: "São Luís de Montes Belos", state: 'GO' },
    { code: '5220157', name: "São Luiz do Norte", state: 'GO' },
    { code: '5220207', name: "São Miguel do Araguaia", state: 'GO' },
    { code: '5220264', name: "São Miguel do Passa Quatro", state: 'GO' },
    { code: '5220280', name: "São Patrício", state: 'GO' },
    { code: '5220405', name: "São Simão", state: 'GO' },
    { code: '5220454', name: "Senador Canedo", state: 'GO' },
    { code: '5220504', name: "Serranópolis", state: 'GO' },
    { code: '5220603', name: "Silvânia", state: 'GO' },
    { code: '5220686', name: "Simolândia", state: 'GO' },
    { code: '5220702', name: "Sítio d'Abadia", state: 'GO' },
    { code: '5221007', name: "Taquaral de Goiás", state: 'GO' },
    { code: '5221080', name: "Teresina de Goiás", state: 'GO' },
    { code: '5221197', name: "Terezópolis de Goiás", state: 'GO' },
    { code: '5221304', name: "Três Ranchos", state: 'GO' },
    { code: '5221403', name: "Trindade", state: 'GO' },
    { code: '5221452', name: "Trombas", state: 'GO' },
    { code: '5221502', name: "Turvânia", state: 'GO' },
    { code: '5221551', name: "Turvelândia", state: 'GO' },
    { code: '5221577', name: "Uirapuru", state: 'GO' },
    { code: '5221601', name: "Uruaçu", state: 'GO' },
    { code: '5221700', name: "Uruana", state: 'GO' },
    { code: '5221809', name: "Urutaí", state: 'GO' },
    { code: '5221858', name: "Valparaíso de Goiás", state: 'GO' },
    { code: '5221908', name: "Varjão", state: 'GO' },
    { code: '5222005', name: "Vianópolis", state: 'GO' },
    { code: '5222054', name: "Vicentinópolis", state: 'GO' },
    { code: '5222203', name: "Vila Boa", state: 'GO' },
    { code: '5222302', name: "Vila Propício", state: 'GO' }
  ],

  // MARANHÃO (MA) - 217 municípios
  MA: [
    { code: '2100055', name: "Açailândia", state: 'MA' },
    { code: '2100105', name: "Afonso Cunha", state: 'MA' },
    { code: '2100154', name: "Água Doce do Maranhão", state: 'MA' },
    { code: '2100204', name: "Alcântara", state: 'MA' },
    { code: '2100303', name: "Aldeias Altas", state: 'MA' },
    { code: '2100402', name: "Altamira do Maranhão", state: 'MA' },
    { code: '2100436', name: "Alto Alegre do Maranhão", state: 'MA' },
    { code: '2100477', name: "Alto Alegre do Pindaré", state: 'MA' },
    { code: '2100501', name: "Alto Parnaíba", state: 'MA' },
    { code: '2100550', name: "Amapá do Maranhão", state: 'MA' },
    { code: '2100600', name: "Amarante do Maranhão", state: 'MA' },
    { code: '2100709', name: "Anajatuba", state: 'MA' },
    { code: '2100808', name: "Anapurus", state: 'MA' },
    { code: '2100832', name: "Apicum-Açu", state: 'MA' },
    { code: '2100873', name: "Araguanã", state: 'MA' },
    { code: '2100907', name: "Araioses", state: 'MA' },
    { code: '2100956', name: "Arame", state: 'MA' },
    { code: '2101004', name: "Arari", state: 'MA' },
    { code: '2101103', name: "Axixá", state: 'MA' },
    { code: '2101202', name: "Bacabal", state: 'MA' },
    { code: '2101251', name: "Bacabeira", state: 'MA' },
    { code: '2101301', name: "Bacuri", state: 'MA' },
    { code: '2101350', name: "Bacurituba", state: 'MA' },
    { code: '2101400', name: "Balsas", state: 'MA' },
    { code: '2101509', name: "Barão de Grajaú", state: 'MA' },
    { code: '2101608', name: "Barra do Corda", state: 'MA' },
    { code: '2101707', name: "Barreirinhas", state: 'MA' },
    { code: '2101772', name: "Bela Vista do Maranhão", state: 'MA' },
    { code: '2101731', name: "Belágua", state: 'MA' },
    { code: '2101806', name: "Benedito Leite", state: 'MA' },
    { code: '2101905', name: "Bequimão", state: 'MA' },
    { code: '2101939', name: "Bernardo do Mearim", state: 'MA' },
    { code: '2101970', name: "Boa Vista do Gurupi", state: 'MA' },
    { code: '2102002', name: "Bom Jardim", state: 'MA' },
    { code: '2102036', name: "Bom Jesus das Selvas", state: 'MA' },
    { code: '2102077', name: "Bom Lugar", state: 'MA' },
    { code: '2102101', name: "Brejo", state: 'MA' },
    { code: '2102150', name: "Brejo de Areia", state: 'MA' },
    { code: '2102200', name: "Buriti", state: 'MA' },
    { code: '2102309', name: "Buriti Bravo", state: 'MA' },
    { code: '2102325', name: "Buriticupu", state: 'MA' },
    { code: '2102358', name: "Buritirana", state: 'MA' },
    { code: '2102374', name: "Cachoeira Grande", state: 'MA' },
    { code: '2102408', name: "Cajapió", state: 'MA' },
    { code: '2102507', name: "Cajari", state: 'MA' },
    { code: '2102556', name: "Campestre do Maranhão", state: 'MA' },
    { code: '2102606', name: "Cândido Mendes", state: 'MA' },
    { code: '2102705', name: "Cantanhede", state: 'MA' },
    { code: '2102754', name: "Capinzal do Norte", state: 'MA' },
    { code: '2102804', name: "Carolina", state: 'MA' },
    { code: '2102903', name: "Carutapera", state: 'MA' },
    { code: '2103000', name: "Caxias", state: 'MA' },
    { code: '2103109', name: "Cedral", state: 'MA' },
    { code: '2103125', name: "Central do Maranhão", state: 'MA' },
    { code: '2103158', name: "Centro do Guilherme", state: 'MA' },
    { code: '2103174', name: "Centro Novo do Maranhão", state: 'MA' },
    { code: '2103208', name: "Chapadinha", state: 'MA' },
    { code: '2103257', name: "Cidelândia", state: 'MA' },
    { code: '2103307', name: "Codó", state: 'MA' },
    { code: '2103406', name: "Coelho Neto", state: 'MA' },
    { code: '2103505', name: "Colinas", state: 'MA' },
    { code: '2103554', name: "Conceição do Lago-Açu", state: 'MA' },
    { code: '2103604', name: "Coroatá", state: 'MA' },
    { code: '2103703', name: "Cururupu", state: 'MA' },
    { code: '2103752', name: "Davinópolis", state: 'MA' },
    { code: '2103802', name: "Dom Pedro", state: 'MA' },
    { code: '2103901', name: "Duque Bacelar", state: 'MA' },
    { code: '2104008', name: "Esperantinópolis", state: 'MA' },
    { code: '2104057', name: "Estreito", state: 'MA' },
    { code: '2104073', name: "Feira Nova do Maranhão", state: 'MA' },
    { code: '2104081', name: "Fernando Falcão", state: 'MA' },
    { code: '2104099', name: "Formosa da Serra Negra", state: 'MA' },
    { code: '2104107', name: "Fortaleza dos Nogueiras", state: 'MA' },
    { code: '2104206', name: "Fortuna", state: 'MA' },
    { code: '2104305', name: "Godofredo Viana", state: 'MA' },
    { code: '2104404', name: "Gonçalves Dias", state: 'MA' },
    { code: '2104503', name: "Governador Archer", state: 'MA' },
    { code: '2104552', name: "Governador Edison Lobão", state: 'MA' },
    { code: '2104602', name: "Governador Eugênio Barros", state: 'MA' },
    { code: '2104628', name: "Governador Luiz Rocha", state: 'MA' },
    { code: '2104651', name: "Governador Newton Bello", state: 'MA' },
    { code: '2104677', name: "Governador Nunes Freire", state: 'MA' },
    { code: '2104701', name: "Graça Aranha", state: 'MA' },
    { code: '2104800', name: "Grajaú", state: 'MA' },
    { code: '2104909', name: "Guimarães", state: 'MA' },
    { code: '2105005', name: "Humberto de Campos", state: 'MA' },
    { code: '2105104', name: "Icatu", state: 'MA' },
    { code: '2105153', name: "Igarapé do Meio", state: 'MA' },
    { code: '2105203', name: "Igarapé Grande", state: 'MA' },
    { code: '2105302', name: "Imperatriz", state: 'MA' },
    { code: '2105351', name: "Itaipava do Grajaú", state: 'MA' },
    { code: '2105401', name: "Itapecuru Mirim", state: 'MA' },
    { code: '2105427', name: "Itinga do Maranhão", state: 'MA' },
    { code: '2105450', name: "Jatobá", state: 'MA' },
    { code: '2105476', name: "Jenipapo dos Vieiras", state: 'MA' },
    { code: '2105500', name: "João Lisboa", state: 'MA' },
    { code: '2105609', name: "Joselândia", state: 'MA' },
    { code: '2105658', name: "Junco do Maranhão", state: 'MA' },
    { code: '2105708', name: "Lago da Pedra", state: 'MA' },
    { code: '2105807', name: "Lago do Junco", state: 'MA' },
    { code: '2105948', name: "Lago dos Rodrigues", state: 'MA' },
    { code: '2105906', name: "Lago Verde", state: 'MA' },
    { code: '2105922', name: "Lagoa do Mato", state: 'MA' },
    { code: '2105963', name: "Lagoa Grande do Maranhão", state: 'MA' },
    { code: '2105989', name: "Lajeado Novo", state: 'MA' },
    { code: '2106003', name: "Lima Campos", state: 'MA' },
    { code: '2106102', name: "Loreto", state: 'MA' },
    { code: '2106201', name: "Luís Domingues", state: 'MA' },
    { code: '2106300', name: "Magalhães de Almeida", state: 'MA' },
    { code: '2106326', name: "Maracaçumé", state: 'MA' },
    { code: '2106359', name: "Marajá do Sena", state: 'MA' },
    { code: '2106375', name: "Maranhãozinho", state: 'MA' },
    { code: '2106409', name: "Mata Roma", state: 'MA' },
    { code: '2106508', name: "Matinha", state: 'MA' },
    { code: '2106607', name: "Matões", state: 'MA' },
    { code: '2106631', name: "Matões do Norte", state: 'MA' },
    { code: '2106672', name: "Milagres do Maranhão", state: 'MA' },
    { code: '2106706', name: "Mirador", state: 'MA' },
    { code: '2106755', name: "Miranda do Norte", state: 'MA' },
    { code: '2106805', name: "Mirinzal", state: 'MA' },
    { code: '2106904', name: "Monção", state: 'MA' },
    { code: '2107001', name: "Montes Altos", state: 'MA' },
    { code: '2107100', name: "Morros", state: 'MA' },
    { code: '2107209', name: "Nina Rodrigues", state: 'MA' },
    { code: '2107258', name: "Nova Colinas", state: 'MA' },
    { code: '2107308', name: "Nova Iorque", state: 'MA' },
    { code: '2107357', name: "Nova Olinda do Maranhão", state: 'MA' },
    { code: '2107407', name: "Olho d'Água das Cunhãs", state: 'MA' },
    { code: '2107456', name: "Olinda Nova do Maranhão", state: 'MA' },
    { code: '2107506', name: "Paço do Lumiar", state: 'MA' },
    { code: '2107605', name: "Palmeirândia", state: 'MA' },
    { code: '2107704', name: "Paraibano", state: 'MA' },
    { code: '2107803', name: "Parnarama", state: 'MA' },
    { code: '2107902', name: "Passagem Franca", state: 'MA' },
    { code: '2108009', name: "Pastos Bons", state: 'MA' },
    { code: '2108058', name: "Paulino Neves", state: 'MA' },
    { code: '2108108', name: "Paulo Ramos", state: 'MA' },
    { code: '2108207', name: "Pedreiras", state: 'MA' },
    { code: '2108256', name: "Pedro do Rosário", state: 'MA' },
    { code: '2108306', name: "Penalva", state: 'MA' },
    { code: '2108405', name: "Peri Mirim", state: 'MA' },
    { code: '2108454', name: "Peritoró", state: 'MA' },
    { code: '2108504', name: "Pindaré-Mirim", state: 'MA' },
    { code: '2108603', name: "Pinheiro", state: 'MA' },
    { code: '2108702', name: "Pio XII", state: 'MA' },
    { code: '2108801', name: "Pirapemas", state: 'MA' },
    { code: '2108900', name: "Poção de Pedras", state: 'MA' },
    { code: '2109007', name: "Porto Franco", state: 'MA' },
    { code: '2109056', name: "Porto Rico do Maranhão", state: 'MA' },
    { code: '2109106', name: "Presidente Dutra", state: 'MA' },
    { code: '2109205', name: "Presidente Juscelino", state: 'MA' },
    { code: '2109239', name: "Presidente Médici", state: 'MA' },
    { code: '2109270', name: "Presidente Sarney", state: 'MA' },
    { code: '2109304', name: "Presidente Vargas", state: 'MA' },
    { code: '2109403', name: "Primeira Cruz", state: 'MA' },
    { code: '2109452', name: "Raposa", state: 'MA' },
    { code: '2109502', name: "Riachão", state: 'MA' },
    { code: '2109551', name: "Ribamar Fiquene", state: 'MA' },
    { code: '2109601', name: "Rosário", state: 'MA' },
    { code: '2109700', name: "Sambaíba", state: 'MA' },
    { code: '2109759', name: "Santa Filomena do Maranhão", state: 'MA' },
    { code: '2109809', name: "Santa Helena", state: 'MA' },
    { code: '2109908', name: "Santa Inês", state: 'MA' },
    { code: '2110005', name: "Santa Luzia", state: 'MA' },
    { code: '2110039', name: "Santa Luzia do Paruá", state: 'MA' },
    { code: '2110104', name: "Santa Quitéria do Maranhão", state: 'MA' },
    { code: '2110203', name: "Santa Rita", state: 'MA' },
    { code: '2110237', name: "Santana do Maranhão", state: 'MA' },
    { code: '2110278', name: "Santo Amaro do Maranhão", state: 'MA' },
    { code: '2110302', name: "Santo Antônio dos Lopes", state: 'MA' },
    { code: '2110401', name: "São Benedito do Rio Preto", state: 'MA' },
    { code: '2110500', name: "São Bento", state: 'MA' },
    { code: '2110609', name: "São Bernardo", state: 'MA' },
    { code: '2110658', name: "São Domingos do Azeitão", state: 'MA' },
    { code: '2110708', name: "São Domingos do Maranhão", state: 'MA' },
    { code: '2110807', name: "São Félix de Balsas", state: 'MA' },
    { code: '2110856', name: "São Francisco do Brejão", state: 'MA' },
    { code: '2110906', name: "São Francisco do Maranhão", state: 'MA' },
    { code: '2111003', name: "São João Batista", state: 'MA' },
    { code: '2111029', name: "São João do Carú", state: 'MA' },
    { code: '2111052', name: "São João do Paraíso", state: 'MA' },
    { code: '2111078', name: "São João do Soter", state: 'MA' },
    { code: '2111102', name: "São João dos Patos", state: 'MA' },
    { code: '2111201', name: "São José de Ribamar", state: 'MA' },
    { code: '2111250', name: "São José dos Basílios", state: 'MA' },
    { code: '2111300', name: "São Luís", state: 'MA' },
    { code: '2111409', name: "São Luís Gonzaga do Maranhão", state: 'MA' },
    { code: '2111508', name: "São Mateus do Maranhão", state: 'MA' },
    { code: '2111532', name: "São Pedro da Água Branca", state: 'MA' },
    { code: '2111573', name: "São Pedro dos Crentes", state: 'MA' },
    { code: '2111607', name: "São Raimundo das Mangabeiras", state: 'MA' },
    { code: '2111631', name: "São Raimundo do Doca Bezerra", state: 'MA' },
    { code: '2111672', name: "São Roberto", state: 'MA' },
    { code: '2111706', name: "São Vicente Ferrer", state: 'MA' },
    { code: '2111722', name: "Satubinha", state: 'MA' },
    { code: '2111748', name: "Senador Alexandre Costa", state: 'MA' },
    { code: '2111763', name: "Senador La Rocque", state: 'MA' },
    { code: '2111789', name: "Serrano do Maranhão", state: 'MA' },
    { code: '2111805', name: "Sítio Novo", state: 'MA' },
    { code: '2111904', name: "Sucupira do Norte", state: 'MA' },
    { code: '2111953', name: "Sucupira do Riachão", state: 'MA' },
    { code: '2112001', name: "Tasso Fragoso", state: 'MA' },
    { code: '2112100', name: "Timbiras", state: 'MA' },
    { code: '2112209', name: "Timon", state: 'MA' },
    { code: '2112233', name: "Trizidela do Vale", state: 'MA' },
    { code: '2112274', name: "Tufilândia", state: 'MA' },
    { code: '2112308', name: "Tuntum", state: 'MA' },
    { code: '2112407', name: "Turiaçu", state: 'MA' },
    { code: '2112456', name: "Turilândia", state: 'MA' },
    { code: '2112506', name: "Tutóia", state: 'MA' },
    { code: '2112605', name: "Urbano Santos", state: 'MA' },
    { code: '2112704', name: "Vargem Grande", state: 'MA' },
    { code: '2112803', name: "Viana", state: 'MA' },
    { code: '2112852', name: "Vila Nova dos Martírios", state: 'MA' },
    { code: '2112902', name: "Vitória do Mearim", state: 'MA' },
    { code: '2113009', name: "Vitorino Freire", state: 'MA' },
    { code: '2114007', name: "Zé Doca", state: 'MA' }
  ],

  // MINAS GERAIS (MG) - 853 municípios
  MG: [
    { code: '3100104', name: "Abadia dos Dourados", state: 'MG' },
    { code: '3100203', name: "Abaeté", state: 'MG' },
    { code: '3100302', name: "Abre Campo", state: 'MG' },
    { code: '3100401', name: "Acaiaca", state: 'MG' },
    { code: '3100500', name: "Açucena", state: 'MG' },
    { code: '3100609', name: "Água Boa", state: 'MG' },
    { code: '3100708', name: "Água Comprida", state: 'MG' },
    { code: '3100807', name: "Aguanil", state: 'MG' },
    { code: '3100906', name: "Águas Formosas", state: 'MG' },
    { code: '3101003', name: "Águas Vermelhas", state: 'MG' },
    { code: '3101102', name: "Aimorés", state: 'MG' },
    { code: '3101201', name: "Aiuruoca", state: 'MG' },
    { code: '3101300', name: "Alagoa", state: 'MG' },
    { code: '3101409', name: "Albertina", state: 'MG' },
    { code: '3101508', name: "Além Paraíba", state: 'MG' },
    { code: '3101607', name: "Alfenas", state: 'MG' },
    { code: '3101631', name: "Alfredo Vasconcelos", state: 'MG' },
    { code: '3101706', name: "Almenara", state: 'MG' },
    { code: '3101805', name: "Alpercata", state: 'MG' },
    { code: '3101904', name: "Alpinópolis", state: 'MG' },
    { code: '3102001', name: "Alterosa", state: 'MG' },
    { code: '3102050', name: "Alto Caparaó", state: 'MG' },
    { code: '3153509', name: "Alto Jequitibá", state: 'MG' },
    { code: '3102100', name: "Alto Rio Doce", state: 'MG' },
    { code: '3102209', name: "Alvarenga", state: 'MG' },
    { code: '3102308', name: "Alvinópolis", state: 'MG' },
    { code: '3102407', name: "Alvorada de Minas", state: 'MG' },
    { code: '3102506', name: "Amparo do Serra", state: 'MG' },
    { code: '3102605', name: "Andradas", state: 'MG' },
    { code: '3102803', name: "Andrelândia", state: 'MG' },
    { code: '3102852', name: "Angelândia", state: 'MG' },
    { code: '3102902', name: "Antônio Carlos", state: 'MG' },
    { code: '3103009', name: "Antônio Dias", state: 'MG' },
    { code: '3103108', name: "Antônio Prado de Minas", state: 'MG' },
    { code: '3103207', name: "Araçaí", state: 'MG' },
    { code: '3103306', name: "Aracitaba", state: 'MG' },
    { code: '3103405', name: "Araçuaí", state: 'MG' },
    { code: '3103504', name: "Araguari", state: 'MG' },
    { code: '3103603', name: "Arantina", state: 'MG' },
    { code: '3103702', name: "Araponga", state: 'MG' },
    { code: '3103751', name: "Araporã", state: 'MG' },
    { code: '3103801', name: "Arapuá", state: 'MG' },
    { code: '3103900', name: "Araújos", state: 'MG' },
    { code: '3104007', name: "Araxá", state: 'MG' },
    { code: '3104106', name: "Arceburgo", state: 'MG' },
    { code: '3104205', name: "Arcos", state: 'MG' },
    { code: '3104304', name: "Areado", state: 'MG' },
    { code: '3104403', name: "Argirita", state: 'MG' },
    { code: '3104452', name: "Aricanduva", state: 'MG' },
    { code: '3104502', name: "Arinos", state: 'MG' },
    { code: '3104601', name: "Astolfo Dutra", state: 'MG' },
    { code: '3104700', name: "Ataléia", state: 'MG' },
    { code: '3104809', name: "Augusto de Lima", state: 'MG' },
    { code: '3104908', name: "Baependi", state: 'MG' },
    { code: '3105004', name: "Baldim", state: 'MG' },
    { code: '3105103', name: "Bambuí", state: 'MG' },
    { code: '3105202', name: "Bandeira", state: 'MG' },
    { code: '3105301', name: "Bandeira do Sul", state: 'MG' },
    { code: '3105400', name: "Barão de Cocais", state: 'MG' },
    { code: '3105509', name: "Barão do Monte Alto", state: 'MG' },
    { code: '3105608', name: "Barbacena", state: 'MG' },
    { code: '3105707', name: "Barra Longa", state: 'MG' },
    { code: '3105905', name: "Barroso", state: 'MG' },
    { code: '3106002', name: "Bela Vista de Minas", state: 'MG' },
    { code: '3106101', name: "Belmiro Braga", state: 'MG' },
    { code: '3106200', name: "Belo Horizonte", state: 'MG' },
    { code: '3106309', name: "Belo Oriente", state: 'MG' },
    { code: '3106408', name: "Belo Vale", state: 'MG' },
    { code: '3106507', name: "Berilo", state: 'MG' },
    { code: '3106655', name: "Berizal", state: 'MG' },
    { code: '3106606', name: "Bertópolis", state: 'MG' },
    { code: '3106705', name: "Betim", state: 'MG' },
    { code: '3106804', name: "Bias Fortes", state: 'MG' },
    { code: '3106903', name: "Bicas", state: 'MG' },
    { code: '3107000', name: "Biquinhas", state: 'MG' },
    { code: '3107109', name: "Boa Esperança", state: 'MG' },
    { code: '3107208', name: "Bocaina de Minas", state: 'MG' },
    { code: '3107307', name: "Bocaiúva", state: 'MG' },
    { code: '3107406', name: "Bom Despacho", state: 'MG' },
    { code: '3107505', name: "Bom Jardim de Minas", state: 'MG' },
    { code: '3107604', name: "Bom Jesus da Penha", state: 'MG' },
    { code: '3107703', name: "Bom Jesus do Amparo", state: 'MG' },
    { code: '3107802', name: "Bom Jesus do Galho", state: 'MG' },
    { code: '3107901', name: "Bom Repouso", state: 'MG' },
    { code: '3108008', name: "Bom Sucesso", state: 'MG' },
    { code: '3108107', name: "Bonfim", state: 'MG' },
    { code: '3108206', name: "Bonfinópolis de Minas", state: 'MG' },
    { code: '3108255', name: "Bonito de Minas", state: 'MG' },
    { code: '3108305', name: "Borda da Mata", state: 'MG' },
    { code: '3108404', name: "Botelhos", state: 'MG' },
    { code: '3108503', name: "Botumirim", state: 'MG' },
    { code: '3108701', name: "Brás Pires", state: 'MG' },
    { code: '3108552', name: "Brasilândia de Minas", state: 'MG' },
    { code: '3108602', name: "Brasília de Minas", state: 'MG' },
    { code: '3108800', name: "Braúnas", state: 'MG' },
    { code: '3108909', name: "Brazópolis", state: 'MG' },
    { code: '3109006', name: "Brumadinho", state: 'MG' },
    { code: '3109105', name: "Bueno Brandão", state: 'MG' },
    { code: '3109204', name: "Buenópolis", state: 'MG' },
    { code: '3109253', name: "Bugre", state: 'MG' },
    { code: '3109303', name: "Buritis", state: 'MG' },
    { code: '3109402', name: "Buritizeiro", state: 'MG' },
    { code: '3109451', name: "Cabeceira Grande", state: 'MG' },
    { code: '3109501', name: "Cabo Verde", state: 'MG' },
    { code: '3109600', name: "Cachoeira da Prata", state: 'MG' },
    { code: '3109709', name: "Cachoeira de Minas", state: 'MG' },
    { code: '3102704', name: "Cachoeira de Pajeú", state: 'MG' },
    { code: '3109808', name: "Cachoeira Dourada", state: 'MG' },
    { code: '3109907', name: "Caetanópolis", state: 'MG' },
    { code: '3110004', name: "Caeté", state: 'MG' },
    { code: '3110103', name: "Caiana", state: 'MG' },
    { code: '3110202', name: "Cajuri", state: 'MG' },
    { code: '3110301', name: "Caldas", state: 'MG' },
    { code: '3110400', name: "Camacho", state: 'MG' },
    { code: '3110509', name: "Camanducaia", state: 'MG' },
    { code: '3110608', name: "Cambuí", state: 'MG' },
    { code: '3110707', name: "Cambuquira", state: 'MG' },
    { code: '3110806', name: "Campanário", state: 'MG' },
    { code: '3110905', name: "Campanha", state: 'MG' },
    { code: '3111002', name: "Campestre", state: 'MG' },
    { code: '3111101', name: "Campina Verde", state: 'MG' },
    { code: '3111150', name: "Campo Azul", state: 'MG' },
    { code: '3111200', name: "Campo Belo", state: 'MG' },
    { code: '3111309', name: "Campo do Meio", state: 'MG' },
    { code: '3111408', name: "Campo Florido", state: 'MG' },
    { code: '3111507', name: "Campos Altos", state: 'MG' },
    { code: '3111606', name: "Campos Gerais", state: 'MG' },
    { code: '3111903', name: "Cana Verde", state: 'MG' },
    { code: '3111705', name: "Canaã", state: 'MG' },
    { code: '3111804', name: "Canápolis", state: 'MG' },
    { code: '3112000', name: "Candeias", state: 'MG' },
    { code: '3112059', name: "Cantagalo", state: 'MG' },
    { code: '3112109', name: "Caparaó", state: 'MG' },
    { code: '3112208', name: "Capela Nova", state: 'MG' },
    { code: '3112307', name: "Capelinha", state: 'MG' },
    { code: '3112406', name: "Capetinga", state: 'MG' },
    { code: '3112505', name: "Capim Branco", state: 'MG' },
    { code: '3112604', name: "Capinópolis", state: 'MG' },
    { code: '3112653', name: "Capitão Andrade", state: 'MG' },
    { code: '3112703', name: "Capitão Enéas", state: 'MG' },
    { code: '3112802', name: "Capitólio", state: 'MG' },
    { code: '3112901', name: "Caputira", state: 'MG' },
    { code: '3113008', name: "Caraí", state: 'MG' },
    { code: '3113107', name: "Caranaíba", state: 'MG' },
    { code: '3113206', name: "Carandaí", state: 'MG' },
    { code: '3113305', name: "Carangola", state: 'MG' },
    { code: '3113404', name: "Caratinga", state: 'MG' },
    { code: '3113503', name: "Carbonita", state: 'MG' },
    { code: '3113602', name: "Careaçu", state: 'MG' },
    { code: '3113701', name: "Carlos Chagas", state: 'MG' },
    { code: '3113800', name: "Carmésia", state: 'MG' },
    { code: '3113909', name: "Carmo da Cachoeira", state: 'MG' },
    { code: '3114006', name: "Carmo da Mata", state: 'MG' },
    { code: '3114105', name: "Carmo de Minas", state: 'MG' },
    { code: '3114204', name: "Carmo do Cajuru", state: 'MG' },
    { code: '3114303', name: "Carmo do Paranaíba", state: 'MG' },
    { code: '3114402', name: "Carmo do Rio Claro", state: 'MG' },
    { code: '3114501', name: "Carmópolis de Minas", state: 'MG' },
    { code: '3114550', name: "Carneirinho", state: 'MG' },
    { code: '3114600', name: "Carrancas", state: 'MG' },
    { code: '3114709', name: "Carvalhópolis", state: 'MG' },
    { code: '3114808', name: "Carvalhos", state: 'MG' },
    { code: '3114907', name: "Casa Grande", state: 'MG' },
    { code: '3115003', name: "Cascalho Rico", state: 'MG' },
    { code: '3115102', name: "Cássia", state: 'MG' },
    { code: '3115300', name: "Cataguases", state: 'MG' },
    { code: '3115359', name: "Catas Altas", state: 'MG' },
    { code: '3115409', name: "Catas Altas da Noruega", state: 'MG' },
    { code: '3115458', name: "Catuji", state: 'MG' },
    { code: '3115474', name: "Catuti", state: 'MG' },
    { code: '3115508', name: "Caxambu", state: 'MG' },
    { code: '3115607', name: "Cedro do Abaeté", state: 'MG' },
    { code: '3115706', name: "Central de Minas", state: 'MG' },
    { code: '3115805', name: "Centralina", state: 'MG' },
    { code: '3115904', name: "Chácara", state: 'MG' },
    { code: '3116001', name: "Chalé", state: 'MG' },
    { code: '3116100', name: "Chapada do Norte", state: 'MG' },
    { code: '3116159', name: "Chapada Gaúcha", state: 'MG' },
    { code: '3116209', name: "Chiador", state: 'MG' },
    { code: '3116308', name: "Cipotânea", state: 'MG' },
    { code: '3116407', name: "Claraval", state: 'MG' },
    { code: '3116506', name: "Claro dos Poções", state: 'MG' },
    { code: '3116605', name: "Cláudio", state: 'MG' },
    { code: '3116704', name: "Coimbra", state: 'MG' },
    { code: '3116803', name: "Coluna", state: 'MG' },
    { code: '3116902', name: "Comendador Gomes", state: 'MG' },
    { code: '3117009', name: "Comercinho", state: 'MG' },
    { code: '3117108', name: "Conceição da Aparecida", state: 'MG' },
    { code: '3115201', name: "Conceição da Barra de Minas", state: 'MG' },
    { code: '3117306', name: "Conceição das Alagoas", state: 'MG' },
    { code: '3117207', name: "Conceição das Pedras", state: 'MG' },
    { code: '3117405', name: "Conceição de Ipanema", state: 'MG' },
    { code: '3117504', name: "Conceição do Mato Dentro", state: 'MG' },
    { code: '3117603', name: "Conceição do Pará", state: 'MG' },
    { code: '3117702', name: "Conceição do Rio Verde", state: 'MG' },
    { code: '3117801', name: "Conceição dos Ouros", state: 'MG' },
    { code: '3117836', name: "Cônego Marinho", state: 'MG' },
    { code: '3117876', name: "Confins", state: 'MG' },
    { code: '3117900', name: "Congonhal", state: 'MG' },
    { code: '3118007', name: "Congonhas", state: 'MG' },
    { code: '3118106', name: "Congonhas do Norte", state: 'MG' },
    { code: '3118205', name: "Conquista", state: 'MG' },
    { code: '3118304', name: "Conselheiro Lafaiete", state: 'MG' },
    { code: '3118403', name: "Conselheiro Pena", state: 'MG' },
    { code: '3118502', name: "Consolação", state: 'MG' },
    { code: '3118601', name: "Contagem", state: 'MG' },
    { code: '3118700', name: "Coqueiral", state: 'MG' },
    { code: '3118809', name: "Coração de Jesus", state: 'MG' },
    { code: '3118908', name: "Cordisburgo", state: 'MG' },
    { code: '3119005', name: "Cordislândia", state: 'MG' },
    { code: '3119104', name: "Corinto", state: 'MG' },
    { code: '3119203', name: "Coroaci", state: 'MG' },
    { code: '3119302', name: "Coromandel", state: 'MG' },
    { code: '3119401', name: "Coronel Fabriciano", state: 'MG' },
    { code: '3119500', name: "Coronel Murta", state: 'MG' },
    { code: '3119609', name: "Coronel Pacheco", state: 'MG' },
    { code: '3119708', name: "Coronel Xavier Chaves", state: 'MG' },
    { code: '3119807', name: "Córrego Danta", state: 'MG' },
    { code: '3119906', name: "Córrego do Bom Jesus", state: 'MG' },
    { code: '3119955', name: "Córrego Fundo", state: 'MG' },
    { code: '3120003', name: "Córrego Novo", state: 'MG' },
    { code: '3120102', name: "Couto de Magalhães de Minas", state: 'MG' },
    { code: '3120151', name: "Crisólita", state: 'MG' },
    { code: '3120201', name: "Cristais", state: 'MG' },
    { code: '3120300', name: "Cristália", state: 'MG' },
    { code: '3120409', name: "Cristiano Otoni", state: 'MG' },
    { code: '3120508', name: "Cristina", state: 'MG' },
    { code: '3120607', name: "Crucilândia", state: 'MG' },
    { code: '3120706', name: "Cruzeiro da Fortaleza", state: 'MG' },
    { code: '3120805', name: "Cruzília", state: 'MG' },
    { code: '3120839', name: "Cuparaque", state: 'MG' },
    { code: '3120870', name: "Curral de Dentro", state: 'MG' },
    { code: '3120904', name: "Curvelo", state: 'MG' },
    { code: '3121001', name: "Datas", state: 'MG' },
    { code: '3121100', name: "Delfim Moreira", state: 'MG' },
    { code: '3121209', name: "Delfinópolis", state: 'MG' },
    { code: '3121258', name: "Delta", state: 'MG' },
    { code: '3121308', name: "Descoberto", state: 'MG' },
    { code: '3121407', name: "Desterro de Entre Rios", state: 'MG' },
    { code: '3121506', name: "Desterro do Melo", state: 'MG' },
    { code: '3121605', name: "Diamantina", state: 'MG' },
    { code: '3121704', name: "Diogo de Vasconcelos", state: 'MG' },
    { code: '3121803', name: "Dionísio", state: 'MG' },
    { code: '3121902', name: "Divinésia", state: 'MG' },
    { code: '3122009', name: "Divino", state: 'MG' },
    { code: '3122108', name: "Divino das Laranjeiras", state: 'MG' },
    { code: '3122207', name: "Divinolândia de Minas", state: 'MG' },
    { code: '3122306', name: "Divinópolis", state: 'MG' },
    { code: '3122355', name: "Divisa Alegre", state: 'MG' },
    { code: '3122405', name: "Divisa Nova", state: 'MG' },
    { code: '3122454', name: "Divisópolis", state: 'MG' },
    { code: '3122470', name: "Dom Bosco", state: 'MG' },
    { code: '3122504', name: "Dom Cavati", state: 'MG' },
    { code: '3122603', name: "Dom Joaquim", state: 'MG' },
    { code: '3122702', name: "Dom Silvério", state: 'MG' },
    { code: '3122801', name: "Dom Viçoso", state: 'MG' },
    { code: '3122900', name: "Dona Euzébia", state: 'MG' },
    { code: '3123007', name: "Dores de Campos", state: 'MG' },
    { code: '3123106', name: "Dores de Guanhães", state: 'MG' },
    { code: '3123205', name: "Dores do Indaiá", state: 'MG' },
    { code: '3123304', name: "Dores do Turvo", state: 'MG' },
    { code: '3123403', name: "Doresópolis", state: 'MG' },
    { code: '3123502', name: "Douradoquara", state: 'MG' },
    { code: '3123528', name: "Durandé", state: 'MG' },
    { code: '3123601', name: "Elói Mendes", state: 'MG' },
    { code: '3123700', name: "Engenheiro Caldas", state: 'MG' },
    { code: '3123809', name: "Engenheiro Navarro", state: 'MG' },
    { code: '3123858', name: "Entre Folhas", state: 'MG' },
    { code: '3123908', name: "Entre Rios de Minas", state: 'MG' },
    { code: '3124005', name: "Ervália", state: 'MG' },
    { code: '3124104', name: "Esmeraldas", state: 'MG' },
    { code: '3124203', name: "Espera Feliz", state: 'MG' },
    { code: '3124302', name: "Espinosa", state: 'MG' },
    { code: '3124401', name: "Espírito Santo do Dourado", state: 'MG' },
    { code: '3124500', name: "Estiva", state: 'MG' },
    { code: '3124609', name: "Estrela Dalva", state: 'MG' },
    { code: '3124708', name: "Estrela do Indaiá", state: 'MG' },
    { code: '3124807', name: "Estrela do Sul", state: 'MG' },
    { code: '3124906', name: "Eugenópolis", state: 'MG' },
    { code: '3125002', name: "Ewbank da Câmara", state: 'MG' },
    { code: '3125101', name: "Extrema", state: 'MG' },
    { code: '3125200', name: "Fama", state: 'MG' },
    { code: '3125309', name: "Faria Lemos", state: 'MG' },
    { code: '3125408', name: "Felício dos Santos", state: 'MG' },
    { code: '3125606', name: "Felisburgo", state: 'MG' },
    { code: '3125705', name: "Felixlândia", state: 'MG' },
    { code: '3125804', name: "Fernandes Tourinho", state: 'MG' },
    { code: '3125903', name: "Ferros", state: 'MG' },
    { code: '3125952', name: "Fervedouro", state: 'MG' },
    { code: '3126000', name: "Florestal", state: 'MG' },
    { code: '3126109', name: "Formiga", state: 'MG' },
    { code: '3126208', name: "Formoso", state: 'MG' },
    { code: '3126307', name: "Fortaleza de Minas", state: 'MG' },
    { code: '3126406', name: "Fortuna de Minas", state: 'MG' },
    { code: '3126505', name: "Francisco Badaró", state: 'MG' },
    { code: '3126604', name: "Francisco Dumont", state: 'MG' },
    { code: '3126703', name: "Francisco Sá", state: 'MG' },
    { code: '3126752', name: "Franciscópolis", state: 'MG' },
    { code: '3126802', name: "Frei Gaspar", state: 'MG' },
    { code: '3126901', name: "Frei Inocêncio", state: 'MG' },
    { code: '3126950', name: "Frei Lagonegro", state: 'MG' },
    { code: '3127008', name: "Fronteira", state: 'MG' },
    { code: '3127057', name: "Fronteira dos Vales", state: 'MG' },
    { code: '3127073', name: "Fruta de Leite", state: 'MG' },
    { code: '3127107', name: "Frutal", state: 'MG' },
    { code: '3127206', name: "Funilândia", state: 'MG' },
    { code: '3127305', name: "Galiléia", state: 'MG' },
    { code: '3127339', name: "Gameleiras", state: 'MG' },
    { code: '3127354', name: "Glaucilândia", state: 'MG' },
    { code: '3127370', name: "Goiabeira", state: 'MG' },
    { code: '3127388', name: "Goianá", state: 'MG' },
    { code: '3127404', name: "Gonçalves", state: 'MG' },
    { code: '3127503', name: "Gonzaga", state: 'MG' },
    { code: '3127602', name: "Gouveia", state: 'MG' },
    { code: '3127701', name: "Governador Valadares", state: 'MG' },
    { code: '3127800', name: "Grão Mogol", state: 'MG' },
    { code: '3127909', name: "Grupiara", state: 'MG' },
    { code: '3128006', name: "Guanhães", state: 'MG' },
    { code: '3128105', name: "Guapé", state: 'MG' },
    { code: '3128204', name: "Guaraciaba", state: 'MG' },
    { code: '3128253', name: "Guaraciama", state: 'MG' },
    { code: '3128303', name: "Guaranésia", state: 'MG' },
    { code: '3128402', name: "Guarani", state: 'MG' },
    { code: '3128501', name: "Guarará", state: 'MG' },
    { code: '3128600', name: "Guarda-Mor", state: 'MG' },
    { code: '3128709', name: "Guaxupé", state: 'MG' },
    { code: '3128808', name: "Guidoval", state: 'MG' },
    { code: '3128907', name: "Guimarânia", state: 'MG' },
    { code: '3129004', name: "Guiricema", state: 'MG' },
    { code: '3129103', name: "Gurinhatã", state: 'MG' },
    { code: '3129202', name: "Heliodora", state: 'MG' },
    { code: '3129301', name: "Iapu", state: 'MG' },
    { code: '3129400', name: "Ibertioga", state: 'MG' },
    { code: '3129509', name: "Ibiá", state: 'MG' },
    { code: '3129608', name: "Ibiaí", state: 'MG' },
    { code: '3129657', name: "Ibiracatu", state: 'MG' },
    { code: '3129707', name: "Ibiraci", state: 'MG' },
    { code: '3129806', name: "Ibirité", state: 'MG' },
    { code: '3129905', name: "Ibitiúra de Minas", state: 'MG' },
    { code: '3130002', name: "Ibituruna", state: 'MG' },
    { code: '3130051', name: "Icaraí de Minas", state: 'MG' },
    { code: '3130101', name: "Igarapé", state: 'MG' },
    { code: '3130200', name: "Igaratinga", state: 'MG' },
    { code: '3130309', name: "Iguatama", state: 'MG' },
    { code: '3130408', name: "Ijaci", state: 'MG' },
    { code: '3130507', name: "Ilicínea", state: 'MG' },
    { code: '3130556', name: "Imbé de Minas", state: 'MG' },
    { code: '3130606', name: "Inconfidentes", state: 'MG' },
    { code: '3130655', name: "Indaiabira", state: 'MG' },
    { code: '3130705', name: "Indianópolis", state: 'MG' },
    { code: '3130804', name: "Ingaí", state: 'MG' },
    { code: '3130903', name: "Inhapim", state: 'MG' },
    { code: '3131000', name: "Inhaúma", state: 'MG' },
    { code: '3131109', name: "Inimutaba", state: 'MG' },
    { code: '3131158', name: "Ipaba", state: 'MG' },
    { code: '3131208', name: "Ipanema", state: 'MG' },
    { code: '3131307', name: "Ipatinga", state: 'MG' },
    { code: '3131406', name: "Ipiaçu", state: 'MG' },
    { code: '3131505', name: "Ipuiúna", state: 'MG' },
    { code: '3131604', name: "Iraí de Minas", state: 'MG' },
    { code: '3131703', name: "Itabira", state: 'MG' },
    { code: '3131802', name: "Itabirinha", state: 'MG' },
    { code: '3131901', name: "Itabirito", state: 'MG' },
    { code: '3132008', name: "Itacambira", state: 'MG' },
    { code: '3132107', name: "Itacarambi", state: 'MG' },
    { code: '3132206', name: "Itaguara", state: 'MG' },
    { code: '3132305', name: "Itaipé", state: 'MG' },
    { code: '3132404', name: "Itajubá", state: 'MG' },
    { code: '3132503', name: "Itamarandiba", state: 'MG' },
    { code: '3132602', name: "Itamarati de Minas", state: 'MG' },
    { code: '3132701', name: "Itambacuri", state: 'MG' },
    { code: '3132800', name: "Itambé do Mato Dentro", state: 'MG' },
    { code: '3132909', name: "Itamogi", state: 'MG' },
    { code: '3133006', name: "Itamonte", state: 'MG' },
    { code: '3133105', name: "Itanhandu", state: 'MG' },
    { code: '3133204', name: "Itanhomi", state: 'MG' },
    { code: '3133303', name: "Itaobim", state: 'MG' },
    { code: '3133402', name: "Itapagipe", state: 'MG' },
    { code: '3133501', name: "Itapecerica", state: 'MG' },
    { code: '3133600', name: "Itapeva", state: 'MG' },
    { code: '3133709', name: "Itatiaiuçu", state: 'MG' },
    { code: '3133758', name: "Itaú de Minas", state: 'MG' },
    { code: '3133808', name: "Itaúna", state: 'MG' },
    { code: '3133907', name: "Itaverava", state: 'MG' },
    { code: '3134004', name: "Itinga", state: 'MG' },
    { code: '3134103', name: "Itueta", state: 'MG' },
    { code: '3134202', name: "Ituiutaba", state: 'MG' },
    { code: '3134301', name: "Itumirim", state: 'MG' },
    { code: '3134400', name: "Iturama", state: 'MG' },
    { code: '3134509', name: "Itutinga", state: 'MG' },
    { code: '3134608', name: "Jaboticatubas", state: 'MG' },
    { code: '3134707', name: "Jacinto", state: 'MG' },
    { code: '3134806', name: "Jacuí", state: 'MG' },
    { code: '3134905', name: "Jacutinga", state: 'MG' },
    { code: '3135001', name: "Jaguaraçu", state: 'MG' },
    { code: '3135050', name: "Jaíba", state: 'MG' },
    { code: '3135076', name: "Jampruca", state: 'MG' },
    { code: '3135100', name: "Janaúba", state: 'MG' },
    { code: '3135209', name: "Januária", state: 'MG' },
    { code: '3135308', name: "Japaraíba", state: 'MG' },
    { code: '3135357', name: "Japonvar", state: 'MG' },
    { code: '3135407', name: "Jeceaba", state: 'MG' },
    { code: '3135456', name: "Jenipapo de Minas", state: 'MG' },
    { code: '3135506', name: "Jequeri", state: 'MG' },
    { code: '3135605', name: "Jequitaí", state: 'MG' },
    { code: '3135704', name: "Jequitibá", state: 'MG' },
    { code: '3135803', name: "Jequitinhonha", state: 'MG' },
    { code: '3135902', name: "Jesuânia", state: 'MG' },
    { code: '3136009', name: "Joaíma", state: 'MG' },
    { code: '3136108', name: "Joanésia", state: 'MG' },
    { code: '3136207', name: "João Monlevade", state: 'MG' },
    { code: '3136306', name: "João Pinheiro", state: 'MG' },
    { code: '3136405', name: "Joaquim Felício", state: 'MG' },
    { code: '3136504', name: "Jordânia", state: 'MG' },
    { code: '3136520', name: "José Gonçalves de Minas", state: 'MG' },
    { code: '3136553', name: "José Raydan", state: 'MG' },
    { code: '3136579', name: "Josenópolis", state: 'MG' },
    { code: '3136652', name: "Juatuba", state: 'MG' },
    { code: '3136702', name: "Juiz de Fora", state: 'MG' },
    { code: '3136801', name: "Juramento", state: 'MG' },
    { code: '3136900', name: "Juruaia", state: 'MG' },
    { code: '3136959', name: "Juvenília", state: 'MG' },
    { code: '3137007', name: "Ladainha", state: 'MG' },
    { code: '3137106', name: "Lagamar", state: 'MG' },
    { code: '3137205', name: "Lagoa da Prata", state: 'MG' },
    { code: '3137304', name: "Lagoa dos Patos", state: 'MG' },
    { code: '3137403', name: "Lagoa Dourada", state: 'MG' },
    { code: '3137502', name: "Lagoa Formosa", state: 'MG' },
    { code: '3137536', name: "Lagoa Grande", state: 'MG' },
    { code: '3137601', name: "Lagoa Santa", state: 'MG' },
    { code: '3137700', name: "Lajinha", state: 'MG' },
    { code: '3137809', name: "Lambari", state: 'MG' },
    { code: '3137908', name: "Lamim", state: 'MG' },
    { code: '3138005', name: "Laranjal", state: 'MG' },
    { code: '3138104', name: "Lassance", state: 'MG' },
    { code: '3138203', name: "Lavras", state: 'MG' },
    { code: '3138302', name: "Leandro Ferreira", state: 'MG' },
    { code: '3138351', name: "Leme do Prado", state: 'MG' },
    { code: '3138401', name: "Leopoldina", state: 'MG' },
    { code: '3138500', name: "Liberdade", state: 'MG' },
    { code: '3138609', name: "Lima Duarte", state: 'MG' },
    { code: '3138625', name: "Limeira do Oeste", state: 'MG' },
    { code: '3138658', name: "Lontra", state: 'MG' },
    { code: '3138674', name: "Luisburgo", state: 'MG' },
    { code: '3138682', name: "Luislândia", state: 'MG' },
    { code: '3138708', name: "Luminárias", state: 'MG' },
    { code: '3138807', name: "Luz", state: 'MG' },
    { code: '3138906', name: "Machacalis", state: 'MG' },
    { code: '3139003', name: "Machado", state: 'MG' },
    { code: '3139102', name: "Madre de Deus de Minas", state: 'MG' },
    { code: '3139201', name: "Malacacheta", state: 'MG' },
    { code: '3139250', name: "Mamonas", state: 'MG' },
    { code: '3139300', name: "Manga", state: 'MG' },
    { code: '3139409', name: "Manhuaçu", state: 'MG' },
    { code: '3139508', name: "Manhumirim", state: 'MG' },
    { code: '3139607', name: "Mantena", state: 'MG' },
    { code: '3139805', name: "Mar de Espanha", state: 'MG' },
    { code: '3139706', name: "Maravilhas", state: 'MG' },
    { code: '3139904', name: "Maria da Fé", state: 'MG' },
    { code: '3140001', name: "Mariana", state: 'MG' },
    { code: '3140100', name: "Marilac", state: 'MG' },
    { code: '3140159', name: "Mário Campos", state: 'MG' },
    { code: '3140209', name: "Maripá de Minas", state: 'MG' },
    { code: '3140308', name: "Marliéria", state: 'MG' },
    { code: '3140407', name: "Marmelópolis", state: 'MG' },
    { code: '3140506', name: "Martinho Campos", state: 'MG' },
    { code: '3140530', name: "Martins Soares", state: 'MG' },
    { code: '3140555', name: "Mata Verde", state: 'MG' },
    { code: '3140605', name: "Materlândia", state: 'MG' },
    { code: '3140704', name: "Mateus Leme", state: 'MG' },
    { code: '3171501', name: "Mathias Lobato", state: 'MG' },
    { code: '3140803', name: "Matias Barbosa", state: 'MG' },
    { code: '3140852', name: "Matias Cardoso", state: 'MG' },
    { code: '3140902', name: "Matipó", state: 'MG' },
    { code: '3141009', name: "Mato Verde", state: 'MG' },
    { code: '3141108', name: "Matozinhos", state: 'MG' },
    { code: '3141207', name: "Matutina", state: 'MG' },
    { code: '3141306', name: "Medeiros", state: 'MG' },
    { code: '3141405', name: "Medina", state: 'MG' },
    { code: '3141504', name: "Mendes Pimentel", state: 'MG' },
    { code: '3141603', name: "Mercês", state: 'MG' },
    { code: '3141702', name: "Mesquita", state: 'MG' },
    { code: '3141801', name: "Minas Novas", state: 'MG' },
    { code: '3141900', name: "Minduri", state: 'MG' },
    { code: '3142007', name: "Mirabela", state: 'MG' },
    { code: '3142106', name: "Miradouro", state: 'MG' },
    { code: '3142205', name: "Miraí", state: 'MG' },
    { code: '3142254', name: "Miravânia", state: 'MG' },
    { code: '3142304', name: "Moeda", state: 'MG' },
    { code: '3142403', name: "Moema", state: 'MG' },
    { code: '3142502', name: "Monjolos", state: 'MG' },
    { code: '3142601', name: "Monsenhor Paulo", state: 'MG' },
    { code: '3142700', name: "Montalvânia", state: 'MG' },
    { code: '3142809', name: "Monte Alegre de Minas", state: 'MG' },
    { code: '3142908', name: "Monte Azul", state: 'MG' },
    { code: '3143005', name: "Monte Belo", state: 'MG' },
    { code: '3143104', name: "Monte Carmelo", state: 'MG' },
    { code: '3143153', name: "Monte Formoso", state: 'MG' },
    { code: '3143203', name: "Monte Santo de Minas", state: 'MG' },
    { code: '3143401', name: "Monte Sião", state: 'MG' },
    { code: '3143302', name: "Montes Claros", state: 'MG' },
    { code: '3143450', name: "Montezuma", state: 'MG' },
    { code: '3143500', name: "Morada Nova de Minas", state: 'MG' },
    { code: '3143609', name: "Morro da Garça", state: 'MG' },
    { code: '3143708', name: "Morro do Pilar", state: 'MG' },
    { code: '3143807', name: "Munhoz", state: 'MG' },
    { code: '3143906', name: "Muriaé", state: 'MG' },
    { code: '3144003', name: "Mutum", state: 'MG' },
    { code: '3144102', name: "Muzambinho", state: 'MG' },
    { code: '3144201', name: "Nacip Raydan", state: 'MG' },
    { code: '3144300', name: "Nanuque", state: 'MG' },
    { code: '3144359', name: "Naque", state: 'MG' },
    { code: '3144375', name: "Natalândia", state: 'MG' },
    { code: '3144409', name: "Natércia", state: 'MG' },
    { code: '3144508', name: "Nazareno", state: 'MG' },
    { code: '3144607', name: "Nepomuceno", state: 'MG' },
    { code: '3144656', name: "Ninheira", state: 'MG' },
    { code: '3144672', name: "Nova Belém", state: 'MG' },
    { code: '3144706', name: "Nova Era", state: 'MG' },
    { code: '3144805', name: "Nova Lima", state: 'MG' },
    { code: '3144904', name: "Nova Módica", state: 'MG' },
    { code: '3145000', name: "Nova Ponte", state: 'MG' },
    { code: '3145059', name: "Nova Porteirinha", state: 'MG' },
    { code: '3145109', name: "Nova Resende", state: 'MG' },
    { code: '3145208', name: "Nova Serrana", state: 'MG' },
    { code: '3136603', name: "Nova União", state: 'MG' },
    { code: '3145307', name: "Novo Cruzeiro", state: 'MG' },
    { code: '3145356', name: "Novo Oriente de Minas", state: 'MG' },
    { code: '3145372', name: "Novorizonte", state: 'MG' },
    { code: '3145406', name: "Olaria", state: 'MG' },
    { code: '3145455', name: "Olhos-d'Água", state: 'MG' },
    { code: '3145505', name: "Olímpio Noronha", state: 'MG' },
    { code: '3145604', name: "Oliveira", state: 'MG' },
    { code: '3145703', name: "Oliveira Fortes", state: 'MG' },
    { code: '3145802', name: "Onça de Pitangui", state: 'MG' },
    { code: '3145851', name: "Oratórios", state: 'MG' },
    { code: '3145877', name: "Orizânia", state: 'MG' },
    { code: '3145901', name: "Ouro Branco", state: 'MG' },
    { code: '3146008', name: "Ouro Fino", state: 'MG' },
    { code: '3146107', name: "Ouro Preto", state: 'MG' },
    { code: '3146206', name: "Ouro Verde de Minas", state: 'MG' },
    { code: '3146255', name: "Padre Carvalho", state: 'MG' },
    { code: '3146305', name: "Padre Paraíso", state: 'MG' },
    { code: '3146552', name: "Pai Pedro", state: 'MG' },
    { code: '3146404', name: "Paineiras", state: 'MG' },
    { code: '3146503', name: "Pains", state: 'MG' },
    { code: '3146602', name: "Paiva", state: 'MG' },
    { code: '3146701', name: "Palma", state: 'MG' },
    { code: '3146750', name: "Palmópolis", state: 'MG' },
    { code: '3146909', name: "Papagaios", state: 'MG' },
    { code: '3147105', name: "Pará de Minas", state: 'MG' },
    { code: '3147006', name: "Paracatu", state: 'MG' },
    { code: '3147204', name: "Paraguaçu", state: 'MG' },
    { code: '3147303', name: "Paraisópolis", state: 'MG' },
    { code: '3147402', name: "Paraopeba", state: 'MG' },
    { code: '3147600', name: "Passa Quatro", state: 'MG' },
    { code: '3147709', name: "Passa Tempo", state: 'MG' },
    { code: '3147808', name: "Passa Vinte", state: 'MG' },
    { code: '3147501', name: "Passabém", state: 'MG' },
    { code: '3147907', name: "Passos", state: 'MG' },
    { code: '3147956', name: "Patis", state: 'MG' },
    { code: '3148004', name: "Patos de Minas", state: 'MG' },
    { code: '3148103', name: "Patrocínio", state: 'MG' },
    { code: '3148202', name: "Patrocínio do Muriaé", state: 'MG' },
    { code: '3148301', name: "Paula Cândido", state: 'MG' },
    { code: '3148400', name: "Paulistas", state: 'MG' },
    { code: '3148509', name: "Pavão", state: 'MG' },
    { code: '3148608', name: "Peçanha", state: 'MG' },
    { code: '3148707', name: "Pedra Azul", state: 'MG' },
    { code: '3148756', name: "Pedra Bonita", state: 'MG' },
    { code: '3148806', name: "Pedra do Anta", state: 'MG' },
    { code: '3148905', name: "Pedra do Indaiá", state: 'MG' },
    { code: '3149002', name: "Pedra Dourada", state: 'MG' },
    { code: '3149101', name: "Pedralva", state: 'MG' },
    { code: '3149150', name: "Pedras de Maria da Cruz", state: 'MG' },
    { code: '3149200', name: "Pedrinópolis", state: 'MG' },
    { code: '3149309', name: "Pedro Leopoldo", state: 'MG' },
    { code: '3149408', name: "Pedro Teixeira", state: 'MG' },
    { code: '3149507', name: "Pequeri", state: 'MG' },
    { code: '3149606', name: "Pequi", state: 'MG' },
    { code: '3149705', name: "Perdigão", state: 'MG' },
    { code: '3149804', name: "Perdizes", state: 'MG' },
    { code: '3149903', name: "Perdões", state: 'MG' },
    { code: '3149952', name: "Periquito", state: 'MG' },
    { code: '3150000', name: "Pescador", state: 'MG' },
    { code: '3150109', name: "Piau", state: 'MG' },
    { code: '3150158', name: "Piedade de Caratinga", state: 'MG' },
    { code: '3150208', name: "Piedade de Ponte Nova", state: 'MG' },
    { code: '3150307', name: "Piedade do Rio Grande", state: 'MG' },
    { code: '3150406', name: "Piedade dos Gerais", state: 'MG' },
    { code: '3150505', name: "Pimenta", state: 'MG' },
    { code: '3150539', name: "Pingo-d'Água", state: 'MG' },
    { code: '3150570', name: "Pintópolis", state: 'MG' },
    { code: '3150604', name: "Piracema", state: 'MG' },
    { code: '3150703', name: "Pirajuba", state: 'MG' },
    { code: '3150802', name: "Piranga", state: 'MG' },
    { code: '3150901', name: "Piranguçu", state: 'MG' },
    { code: '3151008', name: "Piranguinho", state: 'MG' },
    { code: '3151107', name: "Pirapetinga", state: 'MG' },
    { code: '3151206', name: "Pirapora", state: 'MG' },
    { code: '3151305', name: "Piraúba", state: 'MG' },
    { code: '3151404', name: "Pitangui", state: 'MG' },
    { code: '3151503', name: "Piumhi", state: 'MG' },
    { code: '3151602', name: "Planura", state: 'MG' },
    { code: '3151701', name: "Poço Fundo", state: 'MG' },
    { code: '3151800', name: "Poços de Caldas", state: 'MG' },
    { code: '3151909', name: "Pocrane", state: 'MG' },
    { code: '3152006', name: "Pompéu", state: 'MG' },
    { code: '3152105', name: "Ponte Nova", state: 'MG' },
    { code: '3152131', name: "Ponto Chique", state: 'MG' },
    { code: '3152170', name: "Ponto dos Volantes", state: 'MG' },
    { code: '3152204', name: "Porteirinha", state: 'MG' },
    { code: '3152303', name: "Porto Firme", state: 'MG' },
    { code: '3152402', name: "Poté", state: 'MG' },
    { code: '3152501', name: "Pouso Alegre", state: 'MG' },
    { code: '3152600', name: "Pouso Alto", state: 'MG' },
    { code: '3152709', name: "Prados", state: 'MG' },
    { code: '3152808', name: "Prata", state: 'MG' },
    { code: '3152907', name: "Pratápolis", state: 'MG' },
    { code: '3153004', name: "Pratinha", state: 'MG' },
    { code: '3153103', name: "Presidente Bernardes", state: 'MG' },
    { code: '3153202', name: "Presidente Juscelino", state: 'MG' },
    { code: '3153301', name: "Presidente Kubitschek", state: 'MG' },
    { code: '3153400', name: "Presidente Olegário", state: 'MG' },
    { code: '3153608', name: "Prudente de Morais", state: 'MG' },
    { code: '3153707', name: "Quartel Geral", state: 'MG' },
    { code: '3153806', name: "Queluzito", state: 'MG' },
    { code: '3153905', name: "Raposos", state: 'MG' },
    { code: '3154002', name: "Raul Soares", state: 'MG' },
    { code: '3154101', name: "Recreio", state: 'MG' },
    { code: '3154150', name: "Reduto", state: 'MG' },
    { code: '3154200', name: "Resende Costa", state: 'MG' },
    { code: '3154309', name: "Resplendor", state: 'MG' },
    { code: '3154408', name: "Ressaquinha", state: 'MG' },
    { code: '3154457', name: "Riachinho", state: 'MG' },
    { code: '3154507', name: "Riacho dos Machados", state: 'MG' },
    { code: '3154606', name: "Ribeirão das Neves", state: 'MG' },
    { code: '3154705', name: "Ribeirão Vermelho", state: 'MG' },
    { code: '3154804', name: "Rio Acima", state: 'MG' },
    { code: '3154903', name: "Rio Casca", state: 'MG' },
    { code: '3155108', name: "Rio do Prado", state: 'MG' },
    { code: '3155009', name: "Rio Doce", state: 'MG' },
    { code: '3155207', name: "Rio Espera", state: 'MG' },
    { code: '3155306', name: "Rio Manso", state: 'MG' },
    { code: '3155405', name: "Rio Novo", state: 'MG' },
    { code: '3155504', name: "Rio Paranaíba", state: 'MG' },
    { code: '3155603', name: "Rio Pardo de Minas", state: 'MG' },
    { code: '3155702', name: "Rio Piracicaba", state: 'MG' },
    { code: '3155801', name: "Rio Pomba", state: 'MG' },
    { code: '3155900', name: "Rio Preto", state: 'MG' },
    { code: '3156007', name: "Rio Vermelho", state: 'MG' },
    { code: '3156106', name: "Ritápolis", state: 'MG' },
    { code: '3156205', name: "Rochedo de Minas", state: 'MG' },
    { code: '3156304', name: "Rodeiro", state: 'MG' },
    { code: '3156403', name: "Romaria", state: 'MG' },
    { code: '3156452', name: "Rosário da Limeira", state: 'MG' },
    { code: '3156502', name: "Rubelita", state: 'MG' },
    { code: '3156601', name: "Rubim", state: 'MG' },
    { code: '3156700', name: "Sabará", state: 'MG' },
    { code: '3156809', name: "Sabinópolis", state: 'MG' },
    { code: '3156908', name: "Sacramento", state: 'MG' },
    { code: '3157005', name: "Salinas", state: 'MG' },
    { code: '3157104', name: "Salto da Divisa", state: 'MG' },
    { code: '3157203', name: "Santa Bárbara", state: 'MG' },
    { code: '3157252', name: "Santa Bárbara do Leste", state: 'MG' },
    { code: '3157278', name: "Santa Bárbara do Monte Verde", state: 'MG' },
    { code: '3157302', name: "Santa Bárbara do Tugúrio", state: 'MG' },
    { code: '3157336', name: "Santa Cruz de Minas", state: 'MG' },
    { code: '3157377', name: "Santa Cruz de Salinas", state: 'MG' },
    { code: '3157401', name: "Santa Cruz do Escalvado", state: 'MG' },
    { code: '3157500', name: "Santa Efigênia de Minas", state: 'MG' },
    { code: '3157609', name: "Santa Fé de Minas", state: 'MG' },
    { code: '3157658', name: "Santa Helena de Minas", state: 'MG' },
    { code: '3157708', name: "Santa Juliana", state: 'MG' },
    { code: '3157807', name: "Santa Luzia", state: 'MG' },
    { code: '3157906', name: "Santa Margarida", state: 'MG' },
    { code: '3158003', name: "Santa Maria de Itabira", state: 'MG' },
    { code: '3158102', name: "Santa Maria do Salto", state: 'MG' },
    { code: '3158201', name: "Santa Maria do Suaçuí", state: 'MG' },
    { code: '3159209', name: "Santa Rita de Caldas", state: 'MG' },
    { code: '3159407', name: "Santa Rita de Ibitipoca", state: 'MG' },
    { code: '3159308', name: "Santa Rita de Jacutinga", state: 'MG' },
    { code: '3159357', name: "Santa Rita de Minas", state: 'MG' },
    { code: '3159506', name: "Santa Rita do Itueto", state: 'MG' },
    { code: '3159605', name: "Santa Rita do Sapucaí", state: 'MG' },
    { code: '3159704', name: "Santa Rosa da Serra", state: 'MG' },
    { code: '3159803', name: "Santa Vitória", state: 'MG' },
    { code: '3158300', name: "Santana da Vargem", state: 'MG' },
    { code: '3158409', name: "Santana de Cataguases", state: 'MG' },
    { code: '3158508', name: "Santana de Pirapama", state: 'MG' },
    { code: '3158607', name: "Santana do Deserto", state: 'MG' },
    { code: '3158706', name: "Santana do Garambéu", state: 'MG' },
    { code: '3158805', name: "Santana do Jacaré", state: 'MG' },
    { code: '3158904', name: "Santana do Manhuaçu", state: 'MG' },
    { code: '3158953', name: "Santana do Paraíso", state: 'MG' },
    { code: '3159001', name: "Santana do Riacho", state: 'MG' },
    { code: '3159100', name: "Santana dos Montes", state: 'MG' },
    { code: '3159902', name: "Santo Antônio do Amparo", state: 'MG' },
    { code: '3160009', name: "Santo Antônio do Aventureiro", state: 'MG' },
    { code: '3160108', name: "Santo Antônio do Grama", state: 'MG' },
    { code: '3160207', name: "Santo Antônio do Itambé", state: 'MG' },
    { code: '3160306', name: "Santo Antônio do Jacinto", state: 'MG' },
    { code: '3160405', name: "Santo Antônio do Monte", state: 'MG' },
    { code: '3160454', name: "Santo Antônio do Retiro", state: 'MG' },
    { code: '3160504', name: "Santo Antônio do Rio Abaixo", state: 'MG' },
    { code: '3160603', name: "Santo Hipólito", state: 'MG' },
    { code: '3160702', name: "Santos Dumont", state: 'MG' },
    { code: '3160801', name: "São Bento Abade", state: 'MG' },
    { code: '3160900', name: "São Brás do Suaçuí", state: 'MG' },
    { code: '3160959', name: "São Domingos das Dores", state: 'MG' },
    { code: '3161007', name: "São Domingos do Prata", state: 'MG' },
    { code: '3161056', name: "São Félix de Minas", state: 'MG' },
    { code: '3161106', name: "São Francisco", state: 'MG' },
    { code: '3161205', name: "São Francisco de Paula", state: 'MG' },
    { code: '3161304', name: "São Francisco de Sales", state: 'MG' },
    { code: '3161403', name: "São Francisco do Glória", state: 'MG' },
    { code: '3161502', name: "São Geraldo", state: 'MG' },
    { code: '3161601', name: "São Geraldo da Piedade", state: 'MG' },
    { code: '3161650', name: "São Geraldo do Baixio", state: 'MG' },
    { code: '3161700', name: "São Gonçalo do Abaeté", state: 'MG' },
    { code: '3161809', name: "São Gonçalo do Pará", state: 'MG' },
    { code: '3161908', name: "São Gonçalo do Rio Abaixo", state: 'MG' },
    { code: '3125507', name: "São Gonçalo do Rio Preto", state: 'MG' },
    { code: '3162005', name: "São Gonçalo do Sapucaí", state: 'MG' },
    { code: '3162104', name: "São Gotardo", state: 'MG' },
    { code: '3162203', name: "São João Batista do Glória", state: 'MG' },
    { code: '3162252', name: "São João da Lagoa", state: 'MG' },
    { code: '3162302', name: "São João da Mata", state: 'MG' },
    { code: '3162401', name: "São João da Ponte", state: 'MG' },
    { code: '3162450', name: "São João das Missões", state: 'MG' },
    { code: '3162500', name: "São João del Rei", state: 'MG' },
    { code: '3162559', name: "São João do Manhuaçu", state: 'MG' },
    { code: '3162575', name: "São João do Manteninha", state: 'MG' },
    { code: '3162609', name: "São João do Oriente", state: 'MG' },
    { code: '3162658', name: "São João do Pacuí", state: 'MG' },
    { code: '3162708', name: "São João do Paraíso", state: 'MG' },
    { code: '3162807', name: "São João Evangelista", state: 'MG' },
    { code: '3162906', name: "São João Nepomuceno", state: 'MG' },
    { code: '3162922', name: "São Joaquim de Bicas", state: 'MG' },
    { code: '3162948', name: "São José da Barra", state: 'MG' },
    { code: '3162955', name: "São José da Lapa", state: 'MG' },
    { code: '3163003', name: "São José da Safira", state: 'MG' },
    { code: '3163102', name: "São José da Varginha", state: 'MG' },
    { code: '3163201', name: "São José do Alegre", state: 'MG' },
    { code: '3163300', name: "São José do Divino", state: 'MG' },
    { code: '3163409', name: "São José do Goiabal", state: 'MG' },
    { code: '3163508', name: "São José do Jacuri", state: 'MG' },
    { code: '3163607', name: "São José do Mantimento", state: 'MG' },
    { code: '3163706', name: "São Lourenço", state: 'MG' },
    { code: '3163805', name: "São Miguel do Anta", state: 'MG' },
    { code: '3163904', name: "São Pedro da União", state: 'MG' },
    { code: '3164100', name: "São Pedro do Suaçuí", state: 'MG' },
    { code: '3164001', name: "São Pedro dos Ferros", state: 'MG' },
    { code: '3164209', name: "São Romão", state: 'MG' },
    { code: '3164308', name: "São Roque de Minas", state: 'MG' },
    { code: '3164407', name: "São Sebastião da Bela Vista", state: 'MG' },
    { code: '3164431', name: "São Sebastião da Vargem Alegre", state: 'MG' },
    { code: '3164472', name: "São Sebastião do Anta", state: 'MG' },
    { code: '3164506', name: "São Sebastião do Maranhão", state: 'MG' },
    { code: '3164605', name: "São Sebastião do Oeste", state: 'MG' },
    { code: '3164704', name: "São Sebastião do Paraíso", state: 'MG' },
    { code: '3164803', name: "São Sebastião do Rio Preto", state: 'MG' },
    { code: '3164902', name: "São Sebastião do Rio Verde", state: 'MG' },
    { code: '3165008', name: "São Tiago", state: 'MG' },
    { code: '3165107', name: "São Tomás de Aquino", state: 'MG' },
    { code: '3165206', name: "São Tomé das Letras", state: 'MG' },
    { code: '3165305', name: "São Vicente de Minas", state: 'MG' },
    { code: '3165404', name: "Sapucaí-Mirim", state: 'MG' },
    { code: '3165503', name: "Sardoá", state: 'MG' },
    { code: '3165537', name: "Sarzedo", state: 'MG' },
    { code: '3165560', name: "Sem-Peixe", state: 'MG' },
    { code: '3165578', name: "Senador Amaral", state: 'MG' },
    { code: '3165602', name: "Senador Cortes", state: 'MG' },
    { code: '3165701', name: "Senador Firmino", state: 'MG' },
    { code: '3165800', name: "Senador José Bento", state: 'MG' },
    { code: '3165909', name: "Senador Modestino Gonçalves", state: 'MG' },
    { code: '3166006', name: "Senhora de Oliveira", state: 'MG' },
    { code: '3166105', name: "Senhora do Porto", state: 'MG' },
    { code: '3166204', name: "Senhora dos Remédios", state: 'MG' },
    { code: '3166303', name: "Sericita", state: 'MG' },
    { code: '3166402', name: "Seritinga", state: 'MG' },
    { code: '3166501', name: "Serra Azul de Minas", state: 'MG' },
    { code: '3166600', name: "Serra da Saudade", state: 'MG' },
    { code: '3166808', name: "Serra do Salitre", state: 'MG' },
    { code: '3166709', name: "Serra dos Aimorés", state: 'MG' },
    { code: '3166907', name: "Serrania", state: 'MG' },
    { code: '3166956', name: "Serranópolis de Minas", state: 'MG' },
    { code: '3167004', name: "Serranos", state: 'MG' },
    { code: '3167103', name: "Serro", state: 'MG' },
    { code: '3167202', name: "Sete Lagoas", state: 'MG' },
    { code: '3165552', name: "Setubinha", state: 'MG' },
    { code: '3167301', name: "Silveirânia", state: 'MG' },
    { code: '3167400', name: "Silvianópolis", state: 'MG' },
    { code: '3167509', name: "Simão Pereira", state: 'MG' },
    { code: '3167608', name: "Simonésia", state: 'MG' },
    { code: '3167707', name: "Sobrália", state: 'MG' },
    { code: '3167806', name: "Soledade de Minas", state: 'MG' },
    { code: '3167905', name: "Tabuleiro", state: 'MG' },
    { code: '3168002', name: "Taiobeiras", state: 'MG' },
    { code: '3168051', name: "Taparuba", state: 'MG' },
    { code: '3168101', name: "Tapira", state: 'MG' },
    { code: '3168200', name: "Tapiraí", state: 'MG' },
    { code: '3168309', name: "Taquaraçu de Minas", state: 'MG' },
    { code: '3168408', name: "Tarumirim", state: 'MG' },
    { code: '3168507', name: "Teixeiras", state: 'MG' },
    { code: '3168606', name: "Teófilo Otoni", state: 'MG' },
    { code: '3168705', name: "Timóteo", state: 'MG' },
    { code: '3168804', name: "Tiradentes", state: 'MG' },
    { code: '3168903', name: "Tiros", state: 'MG' },
    { code: '3169000', name: "Tocantins", state: 'MG' },
    { code: '3169059', name: "Tocos do Moji", state: 'MG' },
    { code: '3169109', name: "Toledo", state: 'MG' },
    { code: '3169208', name: "Tombos", state: 'MG' },
    { code: '3169307', name: "Três Corações", state: 'MG' },
    { code: '3169356', name: "Três Marias", state: 'MG' },
    { code: '3169406', name: "Três Pontas", state: 'MG' },
    { code: '3169505', name: "Tumiritinga", state: 'MG' },
    { code: '3169604', name: "Tupaciguara", state: 'MG' },
    { code: '3169703', name: "Turmalina", state: 'MG' },
    { code: '3169802', name: "Turvolândia", state: 'MG' },
    { code: '3169901', name: "Ubá", state: 'MG' },
    { code: '3170008', name: "Ubaí", state: 'MG' },
    { code: '3170057', name: "Ubaporanga", state: 'MG' },
    { code: '3170107', name: "Uberaba", state: 'MG' },
    { code: '3170206', name: "Uberlândia", state: 'MG' },
    { code: '3170305', name: "Umburatiba", state: 'MG' },
    { code: '3170404', name: "Unaí", state: 'MG' },
    { code: '3170438', name: "União de Minas", state: 'MG' },
    { code: '3170479', name: "Uruana de Minas", state: 'MG' },
    { code: '3170503', name: "Urucânia", state: 'MG' },
    { code: '3170529', name: "Urucuia", state: 'MG' },
    { code: '3170578', name: "Vargem Alegre", state: 'MG' },
    { code: '3170602', name: "Vargem Bonita", state: 'MG' },
    { code: '3170651', name: "Vargem Grande do Rio Pardo", state: 'MG' },
    { code: '3170701', name: "Varginha", state: 'MG' },
    { code: '3170750', name: "Varjão de Minas", state: 'MG' },
    { code: '3170800', name: "Várzea da Palma", state: 'MG' },
    { code: '3170909', name: "Varzelândia", state: 'MG' },
    { code: '3171006', name: "Vazante", state: 'MG' },
    { code: '3171030', name: "Verdelândia", state: 'MG' },
    { code: '3171071', name: "Veredinha", state: 'MG' },
    { code: '3171105', name: "Veríssimo", state: 'MG' },
    { code: '3171154', name: "Vermelho Novo", state: 'MG' },
    { code: '3171204', name: "Vespasiano", state: 'MG' },
    { code: '3171303', name: "Viçosa", state: 'MG' },
    { code: '3171402', name: "Vieiras", state: 'MG' },
    { code: '3171600', name: "Virgem da Lapa", state: 'MG' },
    { code: '3171709', name: "Virgínia", state: 'MG' },
    { code: '3171808', name: "Virginópolis", state: 'MG' },
    { code: '3171907', name: "Virgolândia", state: 'MG' },
    { code: '3172004', name: "Visconde do Rio Branco", state: 'MG' },
    { code: '3172103', name: "Volta Grande", state: 'MG' },
    { code: '3172202', name: "Wenceslau Braz", state: 'MG' }
  ],

  // MATO GROSSO DO SUL (MS) - 79 municípios
  MS: [
    { code: '5000203', name: "Água Clara", state: 'MS' },
    { code: '5000252', name: "Alcinópolis", state: 'MS' },
    { code: '5000609', name: "Amambai", state: 'MS' },
    { code: '5000708', name: "Anastácio", state: 'MS' },
    { code: '5000807', name: "Anaurilândia", state: 'MS' },
    { code: '5000856', name: "Angélica", state: 'MS' },
    { code: '5000906', name: "Antônio João", state: 'MS' },
    { code: '5001003', name: "Aparecida do Taboado", state: 'MS' },
    { code: '5001102', name: "Aquidauana", state: 'MS' },
    { code: '5001243', name: "Aral Moreira", state: 'MS' },
    { code: '5001508', name: "Bandeirantes", state: 'MS' },
    { code: '5001904', name: "Bataguassu", state: 'MS' },
    { code: '5002001', name: "Batayporã", state: 'MS' },
    { code: '5002100', name: "Bela Vista", state: 'MS' },
    { code: '5002159', name: "Bodoquena", state: 'MS' },
    { code: '5002209', name: "Bonito", state: 'MS' },
    { code: '5002308', name: "Brasilândia", state: 'MS' },
    { code: '5002407', name: "Caarapó", state: 'MS' },
    { code: '5002605', name: "Camapuã", state: 'MS' },
    { code: '5002704', name: "Campo Grande", state: 'MS' },
    { code: '5002803', name: "Caracol", state: 'MS' },
    { code: '5002902', name: "Cassilândia", state: 'MS' },
    { code: '5002951', name: "Chapadão do Sul", state: 'MS' },
    { code: '5003108', name: "Corguinho", state: 'MS' },
    { code: '5003157', name: "Coronel Sapucaia", state: 'MS' },
    { code: '5003207', name: "Corumbá", state: 'MS' },
    { code: '5003256', name: "Costa Rica", state: 'MS' },
    { code: '5003306', name: "Coxim", state: 'MS' },
    { code: '5003454', name: "Deodápolis", state: 'MS' },
    { code: '5003488', name: "Dois Irmãos do Buriti", state: 'MS' },
    { code: '5003504', name: "Douradina", state: 'MS' },
    { code: '5003702', name: "Dourados", state: 'MS' },
    { code: '5003751', name: "Eldorado", state: 'MS' },
    { code: '5003801', name: "Fátima do Sul", state: 'MS' },
    { code: '5003900', name: "Figueirão", state: 'MS' },
    { code: '5004007', name: "Glória de Dourados", state: 'MS' },
    { code: '5004106', name: "Guia Lopes da Laguna", state: 'MS' },
    { code: '5004304', name: "Iguatemi", state: 'MS' },
    { code: '5004403', name: "Inocência", state: 'MS' },
    { code: '5004502', name: "Itaporã", state: 'MS' },
    { code: '5004601', name: "Itaquiraí", state: 'MS' },
    { code: '5004700', name: "Ivinhema", state: 'MS' },
    { code: '5004809', name: "Japorã", state: 'MS' },
    { code: '5004908', name: "Jaraguari", state: 'MS' },
    { code: '5005004', name: "Jardim", state: 'MS' },
    { code: '5005103', name: "Jateí", state: 'MS' },
    { code: '5005152', name: "Juti", state: 'MS' },
    { code: '5005202', name: "Ladário", state: 'MS' },
    { code: '5005251', name: "Laguna Carapã", state: 'MS' },
    { code: '5005400', name: "Maracaju", state: 'MS' },
    { code: '5005608', name: "Miranda", state: 'MS' },
    { code: '5005681', name: "Mundo Novo", state: 'MS' },
    { code: '5005707', name: "Naviraí", state: 'MS' },
    { code: '5005806', name: "Nioaque", state: 'MS' },
    { code: '5006002', name: "Nova Alvorada do Sul", state: 'MS' },
    { code: '5006200', name: "Nova Andradina", state: 'MS' },
    { code: '5006259', name: "Novo Horizonte do Sul", state: 'MS' },
    { code: '5006275', name: "Paraíso das Águas", state: 'MS' },
    { code: '5006309', name: "Paranaíba", state: 'MS' },
    { code: '5006358', name: "Paranhos", state: 'MS' },
    { code: '5006408', name: "Pedro Gomes", state: 'MS' },
    { code: '5006606', name: "Ponta Porã", state: 'MS' },
    { code: '5006903', name: "Porto Murtinho", state: 'MS' },
    { code: '5007109', name: "Ribas do Rio Pardo", state: 'MS' },
    { code: '5007208', name: "Rio Brilhante", state: 'MS' },
    { code: '5007307', name: "Rio Negro", state: 'MS' },
    { code: '5007406', name: "Rio Verde de Mato Grosso", state: 'MS' },
    { code: '5007505', name: "Rochedo", state: 'MS' },
    { code: '5007554', name: "Santa Rita do Pardo", state: 'MS' },
    { code: '5007695', name: "São Gabriel do Oeste", state: 'MS' },
    { code: '5007802', name: "Selvíria", state: 'MS' },
    { code: '5007703', name: "Sete Quedas", state: 'MS' },
    { code: '5007901', name: "Sidrolândia", state: 'MS' },
    { code: '5007935', name: "Sonora", state: 'MS' },
    { code: '5007950', name: "Tacuru", state: 'MS' },
    { code: '5007976', name: "Taquarussu", state: 'MS' },
    { code: '5008008', name: "Terenos", state: 'MS' },
    { code: '5008305', name: "Três Lagoas", state: 'MS' },
    { code: '5008404', name: "Vicentina", state: 'MS' }
  ],

  // MATO GROSSO (MT) - 141 municípios
  MT: [
    { code: '5100102', name: "Acorizal", state: 'MT' },
    { code: '5100201', name: "Água Boa", state: 'MT' },
    { code: '5100250', name: "Alta Floresta", state: 'MT' },
    { code: '5100300', name: "Alto Araguaia", state: 'MT' },
    { code: '5100359', name: "Alto Boa Vista", state: 'MT' },
    { code: '5100409', name: "Alto Garças", state: 'MT' },
    { code: '5100508', name: "Alto Paraguai", state: 'MT' },
    { code: '5100607', name: "Alto Taquari", state: 'MT' },
    { code: '5100805', name: "Apiacás", state: 'MT' },
    { code: '5101001', name: "Araguaiana", state: 'MT' },
    { code: '5101209', name: "Araguainha", state: 'MT' },
    { code: '5101258', name: "Araputanga", state: 'MT' },
    { code: '5101308', name: "Arenápolis", state: 'MT' },
    { code: '5101407', name: "Aripuanã", state: 'MT' },
    { code: '5101605', name: "Barão de Melgaço", state: 'MT' },
    { code: '5101704', name: "Barra do Bugres", state: 'MT' },
    { code: '5101803', name: "Barra do Garças", state: 'MT' },
    { code: '5101852', name: "Bom Jesus do Araguaia", state: 'MT' },
    { code: '5101902', name: "Brasnorte", state: 'MT' },
    { code: '5102504', name: "Cáceres", state: 'MT' },
    { code: '5102603', name: "Campinápolis", state: 'MT' },
    { code: '5102637', name: "Campo Novo do Parecis", state: 'MT' },
    { code: '5102678', name: "Campo Verde", state: 'MT' },
    { code: '5102686', name: "Campos de Júlio", state: 'MT' },
    { code: '5102694', name: "Canabrava do Norte", state: 'MT' },
    { code: '5102702', name: "Canarana", state: 'MT' },
    { code: '5102793', name: "Carlinda", state: 'MT' },
    { code: '5102850', name: "Castanheira", state: 'MT' },
    { code: '5103007', name: "Chapada dos Guimarães", state: 'MT' },
    { code: '5103056', name: "Cláudia", state: 'MT' },
    { code: '5103106', name: "Cocalinho", state: 'MT' },
    { code: '5103205', name: "Colíder", state: 'MT' },
    { code: '5103254', name: "Colniza", state: 'MT' },
    { code: '5103304', name: "Comodoro", state: 'MT' },
    { code: '5103353', name: "Confresa", state: 'MT' },
    { code: '5103361', name: "Conquista D'Oeste", state: 'MT' },
    { code: '5103379', name: "Cotriguaçu", state: 'MT' },
    { code: '5103403', name: "Cuiabá", state: 'MT' },
    { code: '5103437', name: "Curvelândia", state: 'MT' },
    { code: '5103452', name: "Denise", state: 'MT' },
    { code: '5103502', name: "Diamantino", state: 'MT' },
    { code: '5103601', name: "Dom Aquino", state: 'MT' },
    { code: '5103700', name: "Feliz Natal", state: 'MT' },
    { code: '5103809', name: "Figueirópolis D'Oeste", state: 'MT' },
    { code: '5103858', name: "Gaúcha do Norte", state: 'MT' },
    { code: '5103908', name: "General Carneiro", state: 'MT' },
    { code: '5103957', name: "Glória D'Oeste", state: 'MT' },
    { code: '5104104', name: "Guarantã do Norte", state: 'MT' },
    { code: '5104203', name: "Guiratinga", state: 'MT' },
    { code: '5104500', name: "Indiavaí", state: 'MT' },
    { code: '5104526', name: "Ipiranga do Norte", state: 'MT' },
    { code: '5104542', name: "Itanhangá", state: 'MT' },
    { code: '5104559', name: "Itaúba", state: 'MT' },
    { code: '5104609', name: "Itiquira", state: 'MT' },
    { code: '5104807', name: "Jaciara", state: 'MT' },
    { code: '5104906', name: "Jangada", state: 'MT' },
    { code: '5105002', name: "Jauru", state: 'MT' },
    { code: '5105101', name: "Juara", state: 'MT' },
    { code: '5105150', name: "Juína", state: 'MT' },
    { code: '5105176', name: "Juruena", state: 'MT' },
    { code: '5105200', name: "Juscimeira", state: 'MT' },
    { code: '5105234', name: "Lambari D'Oeste", state: 'MT' },
    { code: '5105259', name: "Lucas do Rio Verde", state: 'MT' },
    { code: '5105309', name: "Luciara", state: 'MT' },
    { code: '5105580', name: "Marcelândia", state: 'MT' },
    { code: '5105606', name: "Matupá", state: 'MT' },
    { code: '5105622', name: "Mirassol d'Oeste", state: 'MT' },
    { code: '5105903', name: "Nobres", state: 'MT' },
    { code: '5106000', name: "Nortelândia", state: 'MT' },
    { code: '5106109', name: "Nossa Senhora do Livramento", state: 'MT' },
    { code: '5106158', name: "Nova Bandeirantes", state: 'MT' },
    { code: '5106208', name: "Nova Brasilândia", state: 'MT' },
    { code: '5106216', name: "Nova Canaã do Norte", state: 'MT' },
    { code: '5108808', name: "Nova Guarita", state: 'MT' },
    { code: '5106182', name: "Nova Lacerda", state: 'MT' },
    { code: '5108857', name: "Nova Marilândia", state: 'MT' },
    { code: '5108907', name: "Nova Maringá", state: 'MT' },
    { code: '5108956', name: "Nova Monte Verde", state: 'MT' },
    { code: '5106224', name: "Nova Mutum", state: 'MT' },
    { code: '5106174', name: "Nova Nazaré", state: 'MT' },
    { code: '5106232', name: "Nova Olímpia", state: 'MT' },
    { code: '5106190', name: "Nova Santa Helena", state: 'MT' },
    { code: '5106240', name: "Nova Ubiratã", state: 'MT' },
    { code: '5106257', name: "Nova Xavantina", state: 'MT' },
    { code: '5106273', name: "Novo Horizonte do Norte", state: 'MT' },
    { code: '5106265', name: "Novo Mundo", state: 'MT' },
    { code: '5106315', name: "Novo Santo Antônio", state: 'MT' },
    { code: '5106281', name: "Novo São Joaquim", state: 'MT' },
    { code: '5106299', name: "Paranaíta", state: 'MT' },
    { code: '5106307', name: "Paranatinga", state: 'MT' },
    { code: '5106372', name: "Pedra Preta", state: 'MT' },
    { code: '5106422', name: "Peixoto de Azevedo", state: 'MT' },
    { code: '5106455', name: "Planalto da Serra", state: 'MT' },
    { code: '5106505', name: "Poconé", state: 'MT' },
    { code: '5106653', name: "Pontal do Araguaia", state: 'MT' },
    { code: '5106703', name: "Ponte Branca", state: 'MT' },
    { code: '5106752', name: "Pontes e Lacerda", state: 'MT' },
    { code: '5106778', name: "Porto Alegre do Norte", state: 'MT' },
    { code: '5106802', name: "Porto dos Gaúchos", state: 'MT' },
    { code: '5106828', name: "Porto Esperidião", state: 'MT' },
    { code: '5106851', name: "Porto Estrela", state: 'MT' },
    { code: '5107008', name: "Poxoréu", state: 'MT' },
    { code: '5107040', name: "Primavera do Leste", state: 'MT' },
    { code: '5107065', name: "Querência", state: 'MT' },
    { code: '5107156', name: "Reserva do Cabaçal", state: 'MT' },
    { code: '5107180', name: "Ribeirão Cascalheira", state: 'MT' },
    { code: '5107198', name: "Ribeirãozinho", state: 'MT' },
    { code: '5107206', name: "Rio Branco", state: 'MT' },
    { code: '5107578', name: "Rondolândia", state: 'MT' },
    { code: '5107602', name: "Rondonópolis", state: 'MT' },
    { code: '5107701', name: "Rosário Oeste", state: 'MT' },
    { code: '5107750', name: "Salto do Céu", state: 'MT' },
    { code: '5107248', name: "Santa Carmem", state: 'MT' },
    { code: '5107743', name: "Santa Cruz do Xingu", state: 'MT' },
    { code: '5107768', name: "Santa Rita do Trivelato", state: 'MT' },
    { code: '5107776', name: "Santa Terezinha", state: 'MT' },
    { code: '5107263', name: "Santo Afonso", state: 'MT' },
    { code: '5107800', name: "Santo Antônio de Leverger", state: 'MT' },
    { code: '5107792', name: "Santo Antônio do Leste", state: 'MT' },
    { code: '5107859', name: "São Félix do Araguaia", state: 'MT' },
    { code: '5107297', name: "São José do Povo", state: 'MT' },
    { code: '5107305', name: "São José do Rio Claro", state: 'MT' },
    { code: '5107354', name: "São José do Xingu", state: 'MT' },
    { code: '5107107', name: "São José dos Quatro Marcos", state: 'MT' },
    { code: '5107404', name: "São Pedro da Cipa", state: 'MT' },
    { code: '5107875', name: "Sapezal", state: 'MT' },
    { code: '5107883', name: "Serra Nova Dourada", state: 'MT' },
    { code: '5107909', name: "Sinop", state: 'MT' },
    { code: '5107925', name: "Sorriso", state: 'MT' },
    { code: '5107941', name: "Tabaporã", state: 'MT' },
    { code: '5107958', name: "Tangará da Serra", state: 'MT' },
    { code: '5108006', name: "Tapurah", state: 'MT' },
    { code: '5108055', name: "Terra Nova do Norte", state: 'MT' },
    { code: '5108105', name: "Tesouro", state: 'MT' },
    { code: '5108204', name: "Torixoréu", state: 'MT' },
    { code: '5108303', name: "União do Sul", state: 'MT' },
    { code: '5108352', name: "Vale de São Domingos", state: 'MT' },
    { code: '5108402', name: "Várzea Grande", state: 'MT' },
    { code: '5108501', name: "Vera", state: 'MT' },
    { code: '5105507', name: "Vila Bela da Santíssima Trindade", state: 'MT' },
    { code: '5108600', name: "Vila Rica", state: 'MT' }
  ],

  // PARÁ (PA) - 144 municípios
  PA: [
    { code: '1500107', name: "Abaetetuba", state: 'PA' },
    { code: '1500131', name: "Abel Figueiredo", state: 'PA' },
    { code: '1500206', name: "Acará", state: 'PA' },
    { code: '1500305', name: "Afuá", state: 'PA' },
    { code: '1500347', name: "Água Azul do Norte", state: 'PA' },
    { code: '1500404', name: "Alenquer", state: 'PA' },
    { code: '1500503', name: "Almeirim", state: 'PA' },
    { code: '1500602', name: "Altamira", state: 'PA' },
    { code: '1500701', name: "Anajás", state: 'PA' },
    { code: '1500800', name: "Ananindeua", state: 'PA' },
    { code: '1500859', name: "Anapu", state: 'PA' },
    { code: '1500909', name: "Augusto Corrêa", state: 'PA' },
    { code: '1500958', name: "Aurora do Pará", state: 'PA' },
    { code: '1501006', name: "Aveiro", state: 'PA' },
    { code: '1501105', name: "Bagre", state: 'PA' },
    { code: '1501204', name: "Baião", state: 'PA' },
    { code: '1501253', name: "Bannach", state: 'PA' },
    { code: '1501303', name: "Barcarena", state: 'PA' },
    { code: '1501402', name: "Belém", state: 'PA' },
    { code: '1501451', name: "Belterra", state: 'PA' },
    { code: '1501501', name: "Benevides", state: 'PA' },
    { code: '1501576', name: "Bom Jesus do Tocantins", state: 'PA' },
    { code: '1501600', name: "Bonito", state: 'PA' },
    { code: '1501709', name: "Bragança", state: 'PA' },
    { code: '1501725', name: "Brasil Novo", state: 'PA' },
    { code: '1501758', name: "Brejo Grande do Araguaia", state: 'PA' },
    { code: '1501782', name: "Breu Branco", state: 'PA' },
    { code: '1501808', name: "Breves", state: 'PA' },
    { code: '1501907', name: "Bujaru", state: 'PA' },
    { code: '1502004', name: "Cachoeira do Arari", state: 'PA' },
    { code: '1501956', name: "Cachoeira do Piriá", state: 'PA' },
    { code: '1502103', name: "Cametá", state: 'PA' },
    { code: '1502152', name: "Canaã dos Carajás", state: 'PA' },
    { code: '1502202', name: "Capanema", state: 'PA' },
    { code: '1502301', name: "Capitão Poço", state: 'PA' },
    { code: '1502400', name: "Castanhal", state: 'PA' },
    { code: '1502509', name: "Chaves", state: 'PA' },
    { code: '1502608', name: "Colares", state: 'PA' },
    { code: '1502707', name: "Conceição do Araguaia", state: 'PA' },
    { code: '1502756', name: "Concórdia do Pará", state: 'PA' },
    { code: '1502764', name: "Cumaru do Norte", state: 'PA' },
    { code: '1502772', name: "Curionópolis", state: 'PA' },
    { code: '1502806', name: "Curralinho", state: 'PA' },
    { code: '1502855', name: "Curuá", state: 'PA' },
    { code: '1502905', name: "Curuçá", state: 'PA' },
    { code: '1502939', name: "Dom Eliseu", state: 'PA' },
    { code: '1502954', name: "Eldorado do Carajás", state: 'PA' },
    { code: '1503002', name: "Faro", state: 'PA' },
    { code: '1503044', name: "Floresta do Araguaia", state: 'PA' },
    { code: '1503077', name: "Garrafão do Norte", state: 'PA' },
    { code: '1503093', name: "Goianésia do Pará", state: 'PA' },
    { code: '1503101', name: "Gurupá", state: 'PA' },
    { code: '1503200', name: "Igarapé-Açu", state: 'PA' },
    { code: '1503309', name: "Igarapé-Miri", state: 'PA' },
    { code: '1503408', name: "Inhangapi", state: 'PA' },
    { code: '1503457', name: "Ipixuna do Pará", state: 'PA' },
    { code: '1503507', name: "Irituia", state: 'PA' },
    { code: '1503606', name: "Itaituba", state: 'PA' },
    { code: '1503705', name: "Itupiranga", state: 'PA' },
    { code: '1503754', name: "Jacareacanga", state: 'PA' },
    { code: '1503804', name: "Jacundá", state: 'PA' },
    { code: '1503903', name: "Juruti", state: 'PA' },
    { code: '1504000', name: "Limoeiro do Ajuru", state: 'PA' },
    { code: '1504059', name: "Mãe do Rio", state: 'PA' },
    { code: '1504109', name: "Magalhães Barata", state: 'PA' },
    { code: '1504208', name: "Marabá", state: 'PA' },
    { code: '1504307', name: "Maracanã", state: 'PA' },
    { code: '1504406', name: "Marapanim", state: 'PA' },
    { code: '1504422', name: "Marituba", state: 'PA' },
    { code: '1504455', name: "Medicilândia", state: 'PA' },
    { code: '1504505', name: "Melgaço", state: 'PA' },
    { code: '1504604', name: "Mocajuba", state: 'PA' },
    { code: '1504703', name: "Moju", state: 'PA' },
    { code: '1504752', name: "Mojuí dos Campos", state: 'PA' },
    { code: '1504802', name: "Monte Alegre", state: 'PA' },
    { code: '1504901', name: "Muaná", state: 'PA' },
    { code: '1504950', name: "Nova Esperança do Piriá", state: 'PA' },
    { code: '1504976', name: "Nova Ipixuna", state: 'PA' },
    { code: '1505007', name: "Nova Timboteua", state: 'PA' },
    { code: '1505031', name: "Novo Progresso", state: 'PA' },
    { code: '1505064', name: "Novo Repartimento", state: 'PA' },
    { code: '1505106', name: "Óbidos", state: 'PA' },
    { code: '1505205', name: "Oeiras do Pará", state: 'PA' },
    { code: '1505304', name: "Oriximiná", state: 'PA' },
    { code: '1505403', name: "Ourém", state: 'PA' },
    { code: '1505437', name: "Ourilândia do Norte", state: 'PA' },
    { code: '1505486', name: "Pacajá", state: 'PA' },
    { code: '1505494', name: "Palestina do Pará", state: 'PA' },
    { code: '1505502', name: "Paragominas", state: 'PA' },
    { code: '1505536', name: "Parauapebas", state: 'PA' },
    { code: '1505551', name: "Pau D'Arco", state: 'PA' },
    { code: '1505601', name: "Peixe-Boi", state: 'PA' },
    { code: '1505635', name: "Piçarra", state: 'PA' },
    { code: '1505650', name: "Placas", state: 'PA' },
    { code: '1505700', name: "Ponta de Pedras", state: 'PA' },
    { code: '1505809', name: "Portel", state: 'PA' },
    { code: '1505908', name: "Porto de Moz", state: 'PA' },
    { code: '1506005', name: "Prainha", state: 'PA' },
    { code: '1506104', name: "Primavera", state: 'PA' },
    { code: '1506112', name: "Quatipuru", state: 'PA' },
    { code: '1506138', name: "Redenção", state: 'PA' },
    { code: '1506161', name: "Rio Maria", state: 'PA' },
    { code: '1506187', name: "Rondon do Pará", state: 'PA' },
    { code: '1506195', name: "Rurópolis", state: 'PA' },
    { code: '1506203', name: "Salinópolis", state: 'PA' },
    { code: '1506302', name: "Salvaterra", state: 'PA' },
    { code: '1506351', name: "Santa Bárbara do Pará", state: 'PA' },
    { code: '1506401', name: "Santa Cruz do Arari", state: 'PA' },
    { code: '1506500', name: "Santa Izabel do Pará", state: 'PA' },
    { code: '1506559', name: "Santa Luzia do Pará", state: 'PA' },
    { code: '1506583', name: "Santa Maria das Barreiras", state: 'PA' },
    { code: '1506609', name: "Santa Maria do Pará", state: 'PA' },
    { code: '1506708', name: "Santana do Araguaia", state: 'PA' },
    { code: '1506807', name: "Santarém", state: 'PA' },
    { code: '1506906', name: "Santarém Novo", state: 'PA' },
    { code: '1507003', name: "Santo Antônio do Tauá", state: 'PA' },
    { code: '1507102', name: "São Caetano de Odivelas", state: 'PA' },
    { code: '1507151', name: "São Domingos do Araguaia", state: 'PA' },
    { code: '1507201', name: "São Domingos do Capim", state: 'PA' },
    { code: '1507300', name: "São Félix do Xingu", state: 'PA' },
    { code: '1507409', name: "São Francisco do Pará", state: 'PA' },
    { code: '1507458', name: "São Geraldo do Araguaia", state: 'PA' },
    { code: '1507466', name: "São João da Ponta", state: 'PA' },
    { code: '1507474', name: "São João de Pirabas", state: 'PA' },
    { code: '1507508', name: "São João do Araguaia", state: 'PA' },
    { code: '1507607', name: "São Miguel do Guamá", state: 'PA' },
    { code: '1507706', name: "São Sebastião da Boa Vista", state: 'PA' },
    { code: '1507755', name: "Sapucaia", state: 'PA' },
    { code: '1507805', name: "Senador José Porfírio", state: 'PA' },
    { code: '1507904', name: "Soure", state: 'PA' },
    { code: '1507953', name: "Tailândia", state: 'PA' },
    { code: '1507961', name: "Terra Alta", state: 'PA' },
    { code: '1507979', name: "Terra Santa", state: 'PA' },
    { code: '1508001', name: "Tomé-Açu", state: 'PA' },
    { code: '1508035', name: "Tracuateua", state: 'PA' },
    { code: '1508050', name: "Trairão", state: 'PA' },
    { code: '1508084', name: "Tucumã", state: 'PA' },
    { code: '1508100', name: "Tucuruí", state: 'PA' },
    { code: '1508126', name: "Ulianópolis", state: 'PA' },
    { code: '1508159', name: "Uruará", state: 'PA' },
    { code: '1508209', name: "Vigia", state: 'PA' },
    { code: '1508308', name: "Viseu", state: 'PA' },
    { code: '1508357', name: "Vitória do Xingu", state: 'PA' },
    { code: '1508407', name: "Xinguara", state: 'PA' }
  ],

  // PARAÍBA (PB) - 223 municípios
  PB: [
    { code: '2500106', name: "Água Branca", state: 'PB' },
    { code: '2500205', name: "Aguiar", state: 'PB' },
    { code: '2500304', name: "Alagoa Grande", state: 'PB' },
    { code: '2500403', name: "Alagoa Nova", state: 'PB' },
    { code: '2500502', name: "Alagoinha", state: 'PB' },
    { code: '2500536', name: "Alcantil", state: 'PB' },
    { code: '2500577', name: "Algodão de Jandaíra", state: 'PB' },
    { code: '2500601', name: "Alhandra", state: 'PB' },
    { code: '2500734', name: "Amparo", state: 'PB' },
    { code: '2500775', name: "Aparecida", state: 'PB' },
    { code: '2500809', name: "Araçagi", state: 'PB' },
    { code: '2500908', name: "Arara", state: 'PB' },
    { code: '2501005', name: "Araruna", state: 'PB' },
    { code: '2501104', name: "Areia", state: 'PB' },
    { code: '2501153', name: "Areia de Baraúnas", state: 'PB' },
    { code: '2501203', name: "Areial", state: 'PB' },
    { code: '2501302', name: "Aroeiras", state: 'PB' },
    { code: '2501351', name: "Assunção", state: 'PB' },
    { code: '2501401', name: "Baía da Traição", state: 'PB' },
    { code: '2501500', name: "Bananeiras", state: 'PB' },
    { code: '2501534', name: "Baraúna", state: 'PB' },
    { code: '2501609', name: "Barra de Santa Rosa", state: 'PB' },
    { code: '2501575', name: "Barra de Santana", state: 'PB' },
    { code: '2501708', name: "Barra de São Miguel", state: 'PB' },
    { code: '2501807', name: "Bayeux", state: 'PB' },
    { code: '2501906', name: "Belém", state: 'PB' },
    { code: '2502003', name: "Belém do Brejo do Cruz", state: 'PB' },
    { code: '2502052', name: "Bernardino Batista", state: 'PB' },
    { code: '2502102', name: "Boa Ventura", state: 'PB' },
    { code: '2502151', name: "Boa Vista", state: 'PB' },
    { code: '2502201', name: "Bom Jesus", state: 'PB' },
    { code: '2502300', name: "Bom Sucesso", state: 'PB' },
    { code: '2502409', name: "Bonito de Santa Fé", state: 'PB' },
    { code: '2502508', name: "Boqueirão", state: 'PB' },
    { code: '2502706', name: "Borborema", state: 'PB' },
    { code: '2502805', name: "Brejo do Cruz", state: 'PB' },
    { code: '2502904', name: "Brejo dos Santos", state: 'PB' },
    { code: '2503001', name: "Caaporã", state: 'PB' },
    { code: '2503100', name: "Cabaceiras", state: 'PB' },
    { code: '2503209', name: "Cabedelo", state: 'PB' },
    { code: '2503308', name: "Cachoeira dos Índios", state: 'PB' },
    { code: '2503407', name: "Cacimba de Areia", state: 'PB' },
    { code: '2503506', name: "Cacimba de Dentro", state: 'PB' },
    { code: '2503555', name: "Cacimbas", state: 'PB' },
    { code: '2503605', name: "Caiçara", state: 'PB' },
    { code: '2503704', name: "Cajazeiras", state: 'PB' },
    { code: '2503753', name: "Cajazeirinhas", state: 'PB' },
    { code: '2503803', name: "Caldas Brandão", state: 'PB' },
    { code: '2503902', name: "Camalaú", state: 'PB' },
    { code: '2504009', name: "Campina Grande", state: 'PB' },
    { code: '2504033', name: "Capim", state: 'PB' },
    { code: '2504074', name: "Caraúbas", state: 'PB' },
    { code: '2504108', name: "Carrapateira", state: 'PB' },
    { code: '2504157', name: "Casserengue", state: 'PB' },
    { code: '2504207', name: "Catingueira", state: 'PB' },
    { code: '2504306', name: "Catolé do Rocha", state: 'PB' },
    { code: '2504355', name: "Caturité", state: 'PB' },
    { code: '2504405', name: "Conceição", state: 'PB' },
    { code: '2504504', name: "Condado", state: 'PB' },
    { code: '2504603', name: "Conde", state: 'PB' },
    { code: '2504702', name: "Congo", state: 'PB' },
    { code: '2504801', name: "Coremas", state: 'PB' },
    { code: '2504850', name: "Coxixola", state: 'PB' },
    { code: '2504900', name: "Cruz do Espírito Santo", state: 'PB' },
    { code: '2505006', name: "Cubati", state: 'PB' },
    { code: '2505105', name: "Cuité", state: 'PB' },
    { code: '2505238', name: "Cuité de Mamanguape", state: 'PB' },
    { code: '2505204', name: "Cuitegi", state: 'PB' },
    { code: '2505279', name: "Curral de Cima", state: 'PB' },
    { code: '2505303', name: "Curral Velho", state: 'PB' },
    { code: '2505352', name: "Damião", state: 'PB' },
    { code: '2505402', name: "Desterro", state: 'PB' },
    { code: '2505600', name: "Diamante", state: 'PB' },
    { code: '2505709', name: "Dona Inês", state: 'PB' },
    { code: '2505808', name: "Duas Estradas", state: 'PB' },
    { code: '2505907', name: "Emas", state: 'PB' },
    { code: '2506004', name: "Esperança", state: 'PB' },
    { code: '2506103', name: "Fagundes", state: 'PB' },
    { code: '2506202', name: "Frei Martinho", state: 'PB' },
    { code: '2506251', name: "Gado Bravo", state: 'PB' },
    { code: '2506301', name: "Guarabira", state: 'PB' },
    { code: '2506400', name: "Gurinhém", state: 'PB' },
    { code: '2506509', name: "Gurjão", state: 'PB' },
    { code: '2506608', name: "Ibiara", state: 'PB' },
    { code: '2502607', name: "Igaracy", state: 'PB' },
    { code: '2506707', name: "Imaculada", state: 'PB' },
    { code: '2506806', name: "Ingá", state: 'PB' },
    { code: '2506905', name: "Itabaiana", state: 'PB' },
    { code: '2507002', name: "Itaporanga", state: 'PB' },
    { code: '2507101', name: "Itapororoca", state: 'PB' },
    { code: '2507200', name: "Itatuba", state: 'PB' },
    { code: '2507309', name: "Jacaraú", state: 'PB' },
    { code: '2507408', name: "Jericó", state: 'PB' },
    { code: '2507507', name: "João Pessoa", state: 'PB' },
    { code: '2513653', name: "Joca Claudino", state: 'PB' },
    { code: '2507606', name: "Juarez Távora", state: 'PB' },
    { code: '2507705', name: "Juazeirinho", state: 'PB' },
    { code: '2507804', name: "Junco do Seridó", state: 'PB' },
    { code: '2507903', name: "Juripiranga", state: 'PB' },
    { code: '2508000', name: "Juru", state: 'PB' },
    { code: '2508109', name: "Lagoa", state: 'PB' },
    { code: '2508208', name: "Lagoa de Dentro", state: 'PB' },
    { code: '2508307', name: "Lagoa Seca", state: 'PB' },
    { code: '2508406', name: "Lastro", state: 'PB' },
    { code: '2508505', name: "Livramento", state: 'PB' },
    { code: '2508554', name: "Logradouro", state: 'PB' },
    { code: '2508604', name: "Lucena", state: 'PB' },
    { code: '2508703', name: "Mãe d'Água", state: 'PB' },
    { code: '2508802', name: "Malta", state: 'PB' },
    { code: '2508901', name: "Mamanguape", state: 'PB' },
    { code: '2509008', name: "Manaíra", state: 'PB' },
    { code: '2509057', name: "Marcação", state: 'PB' },
    { code: '2509107', name: "Mari", state: 'PB' },
    { code: '2509156', name: "Marizópolis", state: 'PB' },
    { code: '2509206', name: "Massaranduba", state: 'PB' },
    { code: '2509305', name: "Mataraca", state: 'PB' },
    { code: '2509339', name: "Matinhas", state: 'PB' },
    { code: '2509370', name: "Mato Grosso", state: 'PB' },
    { code: '2509396', name: "Maturéia", state: 'PB' },
    { code: '2509404', name: "Mogeiro", state: 'PB' },
    { code: '2509503', name: "Montadas", state: 'PB' },
    { code: '2509602', name: "Monte Horebe", state: 'PB' },
    { code: '2509701', name: "Monteiro", state: 'PB' },
    { code: '2509800', name: "Mulungu", state: 'PB' },
    { code: '2509909', name: "Natuba", state: 'PB' },
    { code: '2510006', name: "Nazarezinho", state: 'PB' },
    { code: '2510105', name: "Nova Floresta", state: 'PB' },
    { code: '2510204', name: "Nova Olinda", state: 'PB' },
    { code: '2510303', name: "Nova Palmeira", state: 'PB' },
    { code: '2510402', name: "Olho d'Água", state: 'PB' },
    { code: '2510501', name: "Olivedos", state: 'PB' },
    { code: '2510600', name: "Ouro Velho", state: 'PB' },
    { code: '2510659', name: "Parari", state: 'PB' },
    { code: '2510709', name: "Passagem", state: 'PB' },
    { code: '2510808', name: "Patos", state: 'PB' },
    { code: '2510907', name: "Paulista", state: 'PB' },
    { code: '2511004', name: "Pedra Branca", state: 'PB' },
    { code: '2511103', name: "Pedra Lavrada", state: 'PB' },
    { code: '2511202', name: "Pedras de Fogo", state: 'PB' },
    { code: '2512721', name: "Pedro Régis", state: 'PB' },
    { code: '2511301', name: "Piancó", state: 'PB' },
    { code: '2511400', name: "Picuí", state: 'PB' },
    { code: '2511509', name: "Pilar", state: 'PB' },
    { code: '2511608', name: "Pilões", state: 'PB' },
    { code: '2511707', name: "Pilõezinhos", state: 'PB' },
    { code: '2511806', name: "Pirpirituba", state: 'PB' },
    { code: '2511905', name: "Pitimbu", state: 'PB' },
    { code: '2512002', name: "Pocinhos", state: 'PB' },
    { code: '2512036', name: "Poço Dantas", state: 'PB' },
    { code: '2512077', name: "Poço de José de Moura", state: 'PB' },
    { code: '2512101', name: "Pombal", state: 'PB' },
    { code: '2512200', name: "Prata", state: 'PB' },
    { code: '2512309', name: "Princesa Isabel", state: 'PB' },
    { code: '2512408', name: "Puxinanã", state: 'PB' },
    { code: '2512507', name: "Queimadas", state: 'PB' },
    { code: '2512606', name: "Quixaba", state: 'PB' },
    { code: '2512705', name: "Remígio", state: 'PB' },
    { code: '2512747', name: "Riachão", state: 'PB' },
    { code: '2512754', name: "Riachão do Bacamarte", state: 'PB' },
    { code: '2512762', name: "Riachão do Poço", state: 'PB' },
    { code: '2512788', name: "Riacho de Santo Antônio", state: 'PB' },
    { code: '2512804', name: "Riacho dos Cavalos", state: 'PB' },
    { code: '2512903', name: "Rio Tinto", state: 'PB' },
    { code: '2513000', name: "Salgadinho", state: 'PB' },
    { code: '2513109', name: "Salgado de São Félix", state: 'PB' },
    { code: '2513158', name: "Santa Cecília", state: 'PB' },
    { code: '2513208', name: "Santa Cruz", state: 'PB' },
    { code: '2513307', name: "Santa Helena", state: 'PB' },
    { code: '2513356', name: "Santa Inês", state: 'PB' },
    { code: '2513406', name: "Santa Luzia", state: 'PB' },
    { code: '2513703', name: "Santa Rita", state: 'PB' },
    { code: '2513802', name: "Santa Teresinha", state: 'PB' },
    { code: '2513505', name: "Santana de Mangueira", state: 'PB' },
    { code: '2513604', name: "Santana dos Garrotes", state: 'PB' },
    { code: '2513851', name: "Santo André", state: 'PB' },
    { code: '2513927', name: "São Bentinho", state: 'PB' },
    { code: '2513901', name: "São Bento", state: 'PB' },
    { code: '2513968', name: "São Domingos", state: 'PB' },
    { code: '2513943', name: "São Domingos do Cariri", state: 'PB' },
    { code: '2513984', name: "São Francisco", state: 'PB' },
    { code: '2514008', name: "São João do Cariri", state: 'PB' },
    { code: '2500700', name: "São João do Rio do Peixe", state: 'PB' },
    { code: '2514107', name: "São João do Tigre", state: 'PB' },
    { code: '2514206', name: "São José da Lagoa Tapada", state: 'PB' },
    { code: '2514305', name: "São José de Caiana", state: 'PB' },
    { code: '2514404', name: "São José de Espinharas", state: 'PB' },
    { code: '2514503', name: "São José de Piranhas", state: 'PB' },
    { code: '2514552', name: "São José de Princesa", state: 'PB' },
    { code: '2514602', name: "São José do Bonfim", state: 'PB' },
    { code: '2514651', name: "São José do Brejo do Cruz", state: 'PB' },
    { code: '2514701', name: "São José do Sabugi", state: 'PB' },
    { code: '2514800', name: "São José dos Cordeiros", state: 'PB' },
    { code: '2514453', name: "São José dos Ramos", state: 'PB' },
    { code: '2514909', name: "São Mamede", state: 'PB' },
    { code: '2515005', name: "São Miguel de Taipu", state: 'PB' },
    { code: '2515104', name: "São Sebastião de Lagoa de Roça", state: 'PB' },
    { code: '2515203', name: "São Sebastião do Umbuzeiro", state: 'PB' },
    { code: '2515401', name: "São Vicente do Seridó", state: 'PB' },
    { code: '2515302', name: "Sapé", state: 'PB' },
    { code: '2515500', name: "Serra Branca", state: 'PB' },
    { code: '2515609', name: "Serra da Raiz", state: 'PB' },
    { code: '2515708', name: "Serra Grande", state: 'PB' },
    { code: '2515807', name: "Serra Redonda", state: 'PB' },
    { code: '2515906', name: "Serraria", state: 'PB' },
    { code: '2515930', name: "Sertãozinho", state: 'PB' },
    { code: '2515971', name: "Sobrado", state: 'PB' },
    { code: '2516003', name: "Solânea", state: 'PB' },
    { code: '2516102', name: "Soledade", state: 'PB' },
    { code: '2516151', name: "Sossêgo", state: 'PB' },
    { code: '2516201', name: "Sousa", state: 'PB' },
    { code: '2516300', name: "Sumé", state: 'PB' },
    { code: '2516409', name: "Tacima", state: 'PB' },
    { code: '2516508', name: "Taperoá", state: 'PB' },
    { code: '2516607', name: "Tavares", state: 'PB' },
    { code: '2516706', name: "Teixeira", state: 'PB' },
    { code: '2516755', name: "Tenório", state: 'PB' },
    { code: '2516805', name: "Triunfo", state: 'PB' },
    { code: '2516904', name: "Uiraúna", state: 'PB' },
    { code: '2517001', name: "Umbuzeiro", state: 'PB' },
    { code: '2517100', name: "Várzea", state: 'PB' },
    { code: '2517209', name: "Vieirópolis", state: 'PB' },
    { code: '2505501', name: "Vista Serrana", state: 'PB' },
    { code: '2517407', name: "Zabelê", state: 'PB' }
  ],

  // PERNAMBUCO (PE) - 185 municípios
  PE: [
    { code: '2600054', name: "Abreu e Lima", state: 'PE' },
    { code: '2600104', name: "Afogados da Ingazeira", state: 'PE' },
    { code: '2600203', name: "Afrânio", state: 'PE' },
    { code: '2600302', name: "Agrestina", state: 'PE' },
    { code: '2600401', name: "Água Preta", state: 'PE' },
    { code: '2600500', name: "Águas Belas", state: 'PE' },
    { code: '2600609', name: "Alagoinha", state: 'PE' },
    { code: '2600708', name: "Aliança", state: 'PE' },
    { code: '2600807', name: "Altinho", state: 'PE' },
    { code: '2600906', name: "Amaraji", state: 'PE' },
    { code: '2601003', name: "Angelim", state: 'PE' },
    { code: '2601052', name: "Araçoiaba", state: 'PE' },
    { code: '2601102', name: "Araripina", state: 'PE' },
    { code: '2601201', name: "Arcoverde", state: 'PE' },
    { code: '2601300', name: "Barra de Guabiraba", state: 'PE' },
    { code: '2601409', name: "Barreiros", state: 'PE' },
    { code: '2601508', name: "Belém de Maria", state: 'PE' },
    { code: '2601607', name: "Belém do São Francisco", state: 'PE' },
    { code: '2601706', name: "Belo Jardim", state: 'PE' },
    { code: '2601805', name: "Betânia", state: 'PE' },
    { code: '2601904', name: "Bezerros", state: 'PE' },
    { code: '2602001', name: "Bodocó", state: 'PE' },
    { code: '2602100', name: "Bom Conselho", state: 'PE' },
    { code: '2602209', name: "Bom Jardim", state: 'PE' },
    { code: '2602308', name: "Bonito", state: 'PE' },
    { code: '2602407', name: "Brejão", state: 'PE' },
    { code: '2602506', name: "Brejinho", state: 'PE' },
    { code: '2602605', name: "Brejo da Madre de Deus", state: 'PE' },
    { code: '2602704', name: "Buenos Aires", state: 'PE' },
    { code: '2602803', name: "Buíque", state: 'PE' },
    { code: '2602902', name: "Cabo de Santo Agostinho", state: 'PE' },
    { code: '2603009', name: "Cabrobó", state: 'PE' },
    { code: '2603108', name: "Cachoeirinha", state: 'PE' },
    { code: '2603207', name: "Caetés", state: 'PE' },
    { code: '2603306', name: "Calçado", state: 'PE' },
    { code: '2603405', name: "Calumbi", state: 'PE' },
    { code: '2603454', name: "Camaragibe", state: 'PE' },
    { code: '2603504', name: "Camocim de São Félix", state: 'PE' },
    { code: '2603603', name: "Camutanga", state: 'PE' },
    { code: '2603702', name: "Canhotinho", state: 'PE' },
    { code: '2603801', name: "Capoeiras", state: 'PE' },
    { code: '2603900', name: "Carnaíba", state: 'PE' },
    { code: '2603926', name: "Carnaubeira da Penha", state: 'PE' },
    { code: '2604007', name: "Carpina", state: 'PE' },
    { code: '2604106', name: "Caruaru", state: 'PE' },
    { code: '2604155', name: "Casinhas", state: 'PE' },
    { code: '2604205', name: "Catende", state: 'PE' },
    { code: '2604304', name: "Cedro", state: 'PE' },
    { code: '2604403', name: "Chã de Alegria", state: 'PE' },
    { code: '2604502', name: "Chã Grande", state: 'PE' },
    { code: '2604601', name: "Condado", state: 'PE' },
    { code: '2604700', name: "Correntes", state: 'PE' },
    { code: '2604809', name: "Cortês", state: 'PE' },
    { code: '2604908', name: "Cumaru", state: 'PE' },
    { code: '2605004', name: "Cupira", state: 'PE' },
    { code: '2605103', name: "Custódia", state: 'PE' },
    { code: '2605152', name: "Dormentes", state: 'PE' },
    { code: '2605202', name: "Escada", state: 'PE' },
    { code: '2605301', name: "Exu", state: 'PE' },
    { code: '2605400', name: "Feira Nova", state: 'PE' },
    { code: '2605459', name: "Fernando de Noronha", state: 'PE' },
    { code: '2605509', name: "Ferreiros", state: 'PE' },
    { code: '2605608', name: "Flores", state: 'PE' },
    { code: '2605707', name: "Floresta", state: 'PE' },
    { code: '2605806', name: "Frei Miguelinho", state: 'PE' },
    { code: '2605905', name: "Gameleira", state: 'PE' },
    { code: '2606002', name: "Garanhuns", state: 'PE' },
    { code: '2606101', name: "Glória do Goitá", state: 'PE' },
    { code: '2606200', name: "Goiana", state: 'PE' },
    { code: '2606309', name: "Granito", state: 'PE' },
    { code: '2606408', name: "Gravatá", state: 'PE' },
    { code: '2606507', name: "Iati", state: 'PE' },
    { code: '2606606', name: "Ibimirim", state: 'PE' },
    { code: '2606705', name: "Ibirajuba", state: 'PE' },
    { code: '2606804', name: "Igarassu", state: 'PE' },
    { code: '2606903', name: "Iguaracy", state: 'PE' },
    { code: '2607604', name: "Ilha de Itamaracá", state: 'PE' },
    { code: '2607000', name: "Inajá", state: 'PE' },
    { code: '2607109', name: "Ingazeira", state: 'PE' },
    { code: '2607208', name: "Ipojuca", state: 'PE' },
    { code: '2607307', name: "Ipubi", state: 'PE' },
    { code: '2607406', name: "Itacuruba", state: 'PE' },
    { code: '2607505', name: "Itaíba", state: 'PE' },
    { code: '2607653', name: "Itambé", state: 'PE' },
    { code: '2607703', name: "Itapetim", state: 'PE' },
    { code: '2607752', name: "Itapissuma", state: 'PE' },
    { code: '2607802', name: "Itaquitinga", state: 'PE' },
    { code: '2607901', name: "Jaboatão dos Guararapes", state: 'PE' },
    { code: '2607950', name: "Jaqueira", state: 'PE' },
    { code: '2608008', name: "Jataúba", state: 'PE' },
    { code: '2608057', name: "Jatobá", state: 'PE' },
    { code: '2608107', name: "João Alfredo", state: 'PE' },
    { code: '2608206', name: "Joaquim Nabuco", state: 'PE' },
    { code: '2608255', name: "Jucati", state: 'PE' },
    { code: '2608305', name: "Jupi", state: 'PE' },
    { code: '2608404', name: "Jurema", state: 'PE' },
    { code: '2608503', name: "Lagoa de Itaenga", state: 'PE' },
    { code: '2608453', name: "Lagoa do Carro", state: 'PE' },
    { code: '2608602', name: "Lagoa do Ouro", state: 'PE' },
    { code: '2608701', name: "Lagoa dos Gatos", state: 'PE' },
    { code: '2608750', name: "Lagoa Grande", state: 'PE' },
    { code: '2608800', name: "Lajedo", state: 'PE' },
    { code: '2608909', name: "Limoeiro", state: 'PE' },
    { code: '2609006', name: "Macaparana", state: 'PE' },
    { code: '2609105', name: "Machados", state: 'PE' },
    { code: '2609154', name: "Manari", state: 'PE' },
    { code: '2609204', name: "Maraial", state: 'PE' },
    { code: '2609303', name: "Mirandiba", state: 'PE' },
    { code: '2614303', name: "Moreilândia", state: 'PE' },
    { code: '2609402', name: "Moreno", state: 'PE' },
    { code: '2609501', name: "Nazaré da Mata", state: 'PE' },
    { code: '2609600', name: "Olinda", state: 'PE' },
    { code: '2609709', name: "Orobó", state: 'PE' },
    { code: '2609808', name: "Orocó", state: 'PE' },
    { code: '2609907', name: "Ouricuri", state: 'PE' },
    { code: '2610004', name: "Palmares", state: 'PE' },
    { code: '2610103', name: "Palmeirina", state: 'PE' },
    { code: '2610202', name: "Panelas", state: 'PE' },
    { code: '2610301', name: "Paranatama", state: 'PE' },
    { code: '2610400', name: "Parnamirim", state: 'PE' },
    { code: '2610509', name: "Passira", state: 'PE' },
    { code: '2610608', name: "Paudalho", state: 'PE' },
    { code: '2610707', name: "Paulista", state: 'PE' },
    { code: '2610806', name: "Pedra", state: 'PE' },
    { code: '2610905', name: "Pesqueira", state: 'PE' },
    { code: '2611002', name: "Petrolândia", state: 'PE' },
    { code: '2611101', name: "Petrolina", state: 'PE' },
    { code: '2611200', name: "Poção", state: 'PE' },
    { code: '2611309', name: "Pombos", state: 'PE' },
    { code: '2611408', name: "Primavera", state: 'PE' },
    { code: '2611507', name: "Quipapá", state: 'PE' },
    { code: '2611533', name: "Quixaba", state: 'PE' },
    { code: '2611606', name: "Recife", state: 'PE' },
    { code: '2611705', name: "Riacho das Almas", state: 'PE' },
    { code: '2611804', name: "Ribeirão", state: 'PE' },
    { code: '2611903', name: "Rio Formoso", state: 'PE' },
    { code: '2612000', name: "Sairé", state: 'PE' },
    { code: '2612109', name: "Salgadinho", state: 'PE' },
    { code: '2612208', name: "Salgueiro", state: 'PE' },
    { code: '2612307', name: "Saloá", state: 'PE' },
    { code: '2612406', name: "Sanharó", state: 'PE' },
    { code: '2612455', name: "Santa Cruz", state: 'PE' },
    { code: '2612471', name: "Santa Cruz da Baixa Verde", state: 'PE' },
    { code: '2612505', name: "Santa Cruz do Capibaribe", state: 'PE' },
    { code: '2612554', name: "Santa Filomena", state: 'PE' },
    { code: '2612604', name: "Santa Maria da Boa Vista", state: 'PE' },
    { code: '2612703', name: "Santa Maria do Cambucá", state: 'PE' },
    { code: '2612802', name: "Santa Terezinha", state: 'PE' },
    { code: '2612901', name: "São Benedito do Sul", state: 'PE' },
    { code: '2613008', name: "São Bento do Una", state: 'PE' },
    { code: '2613107', name: "São Caitano", state: 'PE' },
    { code: '2613206', name: "São João", state: 'PE' },
    { code: '2613305', name: "São Joaquim do Monte", state: 'PE' },
    { code: '2613404', name: "São José da Coroa Grande", state: 'PE' },
    { code: '2613503', name: "São José do Belmonte", state: 'PE' },
    { code: '2613602', name: "São José do Egito", state: 'PE' },
    { code: '2613701', name: "São Lourenço da Mata", state: 'PE' },
    { code: '2613800', name: "São Vicente Férrer", state: 'PE' },
    { code: '2613909', name: "Serra Talhada", state: 'PE' },
    { code: '2614006', name: "Serrita", state: 'PE' },
    { code: '2614105', name: "Sertânia", state: 'PE' },
    { code: '2614204', name: "Sirinhaém", state: 'PE' },
    { code: '2614402', name: "Solidão", state: 'PE' },
    { code: '2614501', name: "Surubim", state: 'PE' },
    { code: '2614600', name: "Tabira", state: 'PE' },
    { code: '2614709', name: "Tacaimbó", state: 'PE' },
    { code: '2614808', name: "Tacaratu", state: 'PE' },
    { code: '2614857', name: "Tamandaré", state: 'PE' },
    { code: '2615003', name: "Taquaritinga do Norte", state: 'PE' },
    { code: '2615102', name: "Terezinha", state: 'PE' },
    { code: '2615201', name: "Terra Nova", state: 'PE' },
    { code: '2615300', name: "Timbaúba", state: 'PE' },
    { code: '2615409', name: "Toritama", state: 'PE' },
    { code: '2615508', name: "Tracunhaém", state: 'PE' },
    { code: '2615607', name: "Trindade", state: 'PE' },
    { code: '2615706', name: "Triunfo", state: 'PE' },
    { code: '2615805', name: "Tupanatinga", state: 'PE' },
    { code: '2615904', name: "Tuparetama", state: 'PE' },
    { code: '2616001', name: "Venturosa", state: 'PE' },
    { code: '2616100', name: "Verdejante", state: 'PE' },
    { code: '2616183', name: "Vertente do Lério", state: 'PE' },
    { code: '2616209', name: "Vertentes", state: 'PE' },
    { code: '2616308', name: "Vicência", state: 'PE' },
    { code: '2616407', name: "Vitória de Santo Antão", state: 'PE' },
    { code: '2616506', name: "Xexéu", state: 'PE' }
  ],

  // PIAUÍ (PI) - 224 municípios
  PI: [
    { code: '2200053', name: "Acauã", state: 'PI' },
    { code: '2200103', name: "Agricolândia", state: 'PI' },
    { code: '2200202', name: "Água Branca", state: 'PI' },
    { code: '2200251', name: "Alagoinha do Piauí", state: 'PI' },
    { code: '2200277', name: "Alegrete do Piauí", state: 'PI' },
    { code: '2200301', name: "Alto Longá", state: 'PI' },
    { code: '2200400', name: "Altos", state: 'PI' },
    { code: '2200459', name: "Alvorada do Gurguéia", state: 'PI' },
    { code: '2200509', name: "Amarante", state: 'PI' },
    { code: '2200608', name: "Angical do Piauí", state: 'PI' },
    { code: '2200707', name: "Anísio de Abreu", state: 'PI' },
    { code: '2200806', name: "Antônio Almeida", state: 'PI' },
    { code: '2200905', name: "Aroazes", state: 'PI' },
    { code: '2200954', name: "Aroeiras do Itaim", state: 'PI' },
    { code: '2201002', name: "Arraial", state: 'PI' },
    { code: '2201051', name: "Assunção do Piauí", state: 'PI' },
    { code: '2201101', name: "Avelino Lopes", state: 'PI' },
    { code: '2201150', name: "Baixa Grande do Ribeiro", state: 'PI' },
    { code: '2201176', name: "Barra D'Alcântara", state: 'PI' },
    { code: '2201200', name: "Barras", state: 'PI' },
    { code: '2201309', name: "Barreiras do Piauí", state: 'PI' },
    { code: '2201408', name: "Barro Duro", state: 'PI' },
    { code: '2201507', name: "Batalha", state: 'PI' },
    { code: '2201556', name: "Bela Vista do Piauí", state: 'PI' },
    { code: '2201572', name: "Belém do Piauí", state: 'PI' },
    { code: '2201606', name: "Beneditinos", state: 'PI' },
    { code: '2201705', name: "Bertolínia", state: 'PI' },
    { code: '2201739', name: "Betânia do Piauí", state: 'PI' },
    { code: '2201770', name: "Boa Hora", state: 'PI' },
    { code: '2201804', name: "Bocaina", state: 'PI' },
    { code: '2201903', name: "Bom Jesus", state: 'PI' },
    { code: '2201919', name: "Bom Princípio do Piauí", state: 'PI' },
    { code: '2201929', name: "Bonfim do Piauí", state: 'PI' },
    { code: '2201945', name: "Boqueirão do Piauí", state: 'PI' },
    { code: '2201960', name: "Brasileira", state: 'PI' },
    { code: '2201988', name: "Brejo do Piauí", state: 'PI' },
    { code: '2202000', name: "Buriti dos Lopes", state: 'PI' },
    { code: '2202026', name: "Buriti dos Montes", state: 'PI' },
    { code: '2202059', name: "Cabeceiras do Piauí", state: 'PI' },
    { code: '2202075', name: "Cajazeiras do Piauí", state: 'PI' },
    { code: '2202083', name: "Cajueiro da Praia", state: 'PI' },
    { code: '2202091', name: "Caldeirão Grande do Piauí", state: 'PI' },
    { code: '2202109', name: "Campinas do Piauí", state: 'PI' },
    { code: '2202117', name: "Campo Alegre do Fidalgo", state: 'PI' },
    { code: '2202133', name: "Campo Grande do Piauí", state: 'PI' },
    { code: '2202174', name: "Campo Largo do Piauí", state: 'PI' },
    { code: '2202208', name: "Campo Maior", state: 'PI' },
    { code: '2202251', name: "Canavieira", state: 'PI' },
    { code: '2202307', name: "Canto do Buriti", state: 'PI' },
    { code: '2202406', name: "Capitão de Campos", state: 'PI' },
    { code: '2202455', name: "Capitão Gervásio Oliveira", state: 'PI' },
    { code: '2202505', name: "Caracol", state: 'PI' },
    { code: '2202539', name: "Caraúbas do Piauí", state: 'PI' },
    { code: '2202554', name: "Caridade do Piauí", state: 'PI' },
    { code: '2202604', name: "Castelo do Piauí", state: 'PI' },
    { code: '2202653', name: "Caxingó", state: 'PI' },
    { code: '2202703', name: "Cocal", state: 'PI' },
    { code: '2202711', name: "Cocal de Telha", state: 'PI' },
    { code: '2202729', name: "Cocal dos Alves", state: 'PI' },
    { code: '2202737', name: "Coivaras", state: 'PI' },
    { code: '2202752', name: "Colônia do Gurguéia", state: 'PI' },
    { code: '2202778', name: "Colônia do Piauí", state: 'PI' },
    { code: '2202802', name: "Conceição do Canindé", state: 'PI' },
    { code: '2202851', name: "Coronel José Dias", state: 'PI' },
    { code: '2202901', name: "Corrente", state: 'PI' },
    { code: '2203008', name: "Cristalândia do Piauí", state: 'PI' },
    { code: '2203107', name: "Cristino Castro", state: 'PI' },
    { code: '2203206', name: "Curimatá", state: 'PI' },
    { code: '2203230', name: "Currais", state: 'PI' },
    { code: '2203271', name: "Curral Novo do Piauí", state: 'PI' },
    { code: '2203255', name: "Curralinhos", state: 'PI' },
    { code: '2203305', name: "Demerval Lobão", state: 'PI' },
    { code: '2203354', name: "Dirceu Arcoverde", state: 'PI' },
    { code: '2203404', name: "Dom Expedito Lopes", state: 'PI' },
    { code: '2203453', name: "Dom Inocêncio", state: 'PI' },
    { code: '2203420', name: "Domingos Mourão", state: 'PI' },
    { code: '2203503', name: "Elesbão Veloso", state: 'PI' },
    { code: '2203602', name: "Eliseu Martins", state: 'PI' },
    { code: '2203701', name: "Esperantina", state: 'PI' },
    { code: '2203750', name: "Fartura do Piauí", state: 'PI' },
    { code: '2203800', name: "Flores do Piauí", state: 'PI' },
    { code: '2203859', name: "Floresta do Piauí", state: 'PI' },
    { code: '2203909', name: "Floriano", state: 'PI' },
    { code: '2204006', name: "Francinópolis", state: 'PI' },
    { code: '2204105', name: "Francisco Ayres", state: 'PI' },
    { code: '2204154', name: "Francisco Macedo", state: 'PI' },
    { code: '2204204', name: "Francisco Santos", state: 'PI' },
    { code: '2204303', name: "Fronteiras", state: 'PI' },
    { code: '2204352', name: "Geminiano", state: 'PI' },
    { code: '2204402', name: "Gilbués", state: 'PI' },
    { code: '2204501', name: "Guadalupe", state: 'PI' },
    { code: '2204550', name: "Guaribas", state: 'PI' },
    { code: '2204600', name: "Hugo Napoleão", state: 'PI' },
    { code: '2204659', name: "Ilha Grande", state: 'PI' },
    { code: '2204709', name: "Inhuma", state: 'PI' },
    { code: '2204808', name: "Ipiranga do Piauí", state: 'PI' },
    { code: '2204907', name: "Isaías Coelho", state: 'PI' },
    { code: '2205003', name: "Itainópolis", state: 'PI' },
    { code: '2205102', name: "Itaueira", state: 'PI' },
    { code: '2205151', name: "Jacobina do Piauí", state: 'PI' },
    { code: '2205201', name: "Jaicós", state: 'PI' },
    { code: '2205250', name: "Jardim do Mulato", state: 'PI' },
    { code: '2205276', name: "Jatobá do Piauí", state: 'PI' },
    { code: '2205300', name: "Jerumenha", state: 'PI' },
    { code: '2205359', name: "João Costa", state: 'PI' },
    { code: '2205409', name: "Joaquim Pires", state: 'PI' },
    { code: '2205458', name: "Joca Marques", state: 'PI' },
    { code: '2205508', name: "José de Freitas", state: 'PI' },
    { code: '2205516', name: "Juazeiro do Piauí", state: 'PI' },
    { code: '2205524', name: "Júlio Borges", state: 'PI' },
    { code: '2205532', name: "Jurema", state: 'PI' },
    { code: '2205557', name: "Lagoa Alegre", state: 'PI' },
    { code: '2205573', name: "Lagoa de São Francisco", state: 'PI' },
    { code: '2205565', name: "Lagoa do Barro do Piauí", state: 'PI' },
    { code: '2205581', name: "Lagoa do Piauí", state: 'PI' },
    { code: '2205599', name: "Lagoa do Sítio", state: 'PI' },
    { code: '2205540', name: "Lagoinha do Piauí", state: 'PI' },
    { code: '2205607', name: "Landri Sales", state: 'PI' },
    { code: '2205706', name: "Luís Correia", state: 'PI' },
    { code: '2205805', name: "Luzilândia", state: 'PI' },
    { code: '2205854', name: "Madeiro", state: 'PI' },
    { code: '2205904', name: "Manoel Emídio", state: 'PI' },
    { code: '2205953', name: "Marcolândia", state: 'PI' },
    { code: '2206001', name: "Marcos Parente", state: 'PI' },
    { code: '2206050', name: "Massapê do Piauí", state: 'PI' },
    { code: '2206100', name: "Matias Olímpio", state: 'PI' },
    { code: '2206209', name: "Miguel Alves", state: 'PI' },
    { code: '2206308', name: "Miguel Leão", state: 'PI' },
    { code: '2206357', name: "Milton Brandão", state: 'PI' },
    { code: '2206407', name: "Monsenhor Gil", state: 'PI' },
    { code: '2206506', name: "Monsenhor Hipólito", state: 'PI' },
    { code: '2206605', name: "Monte Alegre do Piauí", state: 'PI' },
    { code: '2206654', name: "Morro Cabeça no Tempo", state: 'PI' },
    { code: '2206670', name: "Morro do Chapéu do Piauí", state: 'PI' },
    { code: '2206696', name: "Murici dos Portelas", state: 'PI' },
    { code: '2206704', name: "Nazaré do Piauí", state: 'PI' },
    { code: '2206720', name: "Nazária", state: 'PI' },
    { code: '2206753', name: "Nossa Senhora de Nazaré", state: 'PI' },
    { code: '2206803', name: "Nossa Senhora dos Remédios", state: 'PI' },
    { code: '2207959', name: "Nova Santa Rita", state: 'PI' },
    { code: '2206902', name: "Novo Oriente do Piauí", state: 'PI' },
    { code: '2206951', name: "Novo Santo Antônio", state: 'PI' },
    { code: '2207009', name: "Oeiras", state: 'PI' },
    { code: '2207108', name: "Olho D'Água do Piauí", state: 'PI' },
    { code: '2207207', name: "Padre Marcos", state: 'PI' },
    { code: '2207306', name: "Paes Landim", state: 'PI' },
    { code: '2207355', name: "Pajeú do Piauí", state: 'PI' },
    { code: '2207405', name: "Palmeira do Piauí", state: 'PI' },
    { code: '2207504', name: "Palmeirais", state: 'PI' },
    { code: '2207553', name: "Paquetá", state: 'PI' },
    { code: '2207603', name: "Parnaguá", state: 'PI' },
    { code: '2207702', name: "Parnaíba", state: 'PI' },
    { code: '2207751', name: "Passagem Franca do Piauí", state: 'PI' },
    { code: '2207777', name: "Patos do Piauí", state: 'PI' },
    { code: '2207793', name: "Pau D'Arco do Piauí", state: 'PI' },
    { code: '2207801', name: "Paulistana", state: 'PI' },
    { code: '2207850', name: "Pavussu", state: 'PI' },
    { code: '2207900', name: "Pedro II", state: 'PI' },
    { code: '2207934', name: "Pedro Laurentino", state: 'PI' },
    { code: '2208007', name: "Picos", state: 'PI' },
    { code: '2208106', name: "Pimenteiras", state: 'PI' },
    { code: '2208205', name: "Pio IX", state: 'PI' },
    { code: '2208304', name: "Piracuruca", state: 'PI' },
    { code: '2208403', name: "Piripiri", state: 'PI' },
    { code: '2208502', name: "Porto", state: 'PI' },
    { code: '2208551', name: "Porto Alegre do Piauí", state: 'PI' },
    { code: '2208601', name: "Prata do Piauí", state: 'PI' },
    { code: '2208650', name: "Queimada Nova", state: 'PI' },
    { code: '2208700', name: "Redenção do Gurguéia", state: 'PI' },
    { code: '2208809', name: "Regeneração", state: 'PI' },
    { code: '2208858', name: "Riacho Frio", state: 'PI' },
    { code: '2208874', name: "Ribeira do Piauí", state: 'PI' },
    { code: '2208908', name: "Ribeiro Gonçalves", state: 'PI' },
    { code: '2209005', name: "Rio Grande do Piauí", state: 'PI' },
    { code: '2209104', name: "Santa Cruz do Piauí", state: 'PI' },
    { code: '2209153', name: "Santa Cruz dos Milagres", state: 'PI' },
    { code: '2209203', name: "Santa Filomena", state: 'PI' },
    { code: '2209302', name: "Santa Luz", state: 'PI' },
    { code: '2209377', name: "Santa Rosa do Piauí", state: 'PI' },
    { code: '2209351', name: "Santana do Piauí", state: 'PI' },
    { code: '2209401', name: "Santo Antônio de Lisboa", state: 'PI' },
    { code: '2209450', name: "Santo Antônio dos Milagres", state: 'PI' },
    { code: '2209500', name: "Santo Inácio do Piauí", state: 'PI' },
    { code: '2209559', name: "São Braz do Piauí", state: 'PI' },
    { code: '2209609', name: "São Félix do Piauí", state: 'PI' },
    { code: '2209658', name: "São Francisco de Assis do Piauí", state: 'PI' },
    { code: '2209708', name: "São Francisco do Piauí", state: 'PI' },
    { code: '2209757', name: "São Gonçalo do Gurguéia", state: 'PI' },
    { code: '2209807', name: "São Gonçalo do Piauí", state: 'PI' },
    { code: '2209856', name: "São João da Canabrava", state: 'PI' },
    { code: '2209872', name: "São João da Fronteira", state: 'PI' },
    { code: '2209906', name: "São João da Serra", state: 'PI' },
    { code: '2209955', name: "São João da Varjota", state: 'PI' },
    { code: '2209971', name: "São João do Arraial", state: 'PI' },
    { code: '2210003', name: "São João do Piauí", state: 'PI' },
    { code: '2210052', name: "São José do Divino", state: 'PI' },
    { code: '2210102', name: "São José do Peixe", state: 'PI' },
    { code: '2210201', name: "São José do Piauí", state: 'PI' },
    { code: '2210300', name: "São Julião", state: 'PI' },
    { code: '2210359', name: "São Lourenço do Piauí", state: 'PI' },
    { code: '2210375', name: "São Luis do Piauí", state: 'PI' },
    { code: '2210383', name: "São Miguel da Baixa Grande", state: 'PI' },
    { code: '2210391', name: "São Miguel do Fidalgo", state: 'PI' },
    { code: '2210409', name: "São Miguel do Tapuio", state: 'PI' },
    { code: '2210508', name: "São Pedro do Piauí", state: 'PI' },
    { code: '2210607', name: "São Raimundo Nonato", state: 'PI' },
    { code: '2210623', name: "Sebastião Barros", state: 'PI' },
    { code: '2210631', name: "Sebastião Leal", state: 'PI' },
    { code: '2210656', name: "Sigefredo Pacheco", state: 'PI' },
    { code: '2210706', name: "Simões", state: 'PI' },
    { code: '2210805', name: "Simplício Mendes", state: 'PI' },
    { code: '2210904', name: "Socorro do Piauí", state: 'PI' },
    { code: '2210938', name: "Sussuapara", state: 'PI' },
    { code: '2210953', name: "Tamboril do Piauí", state: 'PI' },
    { code: '2210979', name: "Tanque do Piauí", state: 'PI' },
    { code: '2211001', name: "Teresina", state: 'PI' },
    { code: '2211100', name: "União", state: 'PI' },
    { code: '2211209', name: "Uruçuí", state: 'PI' },
    { code: '2211308', name: "Valença do Piauí", state: 'PI' },
    { code: '2211357', name: "Várzea Branca", state: 'PI' },
    { code: '2211407', name: "Várzea Grande", state: 'PI' },
    { code: '2211506', name: "Vera Mendes", state: 'PI' },
    { code: '2211605', name: "Vila Nova do Piauí", state: 'PI' },
    { code: '2211704', name: "Wall Ferraz", state: 'PI' }
  ],

  // PARANÁ (PR) - 399 municípios
  PR: [
    { code: '4100103', name: "Abatiá", state: 'PR' },
    { code: '4100202', name: "Adrianópolis", state: 'PR' },
    { code: '4100301', name: "Agudos do Sul", state: 'PR' },
    { code: '4100400', name: "Almirante Tamandaré", state: 'PR' },
    { code: '4100459', name: "Altamira do Paraná", state: 'PR' },
    { code: '4128625', name: "Alto Paraíso", state: 'PR' },
    { code: '4100608', name: "Alto Paraná", state: 'PR' },
    { code: '4100707', name: "Alto Piquiri", state: 'PR' },
    { code: '4100509', name: "Altônia", state: 'PR' },
    { code: '4100806', name: "Alvorada do Sul", state: 'PR' },
    { code: '4100905', name: "Amaporã", state: 'PR' },
    { code: '4101002', name: "Ampére", state: 'PR' },
    { code: '4101051', name: "Anahy", state: 'PR' },
    { code: '4101101', name: "Andirá", state: 'PR' },
    { code: '4101150', name: "Ângulo", state: 'PR' },
    { code: '4101200', name: "Antonina", state: 'PR' },
    { code: '4101309', name: "Antônio Olinto", state: 'PR' },
    { code: '4101408', name: "Apucarana", state: 'PR' },
    { code: '4101507', name: "Arapongas", state: 'PR' },
    { code: '4101606', name: "Arapoti", state: 'PR' },
    { code: '4101655', name: "Arapuã", state: 'PR' },
    { code: '4101705', name: "Araruna", state: 'PR' },
    { code: '4101804', name: "Araucária", state: 'PR' },
    { code: '4101853', name: "Ariranha do Ivaí", state: 'PR' },
    { code: '4101903', name: "Assaí", state: 'PR' },
    { code: '4102000', name: "Assis Chateaubriand", state: 'PR' },
    { code: '4102109', name: "Astorga", state: 'PR' },
    { code: '4102208', name: "Atalaia", state: 'PR' },
    { code: '4102307', name: "Balsa Nova", state: 'PR' },
    { code: '4102406', name: "Bandeirantes", state: 'PR' },
    { code: '4102505', name: "Barbosa Ferraz", state: 'PR' },
    { code: '4102703', name: "Barra do Jacaré", state: 'PR' },
    { code: '4102604', name: "Barracão", state: 'PR' },
    { code: '4102752', name: "Bela Vista da Caroba", state: 'PR' },
    { code: '4102802', name: "Bela Vista do Paraíso", state: 'PR' },
    { code: '4102901', name: "Bituruna", state: 'PR' },
    { code: '4103008', name: "Boa Esperança", state: 'PR' },
    { code: '4103024', name: "Boa Esperança do Iguaçu", state: 'PR' },
    { code: '4103040', name: "Boa Ventura de São Roque", state: 'PR' },
    { code: '4103057', name: "Boa Vista da Aparecida", state: 'PR' },
    { code: '4103107', name: "Bocaiúva do Sul", state: 'PR' },
    { code: '4103156', name: "Bom Jesus do Sul", state: 'PR' },
    { code: '4103206', name: "Bom Sucesso", state: 'PR' },
    { code: '4103222', name: "Bom Sucesso do Sul", state: 'PR' },
    { code: '4103305', name: "Borrazópolis", state: 'PR' },
    { code: '4103354', name: "Braganey", state: 'PR' },
    { code: '4103370', name: "Brasilândia do Sul", state: 'PR' },
    { code: '4103404', name: "Cafeara", state: 'PR' },
    { code: '4103453', name: "Cafelândia", state: 'PR' },
    { code: '4103479', name: "Cafezal do Sul", state: 'PR' },
    { code: '4103503', name: "Califórnia", state: 'PR' },
    { code: '4103602', name: "Cambará", state: 'PR' },
    { code: '4103701', name: "Cambé", state: 'PR' },
    { code: '4103800', name: "Cambira", state: 'PR' },
    { code: '4103909', name: "Campina da Lagoa", state: 'PR' },
    { code: '4103958', name: "Campina do Simão", state: 'PR' },
    { code: '4104006', name: "Campina Grande do Sul", state: 'PR' },
    { code: '4104055', name: "Campo Bonito", state: 'PR' },
    { code: '4104105', name: "Campo do Tenente", state: 'PR' },
    { code: '4104204', name: "Campo Largo", state: 'PR' },
    { code: '4104253', name: "Campo Magro", state: 'PR' },
    { code: '4104303', name: "Campo Mourão", state: 'PR' },
    { code: '4104402', name: "Cândido de Abreu", state: 'PR' },
    { code: '4104428', name: "Candói", state: 'PR' },
    { code: '4104451', name: "Cantagalo", state: 'PR' },
    { code: '4104501', name: "Capanema", state: 'PR' },
    { code: '4104600', name: "Capitão Leônidas Marques", state: 'PR' },
    { code: '4104659', name: "Carambeí", state: 'PR' },
    { code: '4104709', name: "Carlópolis", state: 'PR' },
    { code: '4104808', name: "Cascavel", state: 'PR' },
    { code: '4104907', name: "Castro", state: 'PR' },
    { code: '4105003', name: "Catanduvas", state: 'PR' },
    { code: '4105102', name: "Centenário do Sul", state: 'PR' },
    { code: '4105201', name: "Cerro Azul", state: 'PR' },
    { code: '4105300', name: "Céu Azul", state: 'PR' },
    { code: '4105409', name: "Chopinzinho", state: 'PR' },
    { code: '4105508', name: "Cianorte", state: 'PR' },
    { code: '4105607', name: "Cidade Gaúcha", state: 'PR' },
    { code: '4105706', name: "Clevelândia", state: 'PR' },
    { code: '4105805', name: "Colombo", state: 'PR' },
    { code: '4105904', name: "Colorado", state: 'PR' },
    { code: '4106001', name: "Congonhinhas", state: 'PR' },
    { code: '4106100', name: "Conselheiro Mairinck", state: 'PR' },
    { code: '4106209', name: "Contenda", state: 'PR' },
    { code: '4106308', name: "Corbélia", state: 'PR' },
    { code: '4106407', name: "Cornélio Procópio", state: 'PR' },
    { code: '4106456', name: "Coronel Domingos Soares", state: 'PR' },
    { code: '4106506', name: "Coronel Vivida", state: 'PR' },
    { code: '4106555', name: "Corumbataí do Sul", state: 'PR' },
    { code: '4106803', name: "Cruz Machado", state: 'PR' },
    { code: '4106571', name: "Cruzeiro do Iguaçu", state: 'PR' },
    { code: '4106605', name: "Cruzeiro do Oeste", state: 'PR' },
    { code: '4106704', name: "Cruzeiro do Sul", state: 'PR' },
    { code: '4106852', name: "Cruzmaltina", state: 'PR' },
    { code: '4106902', name: "Curitiba", state: 'PR' },
    { code: '4107009', name: "Curiúva", state: 'PR' },
    { code: '4107157', name: "Diamante D'Oeste", state: 'PR' },
    { code: '4107108', name: "Diamante do Norte", state: 'PR' },
    { code: '4107124', name: "Diamante do Sul", state: 'PR' },
    { code: '4107207', name: "Dois Vizinhos", state: 'PR' },
    { code: '4107256', name: "Douradina", state: 'PR' },
    { code: '4107306', name: "Doutor Camargo", state: 'PR' },
    { code: '4128633', name: "Doutor Ulysses", state: 'PR' },
    { code: '4107405', name: "Enéas Marques", state: 'PR' },
    { code: '4107504', name: "Engenheiro Beltrão", state: 'PR' },
    { code: '4107538', name: "Entre Rios do Oeste", state: 'PR' },
    { code: '4107520', name: "Esperança Nova", state: 'PR' },
    { code: '4107546', name: "Espigão Alto do Iguaçu", state: 'PR' },
    { code: '4107553', name: "Farol", state: 'PR' },
    { code: '4107603', name: "Faxinal", state: 'PR' },
    { code: '4107652', name: "Fazenda Rio Grande", state: 'PR' },
    { code: '4107702', name: "Fênix", state: 'PR' },
    { code: '4107736', name: "Fernandes Pinheiro", state: 'PR' },
    { code: '4107751', name: "Figueira", state: 'PR' },
    { code: '4107850', name: "Flor da Serra do Sul", state: 'PR' },
    { code: '4107801', name: "Floraí", state: 'PR' },
    { code: '4107900', name: "Floresta", state: 'PR' },
    { code: '4108007', name: "Florestópolis", state: 'PR' },
    { code: '4108106', name: "Flórida", state: 'PR' },
    { code: '4108205', name: "Formosa do Oeste", state: 'PR' },
    { code: '4108304', name: "Foz do Iguaçu", state: 'PR' },
    { code: '4108452', name: "Foz do Jordão", state: 'PR' },
    { code: '4108320', name: "Francisco Alves", state: 'PR' },
    { code: '4108403', name: "Francisco Beltrão", state: 'PR' },
    { code: '4108502', name: "General Carneiro", state: 'PR' },
    { code: '4108551', name: "Godoy Moreira", state: 'PR' },
    { code: '4108601', name: "Goioerê", state: 'PR' },
    { code: '4108650', name: "Goioxim", state: 'PR' },
    { code: '4108700', name: "Grandes Rios", state: 'PR' },
    { code: '4108809', name: "Guaíra", state: 'PR' },
    { code: '4108908', name: "Guairaçá", state: 'PR' },
    { code: '4108957', name: "Guamiranga", state: 'PR' },
    { code: '4109005', name: "Guapirama", state: 'PR' },
    { code: '4109104', name: "Guaporema", state: 'PR' },
    { code: '4109203', name: "Guaraci", state: 'PR' },
    { code: '4109302', name: "Guaraniaçu", state: 'PR' },
    { code: '4109401', name: "Guarapuava", state: 'PR' },
    { code: '4109500', name: "Guaraqueçaba", state: 'PR' },
    { code: '4109609', name: "Guaratuba", state: 'PR' },
    { code: '4109658', name: "Honório Serpa", state: 'PR' },
    { code: '4109708', name: "Ibaiti", state: 'PR' },
    { code: '4109757', name: "Ibema", state: 'PR' },
    { code: '4109807', name: "Ibiporã", state: 'PR' },
    { code: '4109906', name: "Icaraíma", state: 'PR' },
    { code: '4110003', name: "Iguaraçu", state: 'PR' },
    { code: '4110052', name: "Iguatu", state: 'PR' },
    { code: '4110078', name: "Imbaú", state: 'PR' },
    { code: '4110102', name: "Imbituva", state: 'PR' },
    { code: '4110201', name: "Inácio Martins", state: 'PR' },
    { code: '4110300', name: "Inajá", state: 'PR' },
    { code: '4110409', name: "Indianópolis", state: 'PR' },
    { code: '4110508', name: "Ipiranga", state: 'PR' },
    { code: '4110607', name: "Iporã", state: 'PR' },
    { code: '4110656', name: "Iracema do Oeste", state: 'PR' },
    { code: '4110706', name: "Irati", state: 'PR' },
    { code: '4110805', name: "Iretama", state: 'PR' },
    { code: '4110904', name: "Itaguajé", state: 'PR' },
    { code: '4110953', name: "Itaipulândia", state: 'PR' },
    { code: '4111001', name: "Itambaracá", state: 'PR' },
    { code: '4111100', name: "Itambé", state: 'PR' },
    { code: '4111209', name: "Itapejara d'Oeste", state: 'PR' },
    { code: '4111258', name: "Itaperuçu", state: 'PR' },
    { code: '4111308', name: "Itaúna do Sul", state: 'PR' },
    { code: '4111407', name: "Ivaí", state: 'PR' },
    { code: '4111506', name: "Ivaiporã", state: 'PR' },
    { code: '4111555', name: "Ivaté", state: 'PR' },
    { code: '4111605', name: "Ivatuba", state: 'PR' },
    { code: '4111704', name: "Jaboti", state: 'PR' },
    { code: '4111803', name: "Jacarezinho", state: 'PR' },
    { code: '4111902', name: "Jaguapitã", state: 'PR' },
    { code: '4112009', name: "Jaguariaíva", state: 'PR' },
    { code: '4112108', name: "Jandaia do Sul", state: 'PR' },
    { code: '4112207', name: "Janiópolis", state: 'PR' },
    { code: '4112306', name: "Japira", state: 'PR' },
    { code: '4112405', name: "Japurá", state: 'PR' },
    { code: '4112504', name: "Jardim Alegre", state: 'PR' },
    { code: '4112603', name: "Jardim Olinda", state: 'PR' },
    { code: '4112702', name: "Jataizinho", state: 'PR' },
    { code: '4112751', name: "Jesuítas", state: 'PR' },
    { code: '4112801', name: "Joaquim Távora", state: 'PR' },
    { code: '4112900', name: "Jundiaí do Sul", state: 'PR' },
    { code: '4112959', name: "Juranda", state: 'PR' },
    { code: '4113007', name: "Jussara", state: 'PR' },
    { code: '4113106', name: "Kaloré", state: 'PR' },
    { code: '4113205', name: "Lapa", state: 'PR' },
    { code: '4113254', name: "Laranjal", state: 'PR' },
    { code: '4113304', name: "Laranjeiras do Sul", state: 'PR' },
    { code: '4113403', name: "Leópolis", state: 'PR' },
    { code: '4113429', name: "Lidianópolis", state: 'PR' },
    { code: '4113452', name: "Lindoeste", state: 'PR' },
    { code: '4113502', name: "Loanda", state: 'PR' },
    { code: '4113601', name: "Lobato", state: 'PR' },
    { code: '4113700', name: "Londrina", state: 'PR' },
    { code: '4113734', name: "Luiziana", state: 'PR' },
    { code: '4113759', name: "Lunardelli", state: 'PR' },
    { code: '4113809', name: "Lupionópolis", state: 'PR' },
    { code: '4113908', name: "Mallet", state: 'PR' },
    { code: '4114005', name: "Mamborê", state: 'PR' },
    { code: '4114104', name: "Mandaguaçu", state: 'PR' },
    { code: '4114203', name: "Mandaguari", state: 'PR' },
    { code: '4114302', name: "Mandirituba", state: 'PR' },
    { code: '4114351', name: "Manfrinópolis", state: 'PR' },
    { code: '4114401', name: "Mangueirinha", state: 'PR' },
    { code: '4114500', name: "Manoel Ribas", state: 'PR' },
    { code: '4114609', name: "Marechal Cândido Rondon", state: 'PR' },
    { code: '4114708', name: "Maria Helena", state: 'PR' },
    { code: '4114807', name: "Marialva", state: 'PR' },
    { code: '4114906', name: "Marilândia do Sul", state: 'PR' },
    { code: '4115002', name: "Marilena", state: 'PR' },
    { code: '4115101', name: "Mariluz", state: 'PR' },
    { code: '4115200', name: "Maringá", state: 'PR' },
    { code: '4115309', name: "Mariópolis", state: 'PR' },
    { code: '4115358', name: "Maripá", state: 'PR' },
    { code: '4115408', name: "Marmeleiro", state: 'PR' },
    { code: '4115457', name: "Marquinho", state: 'PR' },
    { code: '4115507', name: "Marumbi", state: 'PR' },
    { code: '4115606', name: "Matelândia", state: 'PR' },
    { code: '4115705', name: "Matinhos", state: 'PR' },
    { code: '4115739', name: "Mato Rico", state: 'PR' },
    { code: '4115754', name: "Mauá da Serra", state: 'PR' },
    { code: '4115804', name: "Medianeira", state: 'PR' },
    { code: '4115853', name: "Mercedes", state: 'PR' },
    { code: '4115903', name: "Mirador", state: 'PR' },
    { code: '4116000', name: "Miraselva", state: 'PR' },
    { code: '4116059', name: "Missal", state: 'PR' },
    { code: '4116109', name: "Moreira Sales", state: 'PR' },
    { code: '4116208', name: "Morretes", state: 'PR' },
    { code: '4116307', name: "Munhoz de Melo", state: 'PR' },
    { code: '4116406', name: "Nossa Senhora das Graças", state: 'PR' },
    { code: '4116505', name: "Nova Aliança do Ivaí", state: 'PR' },
    { code: '4116604', name: "Nova América da Colina", state: 'PR' },
    { code: '4116703', name: "Nova Aurora", state: 'PR' },
    { code: '4116802', name: "Nova Cantu", state: 'PR' },
    { code: '4116901', name: "Nova Esperança", state: 'PR' },
    { code: '4116950', name: "Nova Esperança do Sudoeste", state: 'PR' },
    { code: '4117008', name: "Nova Fátima", state: 'PR' },
    { code: '4117057', name: "Nova Laranjeiras", state: 'PR' },
    { code: '4117107', name: "Nova Londrina", state: 'PR' },
    { code: '4117206', name: "Nova Olímpia", state: 'PR' },
    { code: '4117255', name: "Nova Prata do Iguaçu", state: 'PR' },
    { code: '4117214', name: "Nova Santa Bárbara", state: 'PR' },
    { code: '4117222', name: "Nova Santa Rosa", state: 'PR' },
    { code: '4117271', name: "Nova Tebas", state: 'PR' },
    { code: '4117297', name: "Novo Itacolomi", state: 'PR' },
    { code: '4117305', name: "Ortigueira", state: 'PR' },
    { code: '4117404', name: "Ourizona", state: 'PR' },
    { code: '4117453', name: "Ouro Verde do Oeste", state: 'PR' },
    { code: '4117503', name: "Paiçandu", state: 'PR' },
    { code: '4117602', name: "Palmas", state: 'PR' },
    { code: '4117701', name: "Palmeira", state: 'PR' },
    { code: '4117800', name: "Palmital", state: 'PR' },
    { code: '4117909', name: "Palotina", state: 'PR' },
    { code: '4118006', name: "Paraíso do Norte", state: 'PR' },
    { code: '4118105', name: "Paranacity", state: 'PR' },
    { code: '4118204', name: "Paranaguá", state: 'PR' },
    { code: '4118303', name: "Paranapoema", state: 'PR' },
    { code: '4118402', name: "Paranavaí", state: 'PR' },
    { code: '4118451', name: "Pato Bragado", state: 'PR' },
    { code: '4118501', name: "Pato Branco", state: 'PR' },
    { code: '4118600', name: "Paula Freitas", state: 'PR' },
    { code: '4118709', name: "Paulo Frontin", state: 'PR' },
    { code: '4118808', name: "Peabiru", state: 'PR' },
    { code: '4118857', name: "Perobal", state: 'PR' },
    { code: '4118907', name: "Pérola", state: 'PR' },
    { code: '4119004', name: "Pérola d'Oeste", state: 'PR' },
    { code: '4119103', name: "Piên", state: 'PR' },
    { code: '4119152', name: "Pinhais", state: 'PR' },
    { code: '4119251', name: "Pinhal de São Bento", state: 'PR' },
    { code: '4119202', name: "Pinhalão", state: 'PR' },
    { code: '4119301', name: "Pinhão", state: 'PR' },
    { code: '4119400', name: "Piraí do Sul", state: 'PR' },
    { code: '4119509', name: "Piraquara", state: 'PR' },
    { code: '4119608', name: "Pitanga", state: 'PR' },
    { code: '4119657', name: "Pitangueiras", state: 'PR' },
    { code: '4119707', name: "Planaltina do Paraná", state: 'PR' },
    { code: '4119806', name: "Planalto", state: 'PR' },
    { code: '4119905', name: "Ponta Grossa", state: 'PR' },
    { code: '4119954', name: "Pontal do Paraná", state: 'PR' },
    { code: '4120002', name: "Porecatu", state: 'PR' },
    { code: '4120101', name: "Porto Amazonas", state: 'PR' },
    { code: '4120150', name: "Porto Barreiro", state: 'PR' },
    { code: '4120200', name: "Porto Rico", state: 'PR' },
    { code: '4120309', name: "Porto Vitória", state: 'PR' },
    { code: '4120333', name: "Prado Ferreira", state: 'PR' },
    { code: '4120358', name: "Pranchita", state: 'PR' },
    { code: '4120408', name: "Presidente Castelo Branco", state: 'PR' },
    { code: '4120507', name: "Primeiro de Maio", state: 'PR' },
    { code: '4120606', name: "Prudentópolis", state: 'PR' },
    { code: '4120655', name: "Quarto Centenário", state: 'PR' },
    { code: '4120705', name: "Quatiguá", state: 'PR' },
    { code: '4120804', name: "Quatro Barras", state: 'PR' },
    { code: '4120853', name: "Quatro Pontes", state: 'PR' },
    { code: '4120903', name: "Quedas do Iguaçu", state: 'PR' },
    { code: '4121000', name: "Querência do Norte", state: 'PR' },
    { code: '4121109', name: "Quinta do Sol", state: 'PR' },
    { code: '4121208', name: "Quitandinha", state: 'PR' },
    { code: '4121257', name: "Ramilândia", state: 'PR' },
    { code: '4121307', name: "Rancho Alegre", state: 'PR' },
    { code: '4121356', name: "Rancho Alegre D'Oeste", state: 'PR' },
    { code: '4121406', name: "Realeza", state: 'PR' },
    { code: '4121505', name: "Rebouças", state: 'PR' },
    { code: '4121604', name: "Renascença", state: 'PR' },
    { code: '4121703', name: "Reserva", state: 'PR' },
    { code: '4121752', name: "Reserva do Iguaçu", state: 'PR' },
    { code: '4121802', name: "Ribeirão Claro", state: 'PR' },
    { code: '4121901', name: "Ribeirão do Pinhal", state: 'PR' },
    { code: '4122008', name: "Rio Azul", state: 'PR' },
    { code: '4122107', name: "Rio Bom", state: 'PR' },
    { code: '4122156', name: "Rio Bonito do Iguaçu", state: 'PR' },
    { code: '4122172', name: "Rio Branco do Ivaí", state: 'PR' },
    { code: '4122206', name: "Rio Branco do Sul", state: 'PR' },
    { code: '4122305', name: "Rio Negro", state: 'PR' },
    { code: '4122404', name: "Rolândia", state: 'PR' },
    { code: '4122503', name: "Roncador", state: 'PR' },
    { code: '4122602', name: "Rondon", state: 'PR' },
    { code: '4122651', name: "Rosário do Ivaí", state: 'PR' },
    { code: '4122701', name: "Sabáudia", state: 'PR' },
    { code: '4122800', name: "Salgado Filho", state: 'PR' },
    { code: '4122909', name: "Salto do Itararé", state: 'PR' },
    { code: '4123006', name: "Salto do Lontra", state: 'PR' },
    { code: '4123105', name: "Santa Amélia", state: 'PR' },
    { code: '4123204', name: "Santa Cecília do Pavão", state: 'PR' },
    { code: '4123303', name: "Santa Cruz de Monte Castelo", state: 'PR' },
    { code: '4123402', name: "Santa Fé", state: 'PR' },
    { code: '4123501', name: "Santa Helena", state: 'PR' },
    { code: '4123600', name: "Santa Inês", state: 'PR' },
    { code: '4123709', name: "Santa Isabel do Ivaí", state: 'PR' },
    { code: '4123808', name: "Santa Izabel do Oeste", state: 'PR' },
    { code: '4123824', name: "Santa Lúcia", state: 'PR' },
    { code: '4123857', name: "Santa Maria do Oeste", state: 'PR' },
    { code: '4123907', name: "Santa Mariana", state: 'PR' },
    { code: '4123956', name: "Santa Mônica", state: 'PR' },
    { code: '4124020', name: "Santa Tereza do Oeste", state: 'PR' },
    { code: '4124053', name: "Santa Terezinha de Itaipu", state: 'PR' },
    { code: '4124004', name: "Santana do Itararé", state: 'PR' },
    { code: '4124103', name: "Santo Antônio da Platina", state: 'PR' },
    { code: '4124202', name: "Santo Antônio do Caiuá", state: 'PR' },
    { code: '4124301', name: "Santo Antônio do Paraíso", state: 'PR' },
    { code: '4124400', name: "Santo Antônio do Sudoeste", state: 'PR' },
    { code: '4124509', name: "Santo Inácio", state: 'PR' },
    { code: '4124608', name: "São Carlos do Ivaí", state: 'PR' },
    { code: '4124707', name: "São Jerônimo da Serra", state: 'PR' },
    { code: '4124806', name: "São João", state: 'PR' },
    { code: '4124905', name: "São João do Caiuá", state: 'PR' },
    { code: '4125001', name: "São João do Ivaí", state: 'PR' },
    { code: '4125100', name: "São João do Triunfo", state: 'PR' },
    { code: '4125209', name: "São Jorge d'Oeste", state: 'PR' },
    { code: '4125308', name: "São Jorge do Ivaí", state: 'PR' },
    { code: '4125357', name: "São Jorge do Patrocínio", state: 'PR' },
    { code: '4125407', name: "São José da Boa Vista", state: 'PR' },
    { code: '4125456', name: "São José das Palmeiras", state: 'PR' },
    { code: '4125506', name: "São José dos Pinhais", state: 'PR' },
    { code: '4125555', name: "São Manoel do Paraná", state: 'PR' },
    { code: '4125605', name: "São Mateus do Sul", state: 'PR' },
    { code: '4125704', name: "São Miguel do Iguaçu", state: 'PR' },
    { code: '4125753', name: "São Pedro do Iguaçu", state: 'PR' },
    { code: '4125803', name: "São Pedro do Ivaí", state: 'PR' },
    { code: '4125902', name: "São Pedro do Paraná", state: 'PR' },
    { code: '4126009', name: "São Sebastião da Amoreira", state: 'PR' },
    { code: '4126108', name: "São Tomé", state: 'PR' },
    { code: '4126207', name: "Sapopema", state: 'PR' },
    { code: '4126256', name: "Sarandi", state: 'PR' },
    { code: '4126272', name: "Saudade do Iguaçu", state: 'PR' },
    { code: '4126306', name: "Sengés", state: 'PR' },
    { code: '4126355', name: "Serranópolis do Iguaçu", state: 'PR' },
    { code: '4126405', name: "Sertaneja", state: 'PR' },
    { code: '4126504', name: "Sertanópolis", state: 'PR' },
    { code: '4126603', name: "Siqueira Campos", state: 'PR' },
    { code: '4126652', name: "Sulina", state: 'PR' },
    { code: '4126678', name: "Tamarana", state: 'PR' },
    { code: '4126702', name: "Tamboara", state: 'PR' },
    { code: '4126801', name: "Tapejara", state: 'PR' },
    { code: '4126900', name: "Tapira", state: 'PR' },
    { code: '4127007', name: "Teixeira Soares", state: 'PR' },
    { code: '4127106', name: "Telêmaco Borba", state: 'PR' },
    { code: '4127205', name: "Terra Boa", state: 'PR' },
    { code: '4127304', name: "Terra Rica", state: 'PR' },
    { code: '4127403', name: "Terra Roxa", state: 'PR' },
    { code: '4127502', name: "Tibagi", state: 'PR' },
    { code: '4127601', name: "Tijucas do Sul", state: 'PR' },
    { code: '4127700', name: "Toledo", state: 'PR' },
    { code: '4127809', name: "Tomazina", state: 'PR' },
    { code: '4127858', name: "Três Barras do Paraná", state: 'PR' },
    { code: '4127882', name: "Tunas do Paraná", state: 'PR' },
    { code: '4127908', name: "Tuneiras do Oeste", state: 'PR' },
    { code: '4127957', name: "Tupãssi", state: 'PR' },
    { code: '4127965', name: "Turvo", state: 'PR' },
    { code: '4128005', name: "Ubiratã", state: 'PR' },
    { code: '4128104', name: "Umuarama", state: 'PR' },
    { code: '4128203', name: "União da Vitória", state: 'PR' },
    { code: '4128302', name: "Uniflor", state: 'PR' },
    { code: '4128401', name: "Uraí", state: 'PR' },
    { code: '4128534', name: "Ventania", state: 'PR' },
    { code: '4128559', name: "Vera Cruz do Oeste", state: 'PR' },
    { code: '4128609', name: "Verê", state: 'PR' },
    { code: '4128658', name: "Virmond", state: 'PR' },
    { code: '4128708', name: "Vitorino", state: 'PR' },
    { code: '4128500', name: "Wenceslau Braz", state: 'PR' },
    { code: '4128807', name: "Xambrê", state: 'PR' }
  ],

  // RIO DE JANEIRO (RJ) - 92 municípios
  RJ: [
    { code: '3300100', name: "Angra dos Reis", state: 'RJ' },
    { code: '3300159', name: "Aperibé", state: 'RJ' },
    { code: '3300209', name: "Araruama", state: 'RJ' },
    { code: '3300225', name: "Areal", state: 'RJ' },
    { code: '3300233', name: "Armação dos Búzios", state: 'RJ' },
    { code: '3300258', name: "Arraial do Cabo", state: 'RJ' },
    { code: '3300308', name: "Barra do Piraí", state: 'RJ' },
    { code: '3300407', name: "Barra Mansa", state: 'RJ' },
    { code: '3300456', name: "Belford Roxo", state: 'RJ' },
    { code: '3300506', name: "Bom Jardim", state: 'RJ' },
    { code: '3300605', name: "Bom Jesus do Itabapoana", state: 'RJ' },
    { code: '3300704', name: "Cabo Frio", state: 'RJ' },
    { code: '3300803', name: "Cachoeiras de Macacu", state: 'RJ' },
    { code: '3300902', name: "Cambuci", state: 'RJ' },
    { code: '3301009', name: "Campos dos Goytacazes", state: 'RJ' },
    { code: '3301108', name: "Cantagalo", state: 'RJ' },
    { code: '3300936', name: "Carapebus", state: 'RJ' },
    { code: '3301157', name: "Cardoso Moreira", state: 'RJ' },
    { code: '3301207', name: "Carmo", state: 'RJ' },
    { code: '3301306', name: "Casimiro de Abreu", state: 'RJ' },
    { code: '3300951', name: "Comendador Levy Gasparian", state: 'RJ' },
    { code: '3301405', name: "Conceição de Macabu", state: 'RJ' },
    { code: '3301504', name: "Cordeiro", state: 'RJ' },
    { code: '3301603', name: "Duas Barras", state: 'RJ' },
    { code: '3301702', name: "Duque de Caxias", state: 'RJ' },
    { code: '3301801', name: "Engenheiro Paulo de Frontin", state: 'RJ' },
    { code: '3301850', name: "Guapimirim", state: 'RJ' },
    { code: '3301876', name: "Iguaba Grande", state: 'RJ' },
    { code: '3301900', name: "Itaboraí", state: 'RJ' },
    { code: '3302007', name: "Itaguaí", state: 'RJ' },
    { code: '3302056', name: "Italva", state: 'RJ' },
    { code: '3302106', name: "Itaocara", state: 'RJ' },
    { code: '3302205', name: "Itaperuna", state: 'RJ' },
    { code: '3302254', name: "Itatiaia", state: 'RJ' },
    { code: '3302270', name: "Japeri", state: 'RJ' },
    { code: '3302304', name: "Laje do Muriaé", state: 'RJ' },
    { code: '3302403', name: "Macaé", state: 'RJ' },
    { code: '3302452', name: "Macuco", state: 'RJ' },
    { code: '3302502', name: "Magé", state: 'RJ' },
    { code: '3302601', name: "Mangaratiba", state: 'RJ' },
    { code: '3302700', name: "Maricá", state: 'RJ' },
    { code: '3302809', name: "Mendes", state: 'RJ' },
    { code: '3302858', name: "Mesquita", state: 'RJ' },
    { code: '3302908', name: "Miguel Pereira", state: 'RJ' },
    { code: '3303005', name: "Miracema", state: 'RJ' },
    { code: '3303104', name: "Natividade", state: 'RJ' },
    { code: '3303203', name: "Nilópolis", state: 'RJ' },
    { code: '3303302', name: "Niterói", state: 'RJ' },
    { code: '3303401', name: "Nova Friburgo", state: 'RJ' },
    { code: '3303500', name: "Nova Iguaçu", state: 'RJ' },
    { code: '3303609', name: "Paracambi", state: 'RJ' },
    { code: '3303708', name: "Paraíba do Sul", state: 'RJ' },
    { code: '3303807', name: "Paraty", state: 'RJ' },
    { code: '3303856', name: "Paty do Alferes", state: 'RJ' },
    { code: '3303906', name: "Petrópolis", state: 'RJ' },
    { code: '3303955', name: "Pinheiral", state: 'RJ' },
    { code: '3304003', name: "Piraí", state: 'RJ' },
    { code: '3304102', name: "Porciúncula", state: 'RJ' },
    { code: '3304110', name: "Porto Real", state: 'RJ' },
    { code: '3304128', name: "Quatis", state: 'RJ' },
    { code: '3304144', name: "Queimados", state: 'RJ' },
    { code: '3304151', name: "Quissamã", state: 'RJ' },
    { code: '3304201', name: "Resende", state: 'RJ' },
    { code: '3304300', name: "Rio Bonito", state: 'RJ' },
    { code: '3304409', name: "Rio Claro", state: 'RJ' },
    { code: '3304508', name: "Rio das Flores", state: 'RJ' },
    { code: '3304524', name: "Rio das Ostras", state: 'RJ' },
    { code: '3304557', name: "Rio de Janeiro", state: 'RJ' },
    { code: '3304607', name: "Santa Maria Madalena", state: 'RJ' },
    { code: '3304706', name: "Santo Antônio de Pádua", state: 'RJ' },
    { code: '3304805', name: "São Fidélis", state: 'RJ' },
    { code: '3304755', name: "São Francisco de Itabapoana", state: 'RJ' },
    { code: '3304904', name: "São Gonçalo", state: 'RJ' },
    { code: '3305000', name: "São João da Barra", state: 'RJ' },
    { code: '3305109', name: "São João de Meriti", state: 'RJ' },
    { code: '3305133', name: "São José de Ubá", state: 'RJ' },
    { code: '3305158', name: "São José do Vale do Rio Preto", state: 'RJ' },
    { code: '3305208', name: "São Pedro da Aldeia", state: 'RJ' },
    { code: '3305307', name: "São Sebastião do Alto", state: 'RJ' },
    { code: '3305406', name: "Sapucaia", state: 'RJ' },
    { code: '3305505', name: "Saquarema", state: 'RJ' },
    { code: '3305554', name: "Seropédica", state: 'RJ' },
    { code: '3305604', name: "Silva Jardim", state: 'RJ' },
    { code: '3305703', name: "Sumidouro", state: 'RJ' },
    { code: '3305752', name: "Tanguá", state: 'RJ' },
    { code: '3305802', name: "Teresópolis", state: 'RJ' },
    { code: '3305901', name: "Trajano de Moraes", state: 'RJ' },
    { code: '3306008', name: "Três Rios", state: 'RJ' },
    { code: '3306107', name: "Valença", state: 'RJ' },
    { code: '3306156', name: "Varre-Sai", state: 'RJ' },
    { code: '3306206', name: "Vassouras", state: 'RJ' },
    { code: '3306305', name: "Volta Redonda", state: 'RJ' }
  ],

  // RIO GRANDE DO NORTE (RN) - 167 municípios
  RN: [
    { code: '2400109', name: "Acari", state: 'RN' },
    { code: '2400208', name: "Açu", state: 'RN' },
    { code: '2400307', name: "Afonso Bezerra", state: 'RN' },
    { code: '2400406', name: "Água Nova", state: 'RN' },
    { code: '2400505', name: "Alexandria", state: 'RN' },
    { code: '2400604', name: "Almino Afonso", state: 'RN' },
    { code: '2400703', name: "Alto do Rodrigues", state: 'RN' },
    { code: '2400802', name: "Angicos", state: 'RN' },
    { code: '2400901', name: "Antônio Martins", state: 'RN' },
    { code: '2401008', name: "Apodi", state: 'RN' },
    { code: '2401107', name: "Areia Branca", state: 'RN' },
    { code: '2401206', name: "Arês", state: 'RN' },
    { code: '2401404', name: "Baía Formosa", state: 'RN' },
    { code: '2401453', name: "Baraúna", state: 'RN' },
    { code: '2401503', name: "Barcelona", state: 'RN' },
    { code: '2401602', name: "Bento Fernandes", state: 'RN' },
    { code: '2401651', name: "Bodó", state: 'RN' },
    { code: '2401701', name: "Bom Jesus", state: 'RN' },
    { code: '2401800', name: "Brejinho", state: 'RN' },
    { code: '2401859', name: "Caiçara do Norte", state: 'RN' },
    { code: '2401909', name: "Caiçara do Rio do Vento", state: 'RN' },
    { code: '2402006', name: "Caicó", state: 'RN' },
    { code: '2401305', name: "Campo Grande", state: 'RN' },
    { code: '2402105', name: "Campo Redondo", state: 'RN' },
    { code: '2402204', name: "Canguaretama", state: 'RN' },
    { code: '2402303', name: "Caraúbas", state: 'RN' },
    { code: '2402402', name: "Carnaúba dos Dantas", state: 'RN' },
    { code: '2402501', name: "Carnaubais", state: 'RN' },
    { code: '2402600', name: "Ceará-Mirim", state: 'RN' },
    { code: '2402709', name: "Cerro Corá", state: 'RN' },
    { code: '2402808', name: "Coronel Ezequiel", state: 'RN' },
    { code: '2402907', name: "Coronel João Pessoa", state: 'RN' },
    { code: '2403004', name: "Cruzeta", state: 'RN' },
    { code: '2403103', name: "Currais Novos", state: 'RN' },
    { code: '2403202', name: "Doutor Severiano", state: 'RN' },
    { code: '2403301', name: "Encanto", state: 'RN' },
    { code: '2403400', name: "Equador", state: 'RN' },
    { code: '2403509', name: "Espírito Santo", state: 'RN' },
    { code: '2403608', name: "Extremoz", state: 'RN' },
    { code: '2403707', name: "Felipe Guerra", state: 'RN' },
    { code: '2403756', name: "Fernando Pedroza", state: 'RN' },
    { code: '2403806', name: "Florânia", state: 'RN' },
    { code: '2403905', name: "Francisco Dantas", state: 'RN' },
    { code: '2404002', name: "Frutuoso Gomes", state: 'RN' },
    { code: '2404101', name: "Galinhos", state: 'RN' },
    { code: '2404200', name: "Goianinha", state: 'RN' },
    { code: '2404309', name: "Governador Dix-Sept Rosado", state: 'RN' },
    { code: '2404408', name: "Grossos", state: 'RN' },
    { code: '2404507', name: "Guamaré", state: 'RN' },
    { code: '2404606', name: "Ielmo Marinho", state: 'RN' },
    { code: '2404705', name: "Ipanguaçu", state: 'RN' },
    { code: '2404804', name: "Ipueira", state: 'RN' },
    { code: '2404853', name: "Itajá", state: 'RN' },
    { code: '2404903', name: "Itaú", state: 'RN' },
    { code: '2405009', name: "Jaçanã", state: 'RN' },
    { code: '2405108', name: "Jandaíra", state: 'RN' },
    { code: '2405207', name: "Janduís", state: 'RN' },
    { code: '2405306', name: "Januário Cicco", state: 'RN' },
    { code: '2405405', name: "Japi", state: 'RN' },
    { code: '2405504', name: "Jardim de Angicos", state: 'RN' },
    { code: '2405603', name: "Jardim de Piranhas", state: 'RN' },
    { code: '2405702', name: "Jardim do Seridó", state: 'RN' },
    { code: '2405801', name: "João Câmara", state: 'RN' },
    { code: '2405900', name: "João Dias", state: 'RN' },
    { code: '2406007', name: "José da Penha", state: 'RN' },
    { code: '2406106', name: "Jucurutu", state: 'RN' },
    { code: '2406155', name: "Jundiá", state: 'RN' },
    { code: '2406205', name: "Lagoa d'Anta", state: 'RN' },
    { code: '2406304', name: "Lagoa de Pedras", state: 'RN' },
    { code: '2406403', name: "Lagoa de Velhos", state: 'RN' },
    { code: '2406502', name: "Lagoa Nova", state: 'RN' },
    { code: '2406601', name: "Lagoa Salgada", state: 'RN' },
    { code: '2406700', name: "Lajes", state: 'RN' },
    { code: '2406809', name: "Lajes Pintadas", state: 'RN' },
    { code: '2406908', name: "Lucrécia", state: 'RN' },
    { code: '2407005', name: "Luís Gomes", state: 'RN' },
    { code: '2407104', name: "Macaíba", state: 'RN' },
    { code: '2407203', name: "Macau", state: 'RN' },
    { code: '2407252', name: "Major Sales", state: 'RN' },
    { code: '2407302', name: "Marcelino Vieira", state: 'RN' },
    { code: '2407401', name: "Martins", state: 'RN' },
    { code: '2407500', name: "Maxaranguape", state: 'RN' },
    { code: '2407609', name: "Messias Targino", state: 'RN' },
    { code: '2407708', name: "Montanhas", state: 'RN' },
    { code: '2407807', name: "Monte Alegre", state: 'RN' },
    { code: '2407906', name: "Monte das Gameleiras", state: 'RN' },
    { code: '2408003', name: "Mossoró", state: 'RN' },
    { code: '2408102', name: "Natal", state: 'RN' },
    { code: '2408201', name: "Nísia Floresta", state: 'RN' },
    { code: '2408300', name: "Nova Cruz", state: 'RN' },
    { code: '2408409', name: "Olho d'Água do Borges", state: 'RN' },
    { code: '2408508', name: "Ouro Branco", state: 'RN' },
    { code: '2408607', name: "Paraná", state: 'RN' },
    { code: '2408706', name: "Paraú", state: 'RN' },
    { code: '2408805', name: "Parazinho", state: 'RN' },
    { code: '2408904', name: "Parelhas", state: 'RN' },
    { code: '2403251', name: "Parnamirim", state: 'RN' },
    { code: '2409100', name: "Passa e Fica", state: 'RN' },
    { code: '2409209', name: "Passagem", state: 'RN' },
    { code: '2409308', name: "Patu", state: 'RN' },
    { code: '2409407', name: "Pau dos Ferros", state: 'RN' },
    { code: '2409506', name: "Pedra Grande", state: 'RN' },
    { code: '2409605', name: "Pedra Preta", state: 'RN' },
    { code: '2409704', name: "Pedro Avelino", state: 'RN' },
    { code: '2409803', name: "Pedro Velho", state: 'RN' },
    { code: '2409902', name: "Pendências", state: 'RN' },
    { code: '2410009', name: "Pilões", state: 'RN' },
    { code: '2410108', name: "Poço Branco", state: 'RN' },
    { code: '2410207', name: "Portalegre", state: 'RN' },
    { code: '2410256', name: "Porto do Mangue", state: 'RN' },
    { code: '2410405', name: "Pureza", state: 'RN' },
    { code: '2410504', name: "Rafael Fernandes", state: 'RN' },
    { code: '2410603', name: "Rafael Godeiro", state: 'RN' },
    { code: '2410702', name: "Riacho da Cruz", state: 'RN' },
    { code: '2410801', name: "Riacho de Santana", state: 'RN' },
    { code: '2410900', name: "Riachuelo", state: 'RN' },
    { code: '2408953', name: "Rio do Fogo", state: 'RN' },
    { code: '2411007', name: "Rodolfo Fernandes", state: 'RN' },
    { code: '2411106', name: "Ruy Barbosa", state: 'RN' },
    { code: '2411205', name: "Santa Cruz", state: 'RN' },
    { code: '2409332', name: "Santa Maria", state: 'RN' },
    { code: '2411403', name: "Santana do Matos", state: 'RN' },
    { code: '2411429', name: "Santana do Seridó", state: 'RN' },
    { code: '2411502', name: "Santo Antônio", state: 'RN' },
    { code: '2411601', name: "São Bento do Norte", state: 'RN' },
    { code: '2411700', name: "São Bento do Trairí", state: 'RN' },
    { code: '2411809', name: "São Fernando", state: 'RN' },
    { code: '2411908', name: "São Francisco do Oeste", state: 'RN' },
    { code: '2412005', name: "São Gonçalo do Amarante", state: 'RN' },
    { code: '2412104', name: "São João do Sabugi", state: 'RN' },
    { code: '2412203', name: "São José de Mipibu", state: 'RN' },
    { code: '2412302', name: "São José do Campestre", state: 'RN' },
    { code: '2412401', name: "São José do Seridó", state: 'RN' },
    { code: '2412500', name: "São Miguel", state: 'RN' },
    { code: '2412559', name: "São Miguel do Gostoso", state: 'RN' },
    { code: '2412609', name: "São Paulo do Potengi", state: 'RN' },
    { code: '2412708', name: "São Pedro", state: 'RN' },
    { code: '2412807', name: "São Rafael", state: 'RN' },
    { code: '2412906', name: "São Tomé", state: 'RN' },
    { code: '2413003', name: "São Vicente", state: 'RN' },
    { code: '2413102', name: "Senador Elói de Souza", state: 'RN' },
    { code: '2413201', name: "Senador Georgino Avelino", state: 'RN' },
    { code: '2410306', name: "Serra Caiada", state: 'RN' },
    { code: '2413300', name: "Serra de São Bento", state: 'RN' },
    { code: '2413359', name: "Serra do Mel", state: 'RN' },
    { code: '2413409', name: "Serra Negra do Norte", state: 'RN' },
    { code: '2413508', name: "Serrinha", state: 'RN' },
    { code: '2413557', name: "Serrinha dos Pintos", state: 'RN' },
    { code: '2413607', name: "Severiano Melo", state: 'RN' },
    { code: '2413706', name: "Sítio Novo", state: 'RN' },
    { code: '2413805', name: "Taboleiro Grande", state: 'RN' },
    { code: '2413904', name: "Taipu", state: 'RN' },
    { code: '2414001', name: "Tangará", state: 'RN' },
    { code: '2414100', name: "Tenente Ananias", state: 'RN' },
    { code: '2414159', name: "Tenente Laurentino Cruz", state: 'RN' },
    { code: '2411056', name: "Tibau", state: 'RN' },
    { code: '2414209', name: "Tibau do Sul", state: 'RN' },
    { code: '2414308', name: "Timbaúba dos Batistas", state: 'RN' },
    { code: '2414407', name: "Touros", state: 'RN' },
    { code: '2414456', name: "Triunfo Potiguar", state: 'RN' },
    { code: '2414506', name: "Umarizal", state: 'RN' },
    { code: '2414605', name: "Upanema", state: 'RN' },
    { code: '2414704', name: "Várzea", state: 'RN' },
    { code: '2414753', name: "Venha-Ver", state: 'RN' },
    { code: '2414803', name: "Vera Cruz", state: 'RN' },
    { code: '2414902', name: "Viçosa", state: 'RN' },
    { code: '2415008', name: "Vila Flor", state: 'RN' }
  ],

  // RONDÔNIA (RO) - 52 municípios
  RO: [
    { code: '1100015', name: "Alta Floresta D'Oeste", state: 'RO' },
    { code: '1100379', name: "Alto Alegre dos Parecis", state: 'RO' },
    { code: '1100403', name: "Alto Paraíso", state: 'RO' },
    { code: '1100346', name: "Alvorada D'Oeste", state: 'RO' },
    { code: '1100023', name: "Ariquemes", state: 'RO' },
    { code: '1100452', name: "Buritis", state: 'RO' },
    { code: '1100031', name: "Cabixi", state: 'RO' },
    { code: '1100601', name: "Cacaulândia", state: 'RO' },
    { code: '1100049', name: "Cacoal", state: 'RO' },
    { code: '1100700', name: "Campo Novo de Rondônia", state: 'RO' },
    { code: '1100809', name: "Candeias do Jamari", state: 'RO' },
    { code: '1100908', name: "Castanheiras", state: 'RO' },
    { code: '1100056', name: "Cerejeiras", state: 'RO' },
    { code: '1100924', name: "Chupinguaia", state: 'RO' },
    { code: '1100064', name: "Colorado do Oeste", state: 'RO' },
    { code: '1100072', name: "Corumbiara", state: 'RO' },
    { code: '1100080', name: "Costa Marques", state: 'RO' },
    { code: '1100940', name: "Cujubim", state: 'RO' },
    { code: '1100098', name: "Espigão D'Oeste", state: 'RO' },
    { code: '1101005', name: "Governador Jorge Teixeira", state: 'RO' },
    { code: '1100106', name: "Guajará-Mirim", state: 'RO' },
    { code: '1101104', name: "Itapuã do Oeste", state: 'RO' },
    { code: '1100114', name: "Jaru", state: 'RO' },
    { code: '1100122', name: "Ji-Paraná", state: 'RO' },
    { code: '1100130', name: "Machadinho D'Oeste", state: 'RO' },
    { code: '1101203', name: "Ministro Andreazza", state: 'RO' },
    { code: '1101302', name: "Mirante da Serra", state: 'RO' },
    { code: '1101401', name: "Monte Negro", state: 'RO' },
    { code: '1100148', name: "Nova Brasilândia D'Oeste", state: 'RO' },
    { code: '1100338', name: "Nova Mamoré", state: 'RO' },
    { code: '1101435', name: "Nova União", state: 'RO' },
    { code: '1100502', name: "Novo Horizonte do Oeste", state: 'RO' },
    { code: '1100155', name: "Ouro Preto do Oeste", state: 'RO' },
    { code: '1101450', name: "Parecis", state: 'RO' },
    { code: '1100189', name: "Pimenta Bueno", state: 'RO' },
    { code: '1101468', name: "Pimenteiras do Oeste", state: 'RO' },
    { code: '1100205', name: "Porto Velho", state: 'RO' },
    { code: '1100254', name: "Presidente Médici", state: 'RO' },
    { code: '1101476', name: "Primavera de Rondônia", state: 'RO' },
    { code: '1100262', name: "Rio Crespo", state: 'RO' },
    { code: '1100288', name: "Rolim de Moura", state: 'RO' },
    { code: '1100296', name: "Santa Luzia D'Oeste", state: 'RO' },
    { code: '1101484', name: "São Felipe D'Oeste", state: 'RO' },
    { code: '1101492', name: "São Francisco do Guaporé", state: 'RO' },
    { code: '1100320', name: "São Miguel do Guaporé", state: 'RO' },
    { code: '1101500', name: "Seringueiras", state: 'RO' },
    { code: '1101559', name: "Teixeirópolis", state: 'RO' },
    { code: '1101609', name: "Theobroma", state: 'RO' },
    { code: '1101708', name: "Urupá", state: 'RO' },
    { code: '1101757', name: "Vale do Anari", state: 'RO' },
    { code: '1101807', name: "Vale do Paraíso", state: 'RO' },
    { code: '1100304', name: "Vilhena", state: 'RO' }
  ],

  // RORAIMA (RR) - 15 municípios
  RR: [
    { code: '1400050', name: "Alto Alegre", state: 'RR' },
    { code: '1400027', name: "Amajari", state: 'RR' },
    { code: '1400100', name: "Boa Vista", state: 'RR' },
    { code: '1400159', name: "Bonfim", state: 'RR' },
    { code: '1400175', name: "Cantá", state: 'RR' },
    { code: '1400209', name: "Caracaraí", state: 'RR' },
    { code: '1400233', name: "Caroebe", state: 'RR' },
    { code: '1400282', name: "Iracema", state: 'RR' },
    { code: '1400308', name: "Mucajaí", state: 'RR' },
    { code: '1400407', name: "Normandia", state: 'RR' },
    { code: '1400456', name: "Pacaraima", state: 'RR' },
    { code: '1400472', name: "Rorainópolis", state: 'RR' },
    { code: '1400506', name: "São João da Baliza", state: 'RR' },
    { code: '1400605', name: "São Luiz", state: 'RR' },
    { code: '1400704', name: "Uiramutã", state: 'RR' }
  ],

  // RIO GRANDE DO SUL (RS) - 497 municípios
  RS: [
    { code: '4300034', name: "Aceguá", state: 'RS' },
    { code: '4300059', name: "Água Santa", state: 'RS' },
    { code: '4300109', name: "Agudo", state: 'RS' },
    { code: '4300208', name: "Ajuricaba", state: 'RS' },
    { code: '4300307', name: "Alecrim", state: 'RS' },
    { code: '4300406', name: "Alegrete", state: 'RS' },
    { code: '4300455', name: "Alegria", state: 'RS' },
    { code: '4300471', name: "Almirante Tamandaré do Sul", state: 'RS' },
    { code: '4300505', name: "Alpestre", state: 'RS' },
    { code: '4300554', name: "Alto Alegre", state: 'RS' },
    { code: '4300570', name: "Alto Feliz", state: 'RS' },
    { code: '4300604', name: "Alvorada", state: 'RS' },
    { code: '4300638', name: "Amaral Ferrador", state: 'RS' },
    { code: '4300646', name: "Ametista do Sul", state: 'RS' },
    { code: '4300661', name: "André da Rocha", state: 'RS' },
    { code: '4300703', name: "Anta Gorda", state: 'RS' },
    { code: '4300802', name: "Antônio Prado", state: 'RS' },
    { code: '4300851', name: "Arambaré", state: 'RS' },
    { code: '4300877', name: "Araricá", state: 'RS' },
    { code: '4300901', name: "Aratiba", state: 'RS' },
    { code: '4301008', name: "Arroio do Meio", state: 'RS' },
    { code: '4301073', name: "Arroio do Padre", state: 'RS' },
    { code: '4301057', name: "Arroio do Sal", state: 'RS' },
    { code: '4301206', name: "Arroio do Tigre", state: 'RS' },
    { code: '4301107', name: "Arroio dos Ratos", state: 'RS' },
    { code: '4301305', name: "Arroio Grande", state: 'RS' },
    { code: '4301404', name: "Arvorezinha", state: 'RS' },
    { code: '4301503', name: "Augusto Pestana", state: 'RS' },
    { code: '4301552', name: "Áurea", state: 'RS' },
    { code: '4301602', name: "Bagé", state: 'RS' },
    { code: '4301636', name: "Balneário Pinhal", state: 'RS' },
    { code: '4301651', name: "Barão", state: 'RS' },
    { code: '4301701', name: "Barão de Cotegipe", state: 'RS' },
    { code: '4301750', name: "Barão do Triunfo", state: 'RS' },
    { code: '4301859', name: "Barra do Guarita", state: 'RS' },
    { code: '4301875', name: "Barra do Quaraí", state: 'RS' },
    { code: '4301909', name: "Barra do Ribeiro", state: 'RS' },
    { code: '4301925', name: "Barra do Rio Azul", state: 'RS' },
    { code: '4301958', name: "Barra Funda", state: 'RS' },
    { code: '4301800', name: "Barracão", state: 'RS' },
    { code: '4302006', name: "Barros Cassal", state: 'RS' },
    { code: '4302055', name: "Benjamin Constant do Sul", state: 'RS' },
    { code: '4302105', name: "Bento Gonçalves", state: 'RS' },
    { code: '4302154', name: "Boa Vista das Missões", state: 'RS' },
    { code: '4302204', name: "Boa Vista do Buricá", state: 'RS' },
    { code: '4302220', name: "Boa Vista do Cadeado", state: 'RS' },
    { code: '4302238', name: "Boa Vista do Incra", state: 'RS' },
    { code: '4302253', name: "Boa Vista do Sul", state: 'RS' },
    { code: '4302303', name: "Bom Jesus", state: 'RS' },
    { code: '4302352', name: "Bom Princípio", state: 'RS' },
    { code: '4302378', name: "Bom Progresso", state: 'RS' },
    { code: '4302402', name: "Bom Retiro do Sul", state: 'RS' },
    { code: '4302451', name: "Boqueirão do Leão", state: 'RS' },
    { code: '4302501', name: "Bossoroca", state: 'RS' },
    { code: '4302584', name: "Bozano", state: 'RS' },
    { code: '4302600', name: "Braga", state: 'RS' },
    { code: '4302659', name: "Brochier", state: 'RS' },
    { code: '4302709', name: "Butiá", state: 'RS' },
    { code: '4302808', name: "Caçapava do Sul", state: 'RS' },
    { code: '4302907', name: "Cacequi", state: 'RS' },
    { code: '4303004', name: "Cachoeira do Sul", state: 'RS' },
    { code: '4303103', name: "Cachoeirinha", state: 'RS' },
    { code: '4303202', name: "Cacique Doble", state: 'RS' },
    { code: '4303301', name: "Caibaté", state: 'RS' },
    { code: '4303400', name: "Caiçara", state: 'RS' },
    { code: '4303509', name: "Camaquã", state: 'RS' },
    { code: '4303558', name: "Camargo", state: 'RS' },
    { code: '4303608', name: "Cambará do Sul", state: 'RS' },
    { code: '4303673', name: "Campestre da Serra", state: 'RS' },
    { code: '4303707', name: "Campina das Missões", state: 'RS' },
    { code: '4303806', name: "Campinas do Sul", state: 'RS' },
    { code: '4303905', name: "Campo Bom", state: 'RS' },
    { code: '4304002', name: "Campo Novo", state: 'RS' },
    { code: '4304101', name: "Campos Borges", state: 'RS' },
    { code: '4304200', name: "Candelária", state: 'RS' },
    { code: '4304309', name: "Cândido Godói", state: 'RS' },
    { code: '4304358', name: "Candiota", state: 'RS' },
    { code: '4304408', name: "Canela", state: 'RS' },
    { code: '4304507', name: "Canguçu", state: 'RS' },
    { code: '4304606', name: "Canoas", state: 'RS' },
    { code: '4304614', name: "Canudos do Vale", state: 'RS' },
    { code: '4304622', name: "Capão Bonito do Sul", state: 'RS' },
    { code: '4304630', name: "Capão da Canoa", state: 'RS' },
    { code: '4304655', name: "Capão do Cipó", state: 'RS' },
    { code: '4304663', name: "Capão do Leão", state: 'RS' },
    { code: '4304689', name: "Capela de Santana", state: 'RS' },
    { code: '4304697', name: "Capitão", state: 'RS' },
    { code: '4304671', name: "Capivari do Sul", state: 'RS' },
    { code: '4304713', name: "Caraá", state: 'RS' },
    { code: '4304705', name: "Carazinho", state: 'RS' },
    { code: '4304804', name: "Carlos Barbosa", state: 'RS' },
    { code: '4304853', name: "Carlos Gomes", state: 'RS' },
    { code: '4304903', name: "Casca", state: 'RS' },
    { code: '4304952', name: "Caseiros", state: 'RS' },
    { code: '4305009', name: "Catuípe", state: 'RS' },
    { code: '4305108', name: "Caxias do Sul", state: 'RS' },
    { code: '4305116', name: "Centenário", state: 'RS' },
    { code: '4305124', name: "Cerrito", state: 'RS' },
    { code: '4305132', name: "Cerro Branco", state: 'RS' },
    { code: '4305157', name: "Cerro Grande", state: 'RS' },
    { code: '4305173', name: "Cerro Grande do Sul", state: 'RS' },
    { code: '4305207', name: "Cerro Largo", state: 'RS' },
    { code: '4305306', name: "Chapada", state: 'RS' },
    { code: '4305355', name: "Charqueadas", state: 'RS' },
    { code: '4305371', name: "Charrua", state: 'RS' },
    { code: '4305405', name: "Chiapetta", state: 'RS' },
    { code: '4305439', name: "Chuí", state: 'RS' },
    { code: '4305447', name: "Chuvisca", state: 'RS' },
    { code: '4305454', name: "Cidreira", state: 'RS' },
    { code: '4305504', name: "Ciríaco", state: 'RS' },
    { code: '4305587', name: "Colinas", state: 'RS' },
    { code: '4305603', name: "Colorado", state: 'RS' },
    { code: '4305702', name: "Condor", state: 'RS' },
    { code: '4305801', name: "Constantina", state: 'RS' },
    { code: '4305835', name: "Coqueiro Baixo", state: 'RS' },
    { code: '4305850', name: "Coqueiros do Sul", state: 'RS' },
    { code: '4305871', name: "Coronel Barros", state: 'RS' },
    { code: '4305900', name: "Coronel Bicaco", state: 'RS' },
    { code: '4305934', name: "Coronel Pilar", state: 'RS' },
    { code: '4305959', name: "Cotiporã", state: 'RS' },
    { code: '4305975', name: "Coxilha", state: 'RS' },
    { code: '4306007', name: "Crissiumal", state: 'RS' },
    { code: '4306056', name: "Cristal", state: 'RS' },
    { code: '4306072', name: "Cristal do Sul", state: 'RS' },
    { code: '4306106', name: "Cruz Alta", state: 'RS' },
    { code: '4306130', name: "Cruzaltense", state: 'RS' },
    { code: '4306205', name: "Cruzeiro do Sul", state: 'RS' },
    { code: '4306304', name: "David Canabarro", state: 'RS' },
    { code: '4306320', name: "Derrubadas", state: 'RS' },
    { code: '4306353', name: "Dezesseis de Novembro", state: 'RS' },
    { code: '4306379', name: "Dilermando de Aguiar", state: 'RS' },
    { code: '4306403', name: "Dois Irmãos", state: 'RS' },
    { code: '4306429', name: "Dois Irmãos das Missões", state: 'RS' },
    { code: '4306452', name: "Dois Lajeados", state: 'RS' },
    { code: '4306502', name: "Dom Feliciano", state: 'RS' },
    { code: '4306601', name: "Dom Pedrito", state: 'RS' },
    { code: '4306551', name: "Dom Pedro de Alcântara", state: 'RS' },
    { code: '4306700', name: "Dona Francisca", state: 'RS' },
    { code: '4306734', name: "Doutor Maurício Cardoso", state: 'RS' },
    { code: '4306759', name: "Doutor Ricardo", state: 'RS' },
    { code: '4306767', name: "Eldorado do Sul", state: 'RS' },
    { code: '4306809', name: "Encantado", state: 'RS' },
    { code: '4306908', name: "Encruzilhada do Sul", state: 'RS' },
    { code: '4306924', name: "Engenho Velho", state: 'RS' },
    { code: '4306957', name: "Entre Rios do Sul", state: 'RS' },
    { code: '4306932', name: "Entre-Ijuís", state: 'RS' },
    { code: '4306973', name: "Erebango", state: 'RS' },
    { code: '4307005', name: "Erechim", state: 'RS' },
    { code: '4307054', name: "Ernestina", state: 'RS' },
    { code: '4307203', name: "Erval Grande", state: 'RS' },
    { code: '4307302', name: "Erval Seco", state: 'RS' },
    { code: '4307401', name: "Esmeralda", state: 'RS' },
    { code: '4307450', name: "Esperança do Sul", state: 'RS' },
    { code: '4307500', name: "Espumoso", state: 'RS' },
    { code: '4307559', name: "Estação", state: 'RS' },
    { code: '4307609', name: "Estância Velha", state: 'RS' },
    { code: '4307708', name: "Esteio", state: 'RS' },
    { code: '4307807', name: "Estrela", state: 'RS' },
    { code: '4307815', name: "Estrela Velha", state: 'RS' },
    { code: '4307831', name: "Eugênio de Castro", state: 'RS' },
    { code: '4307864', name: "Fagundes Varela", state: 'RS' },
    { code: '4307906', name: "Farroupilha", state: 'RS' },
    { code: '4308003', name: "Faxinal do Soturno", state: 'RS' },
    { code: '4308052', name: "Faxinalzinho", state: 'RS' },
    { code: '4308078', name: "Fazenda Vilanova", state: 'RS' },
    { code: '4308102', name: "Feliz", state: 'RS' },
    { code: '4308201', name: "Flores da Cunha", state: 'RS' },
    { code: '4308250', name: "Floriano Peixoto", state: 'RS' },
    { code: '4308300', name: "Fontoura Xavier", state: 'RS' },
    { code: '4308409', name: "Formigueiro", state: 'RS' },
    { code: '4308433', name: "Forquetinha", state: 'RS' },
    { code: '4308458', name: "Fortaleza dos Valos", state: 'RS' },
    { code: '4308508', name: "Frederico Westphalen", state: 'RS' },
    { code: '4308607', name: "Garibaldi", state: 'RS' },
    { code: '4308656', name: "Garruchos", state: 'RS' },
    { code: '4308706', name: "Gaurama", state: 'RS' },
    { code: '4308805', name: "General Câmara", state: 'RS' },
    { code: '4308854', name: "Gentil", state: 'RS' },
    { code: '4308904', name: "Getúlio Vargas", state: 'RS' },
    { code: '4309001', name: "Giruá", state: 'RS' },
    { code: '4309050', name: "Glorinha", state: 'RS' },
    { code: '4309100', name: "Gramado", state: 'RS' },
    { code: '4309126', name: "Gramado dos Loureiros", state: 'RS' },
    { code: '4309159', name: "Gramado Xavier", state: 'RS' },
    { code: '4309209', name: "Gravataí", state: 'RS' },
    { code: '4309258', name: "Guabiju", state: 'RS' },
    { code: '4309308', name: "Guaíba", state: 'RS' },
    { code: '4309407', name: "Guaporé", state: 'RS' },
    { code: '4309506', name: "Guarani das Missões", state: 'RS' },
    { code: '4309555', name: "Harmonia", state: 'RS' },
    { code: '4307104', name: "Herval", state: 'RS' },
    { code: '4309571', name: "Herveiras", state: 'RS' },
    { code: '4309605', name: "Horizontina", state: 'RS' },
    { code: '4309654', name: "Hulha Negra", state: 'RS' },
    { code: '4309704', name: "Humaitá", state: 'RS' },
    { code: '4309753', name: "Ibarama", state: 'RS' },
    { code: '4309803', name: "Ibiaçá", state: 'RS' },
    { code: '4309902', name: "Ibiraiaras", state: 'RS' },
    { code: '4309951', name: "Ibirapuitã", state: 'RS' },
    { code: '4310009', name: "Ibirubá", state: 'RS' },
    { code: '4310108', name: "Igrejinha", state: 'RS' },
    { code: '4310207', name: "Ijuí", state: 'RS' },
    { code: '4310306', name: "Ilópolis", state: 'RS' },
    { code: '4310330', name: "Imbé", state: 'RS' },
    { code: '4310363', name: "Imigrante", state: 'RS' },
    { code: '4310405', name: "Independência", state: 'RS' },
    { code: '4310413', name: "Inhacorá", state: 'RS' },
    { code: '4310439', name: "Ipê", state: 'RS' },
    { code: '4310462', name: "Ipiranga do Sul", state: 'RS' },
    { code: '4310504', name: "Iraí", state: 'RS' },
    { code: '4310538', name: "Itaara", state: 'RS' },
    { code: '4310553', name: "Itacurubi", state: 'RS' },
    { code: '4310579', name: "Itapuca", state: 'RS' },
    { code: '4310603', name: "Itaqui", state: 'RS' },
    { code: '4310652', name: "Itati", state: 'RS' },
    { code: '4310702', name: "Itatiba do Sul", state: 'RS' },
    { code: '4310751', name: "Ivorá", state: 'RS' },
    { code: '4310801', name: "Ivoti", state: 'RS' },
    { code: '4310850', name: "Jaboticaba", state: 'RS' },
    { code: '4310876', name: "Jacuizinho", state: 'RS' },
    { code: '4310900', name: "Jacutinga", state: 'RS' },
    { code: '4311007', name: "Jaguarão", state: 'RS' },
    { code: '4311106', name: "Jaguari", state: 'RS' },
    { code: '4311122', name: "Jaquirana", state: 'RS' },
    { code: '4311130', name: "Jari", state: 'RS' },
    { code: '4311155', name: "Jóia", state: 'RS' },
    { code: '4311205', name: "Júlio de Castilhos", state: 'RS' },
    { code: '4311239', name: "Lagoa Bonita do Sul", state: 'RS' },
    { code: '4311270', name: "Lagoa dos Três Cantos", state: 'RS' },
    { code: '4311304', name: "Lagoa Vermelha", state: 'RS' },
    { code: '4311254', name: "Lagoão", state: 'RS' },
    { code: '4311403', name: "Lajeado", state: 'RS' },
    { code: '4311429', name: "Lajeado do Bugre", state: 'RS' },
    { code: '4311502', name: "Lavras do Sul", state: 'RS' },
    { code: '4311601', name: "Liberato Salzano", state: 'RS' },
    { code: '4311627', name: "Lindolfo Collor", state: 'RS' },
    { code: '4311643', name: "Linha Nova", state: 'RS' },
    { code: '4311718', name: "Maçambará", state: 'RS' },
    { code: '4311700', name: "Machadinho", state: 'RS' },
    { code: '4311734', name: "Mampituba", state: 'RS' },
    { code: '4311759', name: "Manoel Viana", state: 'RS' },
    { code: '4311775', name: "Maquiné", state: 'RS' },
    { code: '4311791', name: "Maratá", state: 'RS' },
    { code: '4311809', name: "Marau", state: 'RS' },
    { code: '4311908', name: "Marcelino Ramos", state: 'RS' },
    { code: '4311981', name: "Mariana Pimentel", state: 'RS' },
    { code: '4312005', name: "Mariano Moro", state: 'RS' },
    { code: '4312054', name: "Marques de Souza", state: 'RS' },
    { code: '4312104', name: "Mata", state: 'RS' },
    { code: '4312138', name: "Mato Castelhano", state: 'RS' },
    { code: '4312153', name: "Mato Leitão", state: 'RS' },
    { code: '4312179', name: "Mato Queimado", state: 'RS' },
    { code: '4312203', name: "Maximiliano de Almeida", state: 'RS' },
    { code: '4312252', name: "Minas do Leão", state: 'RS' },
    { code: '4312302', name: "Miraguaí", state: 'RS' },
    { code: '4312351', name: "Montauri", state: 'RS' },
    { code: '4312377', name: "Monte Alegre dos Campos", state: 'RS' },
    { code: '4312385', name: "Monte Belo do Sul", state: 'RS' },
    { code: '4312401', name: "Montenegro", state: 'RS' },
    { code: '4312427', name: "Mormaço", state: 'RS' },
    { code: '4312443', name: "Morrinhos do Sul", state: 'RS' },
    { code: '4312450', name: "Morro Redondo", state: 'RS' },
    { code: '4312476', name: "Morro Reuter", state: 'RS' },
    { code: '4312500', name: "Mostardas", state: 'RS' },
    { code: '4312609', name: "Muçum", state: 'RS' },
    { code: '4312617', name: "Muitos Capões", state: 'RS' },
    { code: '4312625', name: "Muliterno", state: 'RS' },
    { code: '4312658', name: "Não-Me-Toque", state: 'RS' },
    { code: '4312674', name: "Nicolau Vergueiro", state: 'RS' },
    { code: '4312708', name: "Nonoai", state: 'RS' },
    { code: '4312757', name: "Nova Alvorada", state: 'RS' },
    { code: '4312807', name: "Nova Araçá", state: 'RS' },
    { code: '4312906', name: "Nova Bassano", state: 'RS' },
    { code: '4312955', name: "Nova Boa Vista", state: 'RS' },
    { code: '4313003', name: "Nova Bréscia", state: 'RS' },
    { code: '4313011', name: "Nova Candelária", state: 'RS' },
    { code: '4313037', name: "Nova Esperança do Sul", state: 'RS' },
    { code: '4313060', name: "Nova Hartz", state: 'RS' },
    { code: '4313086', name: "Nova Pádua", state: 'RS' },
    { code: '4313102', name: "Nova Palma", state: 'RS' },
    { code: '4313201', name: "Nova Petrópolis", state: 'RS' },
    { code: '4313300', name: "Nova Prata", state: 'RS' },
    { code: '4313334', name: "Nova Ramada", state: 'RS' },
    { code: '4313359', name: "Nova Roma do Sul", state: 'RS' },
    { code: '4313375', name: "Nova Santa Rita", state: 'RS' },
    { code: '4313490', name: "Novo Barreiro", state: 'RS' },
    { code: '4313391', name: "Novo Cabrais", state: 'RS' },
    { code: '4313409', name: "Novo Hamburgo", state: 'RS' },
    { code: '4313425', name: "Novo Machado", state: 'RS' },
    { code: '4313441', name: "Novo Tiradentes", state: 'RS' },
    { code: '4313466', name: "Novo Xingu", state: 'RS' },
    { code: '4313508', name: "Osório", state: 'RS' },
    { code: '4313607', name: "Paim Filho", state: 'RS' },
    { code: '4313656', name: "Palmares do Sul", state: 'RS' },
    { code: '4313706', name: "Palmeira das Missões", state: 'RS' },
    { code: '4313805', name: "Palmitinho", state: 'RS' },
    { code: '4313904', name: "Panambi", state: 'RS' },
    { code: '4313953', name: "Pantano Grande", state: 'RS' },
    { code: '4314001', name: "Paraí", state: 'RS' },
    { code: '4314027', name: "Paraíso do Sul", state: 'RS' },
    { code: '4314035', name: "Pareci Novo", state: 'RS' },
    { code: '4314050', name: "Parobé", state: 'RS' },
    { code: '4314068', name: "Passa Sete", state: 'RS' },
    { code: '4314076', name: "Passo do Sobrado", state: 'RS' },
    { code: '4314100', name: "Passo Fundo", state: 'RS' },
    { code: '4314134', name: "Paulo Bento", state: 'RS' },
    { code: '4314159', name: "Paverama", state: 'RS' },
    { code: '4314175', name: "Pedras Altas", state: 'RS' },
    { code: '4314209', name: "Pedro Osório", state: 'RS' },
    { code: '4314308', name: "Pejuçara", state: 'RS' },
    { code: '4314407', name: "Pelotas", state: 'RS' },
    { code: '4314423', name: "Picada Café", state: 'RS' },
    { code: '4314456', name: "Pinhal", state: 'RS' },
    { code: '4314464', name: "Pinhal da Serra", state: 'RS' },
    { code: '4314472', name: "Pinhal Grande", state: 'RS' },
    { code: '4314498', name: "Pinheirinho do Vale", state: 'RS' },
    { code: '4314506', name: "Pinheiro Machado", state: 'RS' },
    { code: '4314548', name: "Pinto Bandeira", state: 'RS' },
    { code: '4314555', name: "Pirapó", state: 'RS' },
    { code: '4314605', name: "Piratini", state: 'RS' },
    { code: '4314704', name: "Planalto", state: 'RS' },
    { code: '4314753', name: "Poço das Antas", state: 'RS' },
    { code: '4314779', name: "Pontão", state: 'RS' },
    { code: '4314787', name: "Ponte Preta", state: 'RS' },
    { code: '4314803', name: "Portão", state: 'RS' },
    { code: '4314902', name: "Porto Alegre", state: 'RS' },
    { code: '4315008', name: "Porto Lucena", state: 'RS' },
    { code: '4315057', name: "Porto Mauá", state: 'RS' },
    { code: '4315073', name: "Porto Vera Cruz", state: 'RS' },
    { code: '4315107', name: "Porto Xavier", state: 'RS' },
    { code: '4315131', name: "Pouso Novo", state: 'RS' },
    { code: '4315149', name: "Presidente Lucena", state: 'RS' },
    { code: '4315156', name: "Progresso", state: 'RS' },
    { code: '4315172', name: "Protásio Alves", state: 'RS' },
    { code: '4315206', name: "Putinga", state: 'RS' },
    { code: '4315305', name: "Quaraí", state: 'RS' },
    { code: '4315313', name: "Quatro Irmãos", state: 'RS' },
    { code: '4315321', name: "Quevedos", state: 'RS' },
    { code: '4315354', name: "Quinze de Novembro", state: 'RS' },
    { code: '4315404', name: "Redentora", state: 'RS' },
    { code: '4315453', name: "Relvado", state: 'RS' },
    { code: '4315503', name: "Restinga Sêca", state: 'RS' },
    { code: '4315552', name: "Rio dos Índios", state: 'RS' },
    { code: '4315602', name: "Rio Grande", state: 'RS' },
    { code: '4315701', name: "Rio Pardo", state: 'RS' },
    { code: '4315750', name: "Riozinho", state: 'RS' },
    { code: '4315800', name: "Roca Sales", state: 'RS' },
    { code: '4315909', name: "Rodeio Bonito", state: 'RS' },
    { code: '4315958', name: "Rolador", state: 'RS' },
    { code: '4316006', name: "Rolante", state: 'RS' },
    { code: '4316105', name: "Ronda Alta", state: 'RS' },
    { code: '4316204', name: "Rondinha", state: 'RS' },
    { code: '4316303', name: "Roque Gonzales", state: 'RS' },
    { code: '4316402', name: "Rosário do Sul", state: 'RS' },
    { code: '4316428', name: "Sagrada Família", state: 'RS' },
    { code: '4316436', name: "Saldanha Marinho", state: 'RS' },
    { code: '4316451', name: "Salto do Jacuí", state: 'RS' },
    { code: '4316477', name: "Salvador das Missões", state: 'RS' },
    { code: '4316501', name: "Salvador do Sul", state: 'RS' },
    { code: '4316600', name: "Sananduva", state: 'RS' },
    { code: '4317103', name: "Sant'Ana do Livramento", state: 'RS' },
    { code: '4316709', name: "Santa Bárbara do Sul", state: 'RS' },
    { code: '4316733', name: "Santa Cecília do Sul", state: 'RS' },
    { code: '4316758', name: "Santa Clara do Sul", state: 'RS' },
    { code: '4316808', name: "Santa Cruz do Sul", state: 'RS' },
    { code: '4316972', name: "Santa Margarida do Sul", state: 'RS' },
    { code: '4316907', name: "Santa Maria", state: 'RS' },
    { code: '4316956', name: "Santa Maria do Herval", state: 'RS' },
    { code: '4317202', name: "Santa Rosa", state: 'RS' },
    { code: '4317251', name: "Santa Tereza", state: 'RS' },
    { code: '4317301', name: "Santa Vitória do Palmar", state: 'RS' },
    { code: '4317004', name: "Santana da Boa Vista", state: 'RS' },
    { code: '4317400', name: "Santiago", state: 'RS' },
    { code: '4317509', name: "Santo Ângelo", state: 'RS' },
    { code: '4317608', name: "Santo Antônio da Patrulha", state: 'RS' },
    { code: '4317707', name: "Santo Antônio das Missões", state: 'RS' },
    { code: '4317558', name: "Santo Antônio do Palma", state: 'RS' },
    { code: '4317756', name: "Santo Antônio do Planalto", state: 'RS' },
    { code: '4317806', name: "Santo Augusto", state: 'RS' },
    { code: '4317905', name: "Santo Cristo", state: 'RS' },
    { code: '4317954', name: "Santo Expedito do Sul", state: 'RS' },
    { code: '4318002', name: "São Borja", state: 'RS' },
    { code: '4318051', name: "São Domingos do Sul", state: 'RS' },
    { code: '4318101', name: "São Francisco de Assis", state: 'RS' },
    { code: '4318200', name: "São Francisco de Paula", state: 'RS' },
    { code: '4318309', name: "São Gabriel", state: 'RS' },
    { code: '4318408', name: "São Jerônimo", state: 'RS' },
    { code: '4318424', name: "São João da Urtiga", state: 'RS' },
    { code: '4318432', name: "São João do Polêsine", state: 'RS' },
    { code: '4318440', name: "São Jorge", state: 'RS' },
    { code: '4318457', name: "São José das Missões", state: 'RS' },
    { code: '4318465', name: "São José do Herval", state: 'RS' },
    { code: '4318481', name: "São José do Hortêncio", state: 'RS' },
    { code: '4318499', name: "São José do Inhacorá", state: 'RS' },
    { code: '4318507', name: "São José do Norte", state: 'RS' },
    { code: '4318606', name: "São José do Ouro", state: 'RS' },
    { code: '4318614', name: "São José do Sul", state: 'RS' },
    { code: '4318622', name: "São José dos Ausentes", state: 'RS' },
    { code: '4318705', name: "São Leopoldo", state: 'RS' },
    { code: '4318804', name: "São Lourenço do Sul", state: 'RS' },
    { code: '4318903', name: "São Luiz Gonzaga", state: 'RS' },
    { code: '4319000', name: "São Marcos", state: 'RS' },
    { code: '4319109', name: "São Martinho", state: 'RS' },
    { code: '4319125', name: "São Martinho da Serra", state: 'RS' },
    { code: '4319158', name: "São Miguel das Missões", state: 'RS' },
    { code: '4319208', name: "São Nicolau", state: 'RS' },
    { code: '4319307', name: "São Paulo das Missões", state: 'RS' },
    { code: '4319356', name: "São Pedro da Serra", state: 'RS' },
    { code: '4319364', name: "São Pedro das Missões", state: 'RS' },
    { code: '4319372', name: "São Pedro do Butiá", state: 'RS' },
    { code: '4319406', name: "São Pedro do Sul", state: 'RS' },
    { code: '4319505', name: "São Sebastião do Caí", state: 'RS' },
    { code: '4319604', name: "São Sepé", state: 'RS' },
    { code: '4319703', name: "São Valentim", state: 'RS' },
    { code: '4319711', name: "São Valentim do Sul", state: 'RS' },
    { code: '4319737', name: "São Valério do Sul", state: 'RS' },
    { code: '4319752', name: "São Vendelino", state: 'RS' },
    { code: '4319802', name: "São Vicente do Sul", state: 'RS' },
    { code: '4319901', name: "Sapiranga", state: 'RS' },
    { code: '4320008', name: "Sapucaia do Sul", state: 'RS' },
    { code: '4320107', name: "Sarandi", state: 'RS' },
    { code: '4320206', name: "Seberi", state: 'RS' },
    { code: '4320230', name: "Sede Nova", state: 'RS' },
    { code: '4320263', name: "Segredo", state: 'RS' },
    { code: '4320305', name: "Selbach", state: 'RS' },
    { code: '4320321', name: "Senador Salgado Filho", state: 'RS' },
    { code: '4320354', name: "Sentinela do Sul", state: 'RS' },
    { code: '4320404', name: "Serafina Corrêa", state: 'RS' },
    { code: '4320453', name: "Sério", state: 'RS' },
    { code: '4320503', name: "Sertão", state: 'RS' },
    { code: '4320552', name: "Sertão Santana", state: 'RS' },
    { code: '4320578', name: "Sete de Setembro", state: 'RS' },
    { code: '4320602', name: "Severiano de Almeida", state: 'RS' },
    { code: '4320651', name: "Silveira Martins", state: 'RS' },
    { code: '4320677', name: "Sinimbu", state: 'RS' },
    { code: '4320701', name: "Sobradinho", state: 'RS' },
    { code: '4320800', name: "Soledade", state: 'RS' },
    { code: '4320859', name: "Tabaí", state: 'RS' },
    { code: '4320909', name: "Tapejara", state: 'RS' },
    { code: '4321006', name: "Tapera", state: 'RS' },
    { code: '4321105', name: "Tapes", state: 'RS' },
    { code: '4321204', name: "Taquara", state: 'RS' },
    { code: '4321303', name: "Taquari", state: 'RS' },
    { code: '4321329', name: "Taquaruçu do Sul", state: 'RS' },
    { code: '4321352', name: "Tavares", state: 'RS' },
    { code: '4321402', name: "Tenente Portela", state: 'RS' },
    { code: '4321436', name: "Terra de Areia", state: 'RS' },
    { code: '4321451', name: "Teutônia", state: 'RS' },
    { code: '4321469', name: "Tio Hugo", state: 'RS' },
    { code: '4321477', name: "Tiradentes do Sul", state: 'RS' },
    { code: '4321493', name: "Toropi", state: 'RS' },
    { code: '4321501', name: "Torres", state: 'RS' },
    { code: '4321600', name: "Tramandaí", state: 'RS' },
    { code: '4321626', name: "Travesseiro", state: 'RS' },
    { code: '4321634', name: "Três Arroios", state: 'RS' },
    { code: '4321667', name: "Três Cachoeiras", state: 'RS' },
    { code: '4321709', name: "Três Coroas", state: 'RS' },
    { code: '4321808', name: "Três de Maio", state: 'RS' },
    { code: '4321832', name: "Três Forquilhas", state: 'RS' },
    { code: '4321857', name: "Três Palmeiras", state: 'RS' },
    { code: '4321907', name: "Três Passos", state: 'RS' },
    { code: '4321956', name: "Trindade do Sul", state: 'RS' },
    { code: '4322004', name: "Triunfo", state: 'RS' },
    { code: '4322103', name: "Tucunduva", state: 'RS' },
    { code: '4322152', name: "Tunas", state: 'RS' },
    { code: '4322186', name: "Tupanci do Sul", state: 'RS' },
    { code: '4322202', name: "Tupanciretã", state: 'RS' },
    { code: '4322251', name: "Tupandi", state: 'RS' },
    { code: '4322301', name: "Tuparendi", state: 'RS' },
    { code: '4322327', name: "Turuçu", state: 'RS' },
    { code: '4322343', name: "Ubiretama", state: 'RS' },
    { code: '4322350', name: "União da Serra", state: 'RS' },
    { code: '4322376', name: "Unistalda", state: 'RS' },
    { code: '4322400', name: "Uruguaiana", state: 'RS' },
    { code: '4322509', name: "Vacaria", state: 'RS' },
    { code: '4322533', name: "Vale do Sol", state: 'RS' },
    { code: '4322541', name: "Vale Real", state: 'RS' },
    { code: '4322525', name: "Vale Verde", state: 'RS' },
    { code: '4322558', name: "Vanini", state: 'RS' },
    { code: '4322608', name: "Venâncio Aires", state: 'RS' },
    { code: '4322707', name: "Vera Cruz", state: 'RS' },
    { code: '4322806', name: "Veranópolis", state: 'RS' },
    { code: '4322855', name: "Vespasiano Corrêa", state: 'RS' },
    { code: '4322905', name: "Viadutos", state: 'RS' },
    { code: '4323002', name: "Viamão", state: 'RS' },
    { code: '4323101', name: "Vicente Dutra", state: 'RS' },
    { code: '4323200', name: "Victor Graeff", state: 'RS' },
    { code: '4323309', name: "Vila Flores", state: 'RS' },
    { code: '4323358', name: "Vila Lângaro", state: 'RS' },
    { code: '4323408', name: "Vila Maria", state: 'RS' },
    { code: '4323457', name: "Vila Nova do Sul", state: 'RS' },
    { code: '4323507', name: "Vista Alegre", state: 'RS' },
    { code: '4323606', name: "Vista Alegre do Prata", state: 'RS' },
    { code: '4323705', name: "Vista Gaúcha", state: 'RS' },
    { code: '4323754', name: "Vitória das Missões", state: 'RS' },
    { code: '4323770', name: "Westfália", state: 'RS' },
    { code: '4323804', name: "Xangri-lá", state: 'RS' }
  ],

  // SANTA CATARINA (SC) - 295 municípios
  SC: [
    { code: '4200051', name: "Abdon Batista", state: 'SC' },
    { code: '4200101', name: "Abelardo Luz", state: 'SC' },
    { code: '4200200', name: "Agrolândia", state: 'SC' },
    { code: '4200309', name: "Agronômica", state: 'SC' },
    { code: '4200408', name: "Água Doce", state: 'SC' },
    { code: '4200507', name: "Águas de Chapecó", state: 'SC' },
    { code: '4200556', name: "Águas Frias", state: 'SC' },
    { code: '4200606', name: "Águas Mornas", state: 'SC' },
    { code: '4200705', name: "Alfredo Wagner", state: 'SC' },
    { code: '4200754', name: "Alto Bela Vista", state: 'SC' },
    { code: '4200804', name: "Anchieta", state: 'SC' },
    { code: '4200903', name: "Angelina", state: 'SC' },
    { code: '4201000', name: "Anita Garibaldi", state: 'SC' },
    { code: '4201109', name: "Anitápolis", state: 'SC' },
    { code: '4201208', name: "Antônio Carlos", state: 'SC' },
    { code: '4201257', name: "Apiúna", state: 'SC' },
    { code: '4201273', name: "Arabutã", state: 'SC' },
    { code: '4201307', name: "Araquari", state: 'SC' },
    { code: '4201406', name: "Araranguá", state: 'SC' },
    { code: '4201505', name: "Armazém", state: 'SC' },
    { code: '4201604', name: "Arroio Trinta", state: 'SC' },
    { code: '4201653', name: "Arvoredo", state: 'SC' },
    { code: '4201703', name: "Ascurra", state: 'SC' },
    { code: '4201802', name: "Atalanta", state: 'SC' },
    { code: '4201901', name: "Aurora", state: 'SC' },
    { code: '4201950', name: "Balneário Arroio do Silva", state: 'SC' },
    { code: '4202057', name: "Balneário Barra do Sul", state: 'SC' },
    { code: '4202008', name: "Balneário Camboriú", state: 'SC' },
    { code: '4202073', name: "Balneário Gaivota", state: 'SC' },
    { code: '4212809', name: "Balneário Piçarras", state: 'SC' },
    { code: '4220000', name: "Balneário Rincão", state: 'SC' },
    { code: '4202081', name: "Bandeirante", state: 'SC' },
    { code: '4202099', name: "Barra Bonita", state: 'SC' },
    { code: '4202107', name: "Barra Velha", state: 'SC' },
    { code: '4202131', name: "Bela Vista do Toldo", state: 'SC' },
    { code: '4202156', name: "Belmonte", state: 'SC' },
    { code: '4202206', name: "Benedito Novo", state: 'SC' },
    { code: '4202305', name: "Biguaçu", state: 'SC' },
    { code: '4202404', name: "Blumenau", state: 'SC' },
    { code: '4202438', name: "Bocaina do Sul", state: 'SC' },
    { code: '4202503', name: "Bom Jardim da Serra", state: 'SC' },
    { code: '4202537', name: "Bom Jesus", state: 'SC' },
    { code: '4202578', name: "Bom Jesus do Oeste", state: 'SC' },
    { code: '4202602', name: "Bom Retiro", state: 'SC' },
    { code: '4202453', name: "Bombinhas", state: 'SC' },
    { code: '4202701', name: "Botuverá", state: 'SC' },
    { code: '4202800', name: "Braço do Norte", state: 'SC' },
    { code: '4202859', name: "Braço do Trombudo", state: 'SC' },
    { code: '4202875', name: "Brunópolis", state: 'SC' },
    { code: '4202909', name: "Brusque", state: 'SC' },
    { code: '4203006', name: "Caçador", state: 'SC' },
    { code: '4203105', name: "Caibi", state: 'SC' },
    { code: '4203154', name: "Calmon", state: 'SC' },
    { code: '4203204', name: "Camboriú", state: 'SC' },
    { code: '4203303', name: "Campo Alegre", state: 'SC' },
    { code: '4203402', name: "Campo Belo do Sul", state: 'SC' },
    { code: '4203501', name: "Campo Erê", state: 'SC' },
    { code: '4203600', name: "Campos Novos", state: 'SC' },
    { code: '4203709', name: "Canelinha", state: 'SC' },
    { code: '4203808', name: "Canoinhas", state: 'SC' },
    { code: '4203253', name: "Capão Alto", state: 'SC' },
    { code: '4203907', name: "Capinzal", state: 'SC' },
    { code: '4203956', name: "Capivari de Baixo", state: 'SC' },
    { code: '4204004', name: "Catanduvas", state: 'SC' },
    { code: '4204103', name: "Caxambu do Sul", state: 'SC' },
    { code: '4204152', name: "Celso Ramos", state: 'SC' },
    { code: '4204178', name: "Cerro Negro", state: 'SC' },
    { code: '4204194', name: "Chapadão do Lageado", state: 'SC' },
    { code: '4204202', name: "Chapecó", state: 'SC' },
    { code: '4204251', name: "Cocal do Sul", state: 'SC' },
    { code: '4204301', name: "Concórdia", state: 'SC' },
    { code: '4204350', name: "Cordilheira Alta", state: 'SC' },
    { code: '4204400', name: "Coronel Freitas", state: 'SC' },
    { code: '4204459', name: "Coronel Martins", state: 'SC' },
    { code: '4204558', name: "Correia Pinto", state: 'SC' },
    { code: '4204509', name: "Corupá", state: 'SC' },
    { code: '4204608', name: "Criciúma", state: 'SC' },
    { code: '4204707', name: "Cunha Porã", state: 'SC' },
    { code: '4204756', name: "Cunhataí", state: 'SC' },
    { code: '4204806', name: "Curitibanos", state: 'SC' },
    { code: '4204905', name: "Descanso", state: 'SC' },
    { code: '4205001', name: "Dionísio Cerqueira", state: 'SC' },
    { code: '4205100', name: "Dona Emma", state: 'SC' },
    { code: '4205159', name: "Doutor Pedrinho", state: 'SC' },
    { code: '4205175', name: "Entre Rios", state: 'SC' },
    { code: '4205191', name: "Ermo", state: 'SC' },
    { code: '4205209', name: "Erval Velho", state: 'SC' },
    { code: '4205308', name: "Faxinal dos Guedes", state: 'SC' },
    { code: '4205357', name: "Flor do Sertão", state: 'SC' },
    { code: '4205407', name: "Florianópolis", state: 'SC' },
    { code: '4205431', name: "Formosa do Sul", state: 'SC' },
    { code: '4205456', name: "Forquilhinha", state: 'SC' },
    { code: '4205506', name: "Fraiburgo", state: 'SC' },
    { code: '4205555', name: "Frei Rogério", state: 'SC' },
    { code: '4205605', name: "Galvão", state: 'SC' },
    { code: '4205704', name: "Garopaba", state: 'SC' },
    { code: '4205803', name: "Garuva", state: 'SC' },
    { code: '4205902', name: "Gaspar", state: 'SC' },
    { code: '4206009', name: "Governador Celso Ramos", state: 'SC' },
    { code: '4206108', name: "Grão-Pará", state: 'SC' },
    { code: '4206207', name: "Gravatal", state: 'SC' },
    { code: '4206306', name: "Guabiruba", state: 'SC' },
    { code: '4206405', name: "Guaraciaba", state: 'SC' },
    { code: '4206504', name: "Guaramirim", state: 'SC' },
    { code: '4206603', name: "Guarujá do Sul", state: 'SC' },
    { code: '4206652', name: "Guatambú", state: 'SC' },
    { code: '4206702', name: "Herval d'Oeste", state: 'SC' },
    { code: '4206751', name: "Ibiam", state: 'SC' },
    { code: '4206801', name: "Ibicaré", state: 'SC' },
    { code: '4206900', name: "Ibirama", state: 'SC' },
    { code: '4207007', name: "Içara", state: 'SC' },
    { code: '4207106', name: "Ilhota", state: 'SC' },
    { code: '4207205', name: "Imaruí", state: 'SC' },
    { code: '4207304', name: "Imbituba", state: 'SC' },
    { code: '4207403', name: "Imbuia", state: 'SC' },
    { code: '4207502', name: "Indaial", state: 'SC' },
    { code: '4207577', name: "Iomerê", state: 'SC' },
    { code: '4207601', name: "Ipira", state: 'SC' },
    { code: '4207650', name: "Iporã do Oeste", state: 'SC' },
    { code: '4207684', name: "Ipuaçu", state: 'SC' },
    { code: '4207700', name: "Ipumirim", state: 'SC' },
    { code: '4207759', name: "Iraceminha", state: 'SC' },
    { code: '4207809', name: "Irani", state: 'SC' },
    { code: '4207858', name: "Irati", state: 'SC' },
    { code: '4207908', name: "Irineópolis", state: 'SC' },
    { code: '4208005', name: "Itá", state: 'SC' },
    { code: '4208104', name: "Itaiópolis", state: 'SC' },
    { code: '4208203', name: "Itajaí", state: 'SC' },
    { code: '4208302', name: "Itapema", state: 'SC' },
    { code: '4208401', name: "Itapiranga", state: 'SC' },
    { code: '4208450', name: "Itapoá", state: 'SC' },
    { code: '4208500', name: "Ituporanga", state: 'SC' },
    { code: '4208609', name: "Jaborá", state: 'SC' },
    { code: '4208708', name: "Jacinto Machado", state: 'SC' },
    { code: '4208807', name: "Jaguaruna", state: 'SC' },
    { code: '4208906', name: "Jaraguá do Sul", state: 'SC' },
    { code: '4208955', name: "Jardinópolis", state: 'SC' },
    { code: '4209003', name: "Joaçaba", state: 'SC' },
    { code: '4209102', name: "Joinville", state: 'SC' },
    { code: '4209151', name: "José Boiteux", state: 'SC' },
    { code: '4209177', name: "Jupiá", state: 'SC' },
    { code: '4209201', name: "Lacerdópolis", state: 'SC' },
    { code: '4209300', name: "Lages", state: 'SC' },
    { code: '4209409', name: "Laguna", state: 'SC' },
    { code: '4209458', name: "Lajeado Grande", state: 'SC' },
    { code: '4209508', name: "Laurentino", state: 'SC' },
    { code: '4209607', name: "Lauro Müller", state: 'SC' },
    { code: '4209706', name: "Lebon Régis", state: 'SC' },
    { code: '4209805', name: "Leoberto Leal", state: 'SC' },
    { code: '4209854', name: "Lindóia do Sul", state: 'SC' },
    { code: '4209904', name: "Lontras", state: 'SC' },
    { code: '4210001', name: "Luiz Alves", state: 'SC' },
    { code: '4210035', name: "Luzerna", state: 'SC' },
    { code: '4210050', name: "Macieira", state: 'SC' },
    { code: '4210100', name: "Mafra", state: 'SC' },
    { code: '4210209', name: "Major Gercino", state: 'SC' },
    { code: '4210308', name: "Major Vieira", state: 'SC' },
    { code: '4210407', name: "Maracajá", state: 'SC' },
    { code: '4210506', name: "Maravilha", state: 'SC' },
    { code: '4210555', name: "Marema", state: 'SC' },
    { code: '4210605', name: "Massaranduba", state: 'SC' },
    { code: '4210704', name: "Matos Costa", state: 'SC' },
    { code: '4210803', name: "Meleiro", state: 'SC' },
    { code: '4210852', name: "Mirim Doce", state: 'SC' },
    { code: '4210902', name: "Modelo", state: 'SC' },
    { code: '4211009', name: "Mondaí", state: 'SC' },
    { code: '4211058', name: "Monte Carlo", state: 'SC' },
    { code: '4211108', name: "Monte Castelo", state: 'SC' },
    { code: '4211207', name: "Morro da Fumaça", state: 'SC' },
    { code: '4211256', name: "Morro Grande", state: 'SC' },
    { code: '4211306', name: "Navegantes", state: 'SC' },
    { code: '4211405', name: "Nova Erechim", state: 'SC' },
    { code: '4211454', name: "Nova Itaberaba", state: 'SC' },
    { code: '4211504', name: "Nova Trento", state: 'SC' },
    { code: '4211603', name: "Nova Veneza", state: 'SC' },
    { code: '4211652', name: "Novo Horizonte", state: 'SC' },
    { code: '4211702', name: "Orleans", state: 'SC' },
    { code: '4211751', name: "Otacílio Costa", state: 'SC' },
    { code: '4211801', name: "Ouro", state: 'SC' },
    { code: '4211850', name: "Ouro Verde", state: 'SC' },
    { code: '4211876', name: "Paial", state: 'SC' },
    { code: '4211892', name: "Painel", state: 'SC' },
    { code: '4211900', name: "Palhoça", state: 'SC' },
    { code: '4212007', name: "Palma Sola", state: 'SC' },
    { code: '4212056', name: "Palmeira", state: 'SC' },
    { code: '4212106', name: "Palmitos", state: 'SC' },
    { code: '4212205', name: "Papanduva", state: 'SC' },
    { code: '4212239', name: "Paraíso", state: 'SC' },
    { code: '4212254', name: "Passo de Torres", state: 'SC' },
    { code: '4212270', name: "Passos Maia", state: 'SC' },
    { code: '4212304', name: "Paulo Lopes", state: 'SC' },
    { code: '4212403', name: "Pedras Grandes", state: 'SC' },
    { code: '4212502', name: "Penha", state: 'SC' },
    { code: '4212601', name: "Peritiba", state: 'SC' },
    { code: '4212650', name: "Pescaria Brava", state: 'SC' },
    { code: '4212700', name: "Petrolândia", state: 'SC' },
    { code: '4212908', name: "Pinhalzinho", state: 'SC' },
    { code: '4213005', name: "Pinheiro Preto", state: 'SC' },
    { code: '4213104', name: "Piratuba", state: 'SC' },
    { code: '4213153', name: "Planalto Alegre", state: 'SC' },
    { code: '4213203', name: "Pomerode", state: 'SC' },
    { code: '4213302', name: "Ponte Alta", state: 'SC' },
    { code: '4213351', name: "Ponte Alta do Norte", state: 'SC' },
    { code: '4213401', name: "Ponte Serrada", state: 'SC' },
    { code: '4213500', name: "Porto Belo", state: 'SC' },
    { code: '4213609', name: "Porto União", state: 'SC' },
    { code: '4213708', name: "Pouso Redondo", state: 'SC' },
    { code: '4213807', name: "Praia Grande", state: 'SC' },
    { code: '4213906', name: "Presidente Castello Branco", state: 'SC' },
    { code: '4214003', name: "Presidente Getúlio", state: 'SC' },
    { code: '4214102', name: "Presidente Nereu", state: 'SC' },
    { code: '4214151', name: "Princesa", state: 'SC' },
    { code: '4214201', name: "Quilombo", state: 'SC' },
    { code: '4214300', name: "Rancho Queimado", state: 'SC' },
    { code: '4214409', name: "Rio das Antas", state: 'SC' },
    { code: '4214508', name: "Rio do Campo", state: 'SC' },
    { code: '4214607', name: "Rio do Oeste", state: 'SC' },
    { code: '4214805', name: "Rio do Sul", state: 'SC' },
    { code: '4214706', name: "Rio dos Cedros", state: 'SC' },
    { code: '4214904', name: "Rio Fortuna", state: 'SC' },
    { code: '4215000', name: "Rio Negrinho", state: 'SC' },
    { code: '4215059', name: "Rio Rufino", state: 'SC' },
    { code: '4215075', name: "Riqueza", state: 'SC' },
    { code: '4215109', name: "Rodeio", state: 'SC' },
    { code: '4215208', name: "Romelândia", state: 'SC' },
    { code: '4215307', name: "Salete", state: 'SC' },
    { code: '4215356', name: "Saltinho", state: 'SC' },
    { code: '4215406', name: "Salto Veloso", state: 'SC' },
    { code: '4215455', name: "Sangão", state: 'SC' },
    { code: '4215505', name: "Santa Cecília", state: 'SC' },
    { code: '4215554', name: "Santa Helena", state: 'SC' },
    { code: '4215604', name: "Santa Rosa de Lima", state: 'SC' },
    { code: '4215653', name: "Santa Rosa do Sul", state: 'SC' },
    { code: '4215679', name: "Santa Terezinha", state: 'SC' },
    { code: '4215687', name: "Santa Terezinha do Progresso", state: 'SC' },
    { code: '4215695', name: "Santiago do Sul", state: 'SC' },
    { code: '4215703', name: "Santo Amaro da Imperatriz", state: 'SC' },
    { code: '4215802', name: "São Bento do Sul", state: 'SC' },
    { code: '4215752', name: "São Bernardino", state: 'SC' },
    { code: '4215901', name: "São Bonifácio", state: 'SC' },
    { code: '4216008', name: "São Carlos", state: 'SC' },
    { code: '4216057', name: "São Cristóvão do Sul", state: 'SC' },
    { code: '4216107', name: "São Domingos", state: 'SC' },
    { code: '4216206', name: "São Francisco do Sul", state: 'SC' },
    { code: '4216305', name: "São João Batista", state: 'SC' },
    { code: '4216354', name: "São João do Itaperiú", state: 'SC' },
    { code: '4216255', name: "São João do Oeste", state: 'SC' },
    { code: '4216404', name: "São João do Sul", state: 'SC' },
    { code: '4216503', name: "São Joaquim", state: 'SC' },
    { code: '4216602', name: "São José", state: 'SC' },
    { code: '4216701', name: "São José do Cedro", state: 'SC' },
    { code: '4216800', name: "São José do Cerrito", state: 'SC' },
    { code: '4216909', name: "São Lourenço do Oeste", state: 'SC' },
    { code: '4217006', name: "São Ludgero", state: 'SC' },
    { code: '4217105', name: "São Martinho", state: 'SC' },
    { code: '4217154', name: "São Miguel da Boa Vista", state: 'SC' },
    { code: '4217204', name: "São Miguel do Oeste", state: 'SC' },
    { code: '4217253', name: "São Pedro de Alcântara", state: 'SC' },
    { code: '4217303', name: "Saudades", state: 'SC' },
    { code: '4217402', name: "Schroeder", state: 'SC' },
    { code: '4217501', name: "Seara", state: 'SC' },
    { code: '4217550', name: "Serra Alta", state: 'SC' },
    { code: '4217600', name: "Siderópolis", state: 'SC' },
    { code: '4217709', name: "Sombrio", state: 'SC' },
    { code: '4217758', name: "Sul Brasil", state: 'SC' },
    { code: '4217808', name: "Taió", state: 'SC' },
    { code: '4217907', name: "Tangará", state: 'SC' },
    { code: '4217956', name: "Tigrinhos", state: 'SC' },
    { code: '4218004', name: "Tijucas", state: 'SC' },
    { code: '4218103', name: "Timbé do Sul", state: 'SC' },
    { code: '4218202', name: "Timbó", state: 'SC' },
    { code: '4218251', name: "Timbó Grande", state: 'SC' },
    { code: '4218301', name: "Três Barras", state: 'SC' },
    { code: '4218350', name: "Treviso", state: 'SC' },
    { code: '4218400', name: "Treze de Maio", state: 'SC' },
    { code: '4218509', name: "Treze Tílias", state: 'SC' },
    { code: '4218608', name: "Trombudo Central", state: 'SC' },
    { code: '4218707', name: "Tubarão", state: 'SC' },
    { code: '4218756', name: "Tunápolis", state: 'SC' },
    { code: '4218806', name: "Turvo", state: 'SC' },
    { code: '4218855', name: "União do Oeste", state: 'SC' },
    { code: '4218905', name: "Urubici", state: 'SC' },
    { code: '4218954', name: "Urupema", state: 'SC' },
    { code: '4219002', name: "Urussanga", state: 'SC' },
    { code: '4219101', name: "Vargeão", state: 'SC' },
    { code: '4219150', name: "Vargem", state: 'SC' },
    { code: '4219176', name: "Vargem Bonita", state: 'SC' },
    { code: '4219200', name: "Vidal Ramos", state: 'SC' },
    { code: '4219309', name: "Videira", state: 'SC' },
    { code: '4219358', name: "Vitor Meireles", state: 'SC' },
    { code: '4219408', name: "Witmarsum", state: 'SC' },
    { code: '4219507', name: "Xanxerê", state: 'SC' },
    { code: '4219606', name: "Xavantina", state: 'SC' },
    { code: '4219705', name: "Xaxim", state: 'SC' },
    { code: '4219853', name: "Zortéa", state: 'SC' }
  ],

  // SERGIPE (SE) - 75 municípios
  SE: [
    { code: '2800100', name: "Amparo do São Francisco", state: 'SE' },
    { code: '2800209', name: "Aquidabã", state: 'SE' },
    { code: '2800308', name: "Aracaju", state: 'SE' },
    { code: '2800407', name: "Arauá", state: 'SE' },
    { code: '2800506', name: "Areia Branca", state: 'SE' },
    { code: '2800605', name: "Barra dos Coqueiros", state: 'SE' },
    { code: '2800670', name: "Boquim", state: 'SE' },
    { code: '2800704', name: "Brejo Grande", state: 'SE' },
    { code: '2801009', name: "Campo do Brito", state: 'SE' },
    { code: '2801108', name: "Canhoba", state: 'SE' },
    { code: '2801207', name: "Canindé de São Francisco", state: 'SE' },
    { code: '2801306', name: "Capela", state: 'SE' },
    { code: '2801405', name: "Carira", state: 'SE' },
    { code: '2801504', name: "Carmópolis", state: 'SE' },
    { code: '2801603', name: "Cedro de São João", state: 'SE' },
    { code: '2801702', name: "Cristinápolis", state: 'SE' },
    { code: '2801900', name: "Cumbe", state: 'SE' },
    { code: '2802007', name: "Divina Pastora", state: 'SE' },
    { code: '2802106', name: "Estância", state: 'SE' },
    { code: '2802205', name: "Feira Nova", state: 'SE' },
    { code: '2802304', name: "Frei Paulo", state: 'SE' },
    { code: '2802403', name: "Gararu", state: 'SE' },
    { code: '2802502', name: "General Maynard", state: 'SE' },
    { code: '2802601', name: "Graccho Cardoso", state: 'SE' },
    { code: '2802700', name: "Ilha das Flores", state: 'SE' },
    { code: '2802809', name: "Indiaroba", state: 'SE' },
    { code: '2802908', name: "Itabaiana", state: 'SE' },
    { code: '2803005', name: "Itabaianinha", state: 'SE' },
    { code: '2803104', name: "Itabi", state: 'SE' },
    { code: '2803203', name: "Itaporanga d'Ajuda", state: 'SE' },
    { code: '2803302', name: "Japaratuba", state: 'SE' },
    { code: '2803401', name: "Japoatã", state: 'SE' },
    { code: '2803500', name: "Lagarto", state: 'SE' },
    { code: '2803609', name: "Laranjeiras", state: 'SE' },
    { code: '2803708', name: "Macambira", state: 'SE' },
    { code: '2803807', name: "Malhada dos Bois", state: 'SE' },
    { code: '2803906', name: "Malhador", state: 'SE' },
    { code: '2804003', name: "Maruim", state: 'SE' },
    { code: '2804102', name: "Moita Bonita", state: 'SE' },
    { code: '2804201', name: "Monte Alegre de Sergipe", state: 'SE' },
    { code: '2804300', name: "Muribeca", state: 'SE' },
    { code: '2804409', name: "Neópolis", state: 'SE' },
    { code: '2804458', name: "Nossa Senhora Aparecida", state: 'SE' },
    { code: '2804508', name: "Nossa Senhora da Glória", state: 'SE' },
    { code: '2804607', name: "Nossa Senhora das Dores", state: 'SE' },
    { code: '2804706', name: "Nossa Senhora de Lourdes", state: 'SE' },
    { code: '2804805', name: "Nossa Senhora do Socorro", state: 'SE' },
    { code: '2804904', name: "Pacatuba", state: 'SE' },
    { code: '2805000', name: "Pedra Mole", state: 'SE' },
    { code: '2805109', name: "Pedrinhas", state: 'SE' },
    { code: '2805208', name: "Pinhão", state: 'SE' },
    { code: '2805307', name: "Pirambu", state: 'SE' },
    { code: '2805406', name: "Poço Redondo", state: 'SE' },
    { code: '2805505', name: "Poço Verde", state: 'SE' },
    { code: '2805604', name: "Porto da Folha", state: 'SE' },
    { code: '2805703', name: "Propriá", state: 'SE' },
    { code: '2805802', name: "Riachão do Dantas", state: 'SE' },
    { code: '2805901', name: "Riachuelo", state: 'SE' },
    { code: '2806008', name: "Ribeirópolis", state: 'SE' },
    { code: '2806107', name: "Rosário do Catete", state: 'SE' },
    { code: '2806206', name: "Salgado", state: 'SE' },
    { code: '2806305', name: "Santa Luzia do Itanhy", state: 'SE' },
    { code: '2806503', name: "Santa Rosa de Lima", state: 'SE' },
    { code: '2806404', name: "Santana do São Francisco", state: 'SE' },
    { code: '2806602', name: "Santo Amaro das Brotas", state: 'SE' },
    { code: '2806701', name: "São Cristóvão", state: 'SE' },
    { code: '2806800', name: "São Domingos", state: 'SE' },
    { code: '2806909', name: "São Francisco", state: 'SE' },
    { code: '2807006', name: "São Miguel do Aleixo", state: 'SE' },
    { code: '2807105', name: "Simão Dias", state: 'SE' },
    { code: '2807204', name: "Siriri", state: 'SE' },
    { code: '2807303', name: "Telha", state: 'SE' },
    { code: '2807402', name: "Tobias Barreto", state: 'SE' },
    { code: '2807501', name: "Tomar do Geru", state: 'SE' },
    { code: '2807600', name: "Umbaúba", state: 'SE' }
  ],

  // SÃO PAULO (SP) - 645 municípios
  SP: [
    { code: '3500105', name: "Adamantina", state: 'SP' },
    { code: '3500204', name: "Adolfo", state: 'SP' },
    { code: '3500303', name: "Aguaí", state: 'SP' },
    { code: '3500402', name: "Águas da Prata", state: 'SP' },
    { code: '3500501', name: "Águas de Lindóia", state: 'SP' },
    { code: '3500550', name: "Águas de Santa Bárbara", state: 'SP' },
    { code: '3500600', name: "Águas de São Pedro", state: 'SP' },
    { code: '3500709', name: "Agudos", state: 'SP' },
    { code: '3500758', name: "Alambari", state: 'SP' },
    { code: '3500808', name: "Alfredo Marcondes", state: 'SP' },
    { code: '3500907', name: "Altair", state: 'SP' },
    { code: '3501004', name: "Altinópolis", state: 'SP' },
    { code: '3501103', name: "Alto Alegre", state: 'SP' },
    { code: '3501152', name: "Alumínio", state: 'SP' },
    { code: '3501202', name: "Álvares Florence", state: 'SP' },
    { code: '3501301', name: "Álvares Machado", state: 'SP' },
    { code: '3501400', name: "Álvaro de Carvalho", state: 'SP' },
    { code: '3501509', name: "Alvinlândia", state: 'SP' },
    { code: '3501608', name: "Americana", state: 'SP' },
    { code: '3501707', name: "Américo Brasiliense", state: 'SP' },
    { code: '3501806', name: "Américo de Campos", state: 'SP' },
    { code: '3501905', name: "Amparo", state: 'SP' },
    { code: '3502002', name: "Analândia", state: 'SP' },
    { code: '3502101', name: "Andradina", state: 'SP' },
    { code: '3502200', name: "Angatuba", state: 'SP' },
    { code: '3502309', name: "Anhembi", state: 'SP' },
    { code: '3502408', name: "Anhumas", state: 'SP' },
    { code: '3502507', name: "Aparecida", state: 'SP' },
    { code: '3502606', name: "Aparecida d'Oeste", state: 'SP' },
    { code: '3502705', name: "Apiaí", state: 'SP' },
    { code: '3502754', name: "Araçariguama", state: 'SP' },
    { code: '3502804', name: "Araçatuba", state: 'SP' },
    { code: '3502903', name: "Araçoiaba da Serra", state: 'SP' },
    { code: '3503000', name: "Aramina", state: 'SP' },
    { code: '3503109', name: "Arandu", state: 'SP' },
    { code: '3503158', name: "Arapeí", state: 'SP' },
    { code: '3503208', name: "Araraquara", state: 'SP' },
    { code: '3503307', name: "Araras", state: 'SP' },
    { code: '3503356', name: "Arco-Íris", state: 'SP' },
    { code: '3503406', name: "Arealva", state: 'SP' },
    { code: '3503505', name: "Areias", state: 'SP' },
    { code: '3503604', name: "Areiópolis", state: 'SP' },
    { code: '3503703', name: "Ariranha", state: 'SP' },
    { code: '3503802', name: "Artur Nogueira", state: 'SP' },
    { code: '3503901', name: "Arujá", state: 'SP' },
    { code: '3503950', name: "Aspásia", state: 'SP' },
    { code: '3504008', name: "Assis", state: 'SP' },
    { code: '3504107', name: "Atibaia", state: 'SP' },
    { code: '3504206', name: "Auriflama", state: 'SP' },
    { code: '3504305', name: "Avaí", state: 'SP' },
    { code: '3504404', name: "Avanhandava", state: 'SP' },
    { code: '3504503', name: "Avaré", state: 'SP' },
    { code: '3504602', name: "Bady Bassitt", state: 'SP' },
    { code: '3504701', name: "Balbinos", state: 'SP' },
    { code: '3504800', name: "Bálsamo", state: 'SP' },
    { code: '3504909', name: "Bananal", state: 'SP' },
    { code: '3505005', name: "Barão de Antonina", state: 'SP' },
    { code: '3505104', name: "Barbosa", state: 'SP' },
    { code: '3505203', name: "Bariri", state: 'SP' },
    { code: '3505302', name: "Barra Bonita", state: 'SP' },
    { code: '3505351', name: "Barra do Chapéu", state: 'SP' },
    { code: '3505401', name: "Barra do Turvo", state: 'SP' },
    { code: '3505500', name: "Barretos", state: 'SP' },
    { code: '3505609', name: "Barrinha", state: 'SP' },
    { code: '3505708', name: "Barueri", state: 'SP' },
    { code: '3505807', name: "Bastos", state: 'SP' },
    { code: '3505906', name: "Batatais", state: 'SP' },
    { code: '3506003', name: "Bauru", state: 'SP' },
    { code: '3506102', name: "Bebedouro", state: 'SP' },
    { code: '3506201', name: "Bento de Abreu", state: 'SP' },
    { code: '3506300', name: "Bernardino de Campos", state: 'SP' },
    { code: '3506359', name: "Bertioga", state: 'SP' },
    { code: '3506409', name: "Bilac", state: 'SP' },
    { code: '3506508', name: "Birigui", state: 'SP' },
    { code: '3506607', name: "Biritiba Mirim", state: 'SP' },
    { code: '3506706', name: "Boa Esperança do Sul", state: 'SP' },
    { code: '3506805', name: "Bocaina", state: 'SP' },
    { code: '3506904', name: "Bofete", state: 'SP' },
    { code: '3507001', name: "Boituva", state: 'SP' },
    { code: '3507100', name: "Bom Jesus dos Perdões", state: 'SP' },
    { code: '3507159', name: "Bom Sucesso de Itararé", state: 'SP' },
    { code: '3507209', name: "Borá", state: 'SP' },
    { code: '3507308', name: "Boracéia", state: 'SP' },
    { code: '3507407', name: "Borborema", state: 'SP' },
    { code: '3507456', name: "Borebi", state: 'SP' },
    { code: '3507506', name: "Botucatu", state: 'SP' },
    { code: '3507605', name: "Bragança Paulista", state: 'SP' },
    { code: '3507704', name: "Braúna", state: 'SP' },
    { code: '3507753', name: "Brejo Alegre", state: 'SP' },
    { code: '3507803', name: "Brodowski", state: 'SP' },
    { code: '3507902', name: "Brotas", state: 'SP' },
    { code: '3508009', name: "Buri", state: 'SP' },
    { code: '3508108', name: "Buritama", state: 'SP' },
    { code: '3508207', name: "Buritizal", state: 'SP' },
    { code: '3508306', name: "Cabrália Paulista", state: 'SP' },
    { code: '3508405', name: "Cabreúva", state: 'SP' },
    { code: '3508504', name: "Caçapava", state: 'SP' },
    { code: '3508603', name: "Cachoeira Paulista", state: 'SP' },
    { code: '3508702', name: "Caconde", state: 'SP' },
    { code: '3508801', name: "Cafelândia", state: 'SP' },
    { code: '3508900', name: "Caiabu", state: 'SP' },
    { code: '3509007', name: "Caieiras", state: 'SP' },
    { code: '3509106', name: "Caiuá", state: 'SP' },
    { code: '3509205', name: "Cajamar", state: 'SP' },
    { code: '3509254', name: "Cajati", state: 'SP' },
    { code: '3509304', name: "Cajobi", state: 'SP' },
    { code: '3509403', name: "Cajuru", state: 'SP' },
    { code: '3509452', name: "Campina do Monte Alegre", state: 'SP' },
    { code: '3509502', name: "Campinas", state: 'SP' },
    { code: '3509601', name: "Campo Limpo Paulista", state: 'SP' },
    { code: '3509700', name: "Campos do Jordão", state: 'SP' },
    { code: '3509809', name: "Campos Novos Paulista", state: 'SP' },
    { code: '3509908', name: "Cananéia", state: 'SP' },
    { code: '3509957', name: "Canas", state: 'SP' },
    { code: '3510005', name: "Cândido Mota", state: 'SP' },
    { code: '3510104', name: "Cândido Rodrigues", state: 'SP' },
    { code: '3510153', name: "Canitar", state: 'SP' },
    { code: '3510203', name: "Capão Bonito", state: 'SP' },
    { code: '3510302', name: "Capela do Alto", state: 'SP' },
    { code: '3510401', name: "Capivari", state: 'SP' },
    { code: '3510500', name: "Caraguatatuba", state: 'SP' },
    { code: '3510609', name: "Carapicuíba", state: 'SP' },
    { code: '3510708', name: "Cardoso", state: 'SP' },
    { code: '3510807', name: "Casa Branca", state: 'SP' },
    { code: '3510906', name: "Cássia dos Coqueiros", state: 'SP' },
    { code: '3511003', name: "Castilho", state: 'SP' },
    { code: '3511102', name: "Catanduva", state: 'SP' },
    { code: '3511201', name: "Catiguá", state: 'SP' },
    { code: '3511300', name: "Cedral", state: 'SP' },
    { code: '3511409', name: "Cerqueira César", state: 'SP' },
    { code: '3511508', name: "Cerquilho", state: 'SP' },
    { code: '3511607', name: "Cesário Lange", state: 'SP' },
    { code: '3511706', name: "Charqueada", state: 'SP' },
    { code: '3557204', name: "Chavantes", state: 'SP' },
    { code: '3511904', name: "Clementina", state: 'SP' },
    { code: '3512001', name: "Colina", state: 'SP' },
    { code: '3512100', name: "Colômbia", state: 'SP' },
    { code: '3512209', name: "Conchal", state: 'SP' },
    { code: '3512308', name: "Conchas", state: 'SP' },
    { code: '3512407', name: "Cordeirópolis", state: 'SP' },
    { code: '3512506', name: "Coroados", state: 'SP' },
    { code: '3512605', name: "Coronel Macedo", state: 'SP' },
    { code: '3512704', name: "Corumbataí", state: 'SP' },
    { code: '3512803', name: "Cosmópolis", state: 'SP' },
    { code: '3512902', name: "Cosmorama", state: 'SP' },
    { code: '3513009', name: "Cotia", state: 'SP' },
    { code: '3513108', name: "Cravinhos", state: 'SP' },
    { code: '3513207', name: "Cristais Paulista", state: 'SP' },
    { code: '3513306', name: "Cruzália", state: 'SP' },
    { code: '3513405', name: "Cruzeiro", state: 'SP' },
    { code: '3513504', name: "Cubatão", state: 'SP' },
    { code: '3513603', name: "Cunha", state: 'SP' },
    { code: '3513702', name: "Descalvado", state: 'SP' },
    { code: '3513801', name: "Diadema", state: 'SP' },
    { code: '3513850', name: "Dirce Reis", state: 'SP' },
    { code: '3513900', name: "Divinolândia", state: 'SP' },
    { code: '3514007', name: "Dobrada", state: 'SP' },
    { code: '3514106', name: "Dois Córregos", state: 'SP' },
    { code: '3514205', name: "Dolcinópolis", state: 'SP' },
    { code: '3514304', name: "Dourado", state: 'SP' },
    { code: '3514403', name: "Dracena", state: 'SP' },
    { code: '3514502', name: "Duartina", state: 'SP' },
    { code: '3514601', name: "Dumont", state: 'SP' },
    { code: '3514700', name: "Echaporã", state: 'SP' },
    { code: '3514809', name: "Eldorado", state: 'SP' },
    { code: '3514908', name: "Elias Fausto", state: 'SP' },
    { code: '3514924', name: "Elisiário", state: 'SP' },
    { code: '3514957', name: "Embaúba", state: 'SP' },
    { code: '3515004', name: "Embu das Artes", state: 'SP' },
    { code: '3515103', name: "Embu-Guaçu", state: 'SP' },
    { code: '3515129', name: "Emilianópolis", state: 'SP' },
    { code: '3515152', name: "Engenheiro Coelho", state: 'SP' },
    { code: '3515186', name: "Espírito Santo do Pinhal", state: 'SP' },
    { code: '3515194', name: "Espírito Santo do Turvo", state: 'SP' },
    { code: '3557303', name: "Estiva Gerbi", state: 'SP' },
    { code: '3515202', name: "Estrela d'Oeste", state: 'SP' },
    { code: '3515301', name: "Estrela do Norte", state: 'SP' },
    { code: '3515350', name: "Euclides da Cunha Paulista", state: 'SP' },
    { code: '3515400', name: "Fartura", state: 'SP' },
    { code: '3515608', name: "Fernando Prestes", state: 'SP' },
    { code: '3515509', name: "Fernandópolis", state: 'SP' },
    { code: '3515657', name: "Fernão", state: 'SP' },
    { code: '3515707', name: "Ferraz de Vasconcelos", state: 'SP' },
    { code: '3515806', name: "Flora Rica", state: 'SP' },
    { code: '3515905', name: "Floreal", state: 'SP' },
    { code: '3516002', name: "Flórida Paulista", state: 'SP' },
    { code: '3516101', name: "Florínea", state: 'SP' },
    { code: '3516200', name: "Franca", state: 'SP' },
    { code: '3516309', name: "Francisco Morato", state: 'SP' },
    { code: '3516408', name: "Franco da Rocha", state: 'SP' },
    { code: '3516507', name: "Gabriel Monteiro", state: 'SP' },
    { code: '3516606', name: "Gália", state: 'SP' },
    { code: '3516705', name: "Garça", state: 'SP' },
    { code: '3516804', name: "Gastão Vidigal", state: 'SP' },
    { code: '3516853', name: "Gavião Peixoto", state: 'SP' },
    { code: '3516903', name: "General Salgado", state: 'SP' },
    { code: '3517000', name: "Getulina", state: 'SP' },
    { code: '3517109', name: "Glicério", state: 'SP' },
    { code: '3517208', name: "Guaiçara", state: 'SP' },
    { code: '3517307', name: "Guaimbê", state: 'SP' },
    { code: '3517406', name: "Guaíra", state: 'SP' },
    { code: '3517505', name: "Guapiaçu", state: 'SP' },
    { code: '3517604', name: "Guapiara", state: 'SP' },
    { code: '3517703', name: "Guará", state: 'SP' },
    { code: '3517802', name: "Guaraçaí", state: 'SP' },
    { code: '3517901', name: "Guaraci", state: 'SP' },
    { code: '3518008', name: "Guarani d'Oeste", state: 'SP' },
    { code: '3518107', name: "Guarantã", state: 'SP' },
    { code: '3518206', name: "Guararapes", state: 'SP' },
    { code: '3518305', name: "Guararema", state: 'SP' },
    { code: '3518404', name: "Guaratinguetá", state: 'SP' },
    { code: '3518503', name: "Guareí", state: 'SP' },
    { code: '3518602', name: "Guariba", state: 'SP' },
    { code: '3518701', name: "Guarujá", state: 'SP' },
    { code: '3518800', name: "Guarulhos", state: 'SP' },
    { code: '3518859', name: "Guatapará", state: 'SP' },
    { code: '3518909', name: "Guzolândia", state: 'SP' },
    { code: '3519006', name: "Herculândia", state: 'SP' },
    { code: '3519055', name: "Holambra", state: 'SP' },
    { code: '3519071', name: "Hortolândia", state: 'SP' },
    { code: '3519105', name: "Iacanga", state: 'SP' },
    { code: '3519204', name: "Iacri", state: 'SP' },
    { code: '3519253', name: "Iaras", state: 'SP' },
    { code: '3519303', name: "Ibaté", state: 'SP' },
    { code: '3519402', name: "Ibirá", state: 'SP' },
    { code: '3519501', name: "Ibirarema", state: 'SP' },
    { code: '3519600', name: "Ibitinga", state: 'SP' },
    { code: '3519709', name: "Ibiúna", state: 'SP' },
    { code: '3519808', name: "Icém", state: 'SP' },
    { code: '3519907', name: "Iepê", state: 'SP' },
    { code: '3520004', name: "Igaraçu do Tietê", state: 'SP' },
    { code: '3520103', name: "Igarapava", state: 'SP' },
    { code: '3520202', name: "Igaratá", state: 'SP' },
    { code: '3520301', name: "Iguape", state: 'SP' },
    { code: '3520426', name: "Ilha Comprida", state: 'SP' },
    { code: '3520442', name: "Ilha Solteira", state: 'SP' },
    { code: '3520400', name: "Ilhabela", state: 'SP' },
    { code: '3520509', name: "Indaiatuba", state: 'SP' },
    { code: '3520608', name: "Indiana", state: 'SP' },
    { code: '3520707', name: "Indiaporã", state: 'SP' },
    { code: '3520806', name: "Inúbia Paulista", state: 'SP' },
    { code: '3520905', name: "Ipaussu", state: 'SP' },
    { code: '3521002', name: "Iperó", state: 'SP' },
    { code: '3521101', name: "Ipeúna", state: 'SP' },
    { code: '3521150', name: "Ipiguá", state: 'SP' },
    { code: '3521200', name: "Iporanga", state: 'SP' },
    { code: '3521309', name: "Ipuã", state: 'SP' },
    { code: '3521408', name: "Iracemápolis", state: 'SP' },
    { code: '3521507', name: "Irapuã", state: 'SP' },
    { code: '3521606', name: "Irapuru", state: 'SP' },
    { code: '3521705', name: "Itaberá", state: 'SP' },
    { code: '3521804', name: "Itaí", state: 'SP' },
    { code: '3521903', name: "Itajobi", state: 'SP' },
    { code: '3522000', name: "Itaju", state: 'SP' },
    { code: '3522109', name: "Itanhaém", state: 'SP' },
    { code: '3522158', name: "Itaoca", state: 'SP' },
    { code: '3522208', name: "Itapecerica da Serra", state: 'SP' },
    { code: '3522307', name: "Itapetininga", state: 'SP' },
    { code: '3522406', name: "Itapeva", state: 'SP' },
    { code: '3522505', name: "Itapevi", state: 'SP' },
    { code: '3522604', name: "Itapira", state: 'SP' },
    { code: '3522653', name: "Itapirapuã Paulista", state: 'SP' },
    { code: '3522703', name: "Itápolis", state: 'SP' },
    { code: '3522802', name: "Itaporanga", state: 'SP' },
    { code: '3522901', name: "Itapuí", state: 'SP' },
    { code: '3523008', name: "Itapura", state: 'SP' },
    { code: '3523107', name: "Itaquaquecetuba", state: 'SP' },
    { code: '3523206', name: "Itararé", state: 'SP' },
    { code: '3523305', name: "Itariri", state: 'SP' },
    { code: '3523404', name: "Itatiba", state: 'SP' },
    { code: '3523503', name: "Itatinga", state: 'SP' },
    { code: '3523602', name: "Itirapina", state: 'SP' },
    { code: '3523701', name: "Itirapuã", state: 'SP' },
    { code: '3523800', name: "Itobi", state: 'SP' },
    { code: '3523909', name: "Itu", state: 'SP' },
    { code: '3524006', name: "Itupeva", state: 'SP' },
    { code: '3524105', name: "Ituverava", state: 'SP' },
    { code: '3524204', name: "Jaborandi", state: 'SP' },
    { code: '3524303', name: "Jaboticabal", state: 'SP' },
    { code: '3524402', name: "Jacareí", state: 'SP' },
    { code: '3524501', name: "Jaci", state: 'SP' },
    { code: '3524600', name: "Jacupiranga", state: 'SP' },
    { code: '3524709', name: "Jaguariúna", state: 'SP' },
    { code: '3524808', name: "Jales", state: 'SP' },
    { code: '3524907', name: "Jambeiro", state: 'SP' },
    { code: '3525003', name: "Jandira", state: 'SP' },
    { code: '3525102', name: "Jardinópolis", state: 'SP' },
    { code: '3525201', name: "Jarinu", state: 'SP' },
    { code: '3525300', name: "Jaú", state: 'SP' },
    { code: '3525409', name: "Jeriquara", state: 'SP' },
    { code: '3525508', name: "Joanópolis", state: 'SP' },
    { code: '3525607', name: "João Ramalho", state: 'SP' },
    { code: '3525706', name: "José Bonifácio", state: 'SP' },
    { code: '3525805', name: "Júlio Mesquita", state: 'SP' },
    { code: '3525854', name: "Jumirim", state: 'SP' },
    { code: '3525904', name: "Jundiaí", state: 'SP' },
    { code: '3526001', name: "Junqueirópolis", state: 'SP' },
    { code: '3526100', name: "Juquiá", state: 'SP' },
    { code: '3526209', name: "Juquitiba", state: 'SP' },
    { code: '3526308', name: "Lagoinha", state: 'SP' },
    { code: '3526407', name: "Laranjal Paulista", state: 'SP' },
    { code: '3526506', name: "Lavínia", state: 'SP' },
    { code: '3526605', name: "Lavrinhas", state: 'SP' },
    { code: '3526704', name: "Leme", state: 'SP' },
    { code: '3526803', name: "Lençóis Paulista", state: 'SP' },
    { code: '3526902', name: "Limeira", state: 'SP' },
    { code: '3527009', name: "Lindóia", state: 'SP' },
    { code: '3527108', name: "Lins", state: 'SP' },
    { code: '3527207', name: "Lorena", state: 'SP' },
    { code: '3527256', name: "Lourdes", state: 'SP' },
    { code: '3527306', name: "Louveira", state: 'SP' },
    { code: '3527405', name: "Lucélia", state: 'SP' },
    { code: '3527504', name: "Lucianópolis", state: 'SP' },
    { code: '3527603', name: "Luís Antônio", state: 'SP' },
    { code: '3527702', name: "Luiziânia", state: 'SP' },
    { code: '3527801', name: "Lupércio", state: 'SP' },
    { code: '3527900', name: "Lutécia", state: 'SP' },
    { code: '3528007', name: "Macatuba", state: 'SP' },
    { code: '3528106', name: "Macaubal", state: 'SP' },
    { code: '3528205', name: "Macedônia", state: 'SP' },
    { code: '3528304', name: "Magda", state: 'SP' },
    { code: '3528403', name: "Mairinque", state: 'SP' },
    { code: '3528502', name: "Mairiporã", state: 'SP' },
    { code: '3528601', name: "Manduri", state: 'SP' },
    { code: '3528700', name: "Marabá Paulista", state: 'SP' },
    { code: '3528809', name: "Maracaí", state: 'SP' },
    { code: '3528858', name: "Marapoama", state: 'SP' },
    { code: '3528908', name: "Mariápolis", state: 'SP' },
    { code: '3529005', name: "Marília", state: 'SP' },
    { code: '3529104', name: "Marinópolis", state: 'SP' },
    { code: '3529203', name: "Martinópolis", state: 'SP' },
    { code: '3529302', name: "Matão", state: 'SP' },
    { code: '3529401', name: "Mauá", state: 'SP' },
    { code: '3529500', name: "Mendonça", state: 'SP' },
    { code: '3529609', name: "Meridiano", state: 'SP' },
    { code: '3529658', name: "Mesópolis", state: 'SP' },
    { code: '3529708', name: "Miguelópolis", state: 'SP' },
    { code: '3529807', name: "Mineiros do Tietê", state: 'SP' },
    { code: '3530003', name: "Mira Estrela", state: 'SP' },
    { code: '3529906', name: "Miracatu", state: 'SP' },
    { code: '3530102', name: "Mirandópolis", state: 'SP' },
    { code: '3530201', name: "Mirante do Paranapanema", state: 'SP' },
    { code: '3530300', name: "Mirassol", state: 'SP' },
    { code: '3530409', name: "Mirassolândia", state: 'SP' },
    { code: '3530508', name: "Mococa", state: 'SP' },
    { code: '3530607', name: "Mogi das Cruzes", state: 'SP' },
    { code: '3530706', name: "Mogi Guaçu", state: 'SP' },
    { code: '3530805', name: "Mogi Mirim", state: 'SP' },
    { code: '3530904', name: "Mombuca", state: 'SP' },
    { code: '3531001', name: "Monções", state: 'SP' },
    { code: '3531100', name: "Mongaguá", state: 'SP' },
    { code: '3531209', name: "Monte Alegre do Sul", state: 'SP' },
    { code: '3531308', name: "Monte Alto", state: 'SP' },
    { code: '3531407', name: "Monte Aprazível", state: 'SP' },
    { code: '3531506', name: "Monte Azul Paulista", state: 'SP' },
    { code: '3531605', name: "Monte Castelo", state: 'SP' },
    { code: '3531803', name: "Monte Mor", state: 'SP' },
    { code: '3531704', name: "Monteiro Lobato", state: 'SP' },
    { code: '3531902', name: "Morro Agudo", state: 'SP' },
    { code: '3532009', name: "Morungaba", state: 'SP' },
    { code: '3532058', name: "Motuca", state: 'SP' },
    { code: '3532108', name: "Murutinga do Sul", state: 'SP' },
    { code: '3532157', name: "Nantes", state: 'SP' },
    { code: '3532207', name: "Narandiba", state: 'SP' },
    { code: '3532306', name: "Natividade da Serra", state: 'SP' },
    { code: '3532405', name: "Nazaré Paulista", state: 'SP' },
    { code: '3532504', name: "Neves Paulista", state: 'SP' },
    { code: '3532603', name: "Nhandeara", state: 'SP' },
    { code: '3532702', name: "Nipoã", state: 'SP' },
    { code: '3532801', name: "Nova Aliança", state: 'SP' },
    { code: '3532827', name: "Nova Campina", state: 'SP' },
    { code: '3532843', name: "Nova Canaã Paulista", state: 'SP' },
    { code: '3532868', name: "Nova Castilho", state: 'SP' },
    { code: '3532900', name: "Nova Europa", state: 'SP' },
    { code: '3533007', name: "Nova Granada", state: 'SP' },
    { code: '3533106', name: "Nova Guataporanga", state: 'SP' },
    { code: '3533205', name: "Nova Independência", state: 'SP' },
    { code: '3533304', name: "Nova Luzitânia", state: 'SP' },
    { code: '3533403', name: "Nova Odessa", state: 'SP' },
    { code: '3533254', name: "Novais", state: 'SP' },
    { code: '3533502', name: "Novo Horizonte", state: 'SP' },
    { code: '3533601', name: "Nuporanga", state: 'SP' },
    { code: '3533700', name: "Ocauçu", state: 'SP' },
    { code: '3533809', name: "Óleo", state: 'SP' },
    { code: '3533908', name: "Olímpia", state: 'SP' },
    { code: '3534005', name: "Onda Verde", state: 'SP' },
    { code: '3534104', name: "Oriente", state: 'SP' },
    { code: '3534203', name: "Orindiúva", state: 'SP' },
    { code: '3534302', name: "Orlândia", state: 'SP' },
    { code: '3534401', name: "Osasco", state: 'SP' },
    { code: '3534500', name: "Oscar Bressane", state: 'SP' },
    { code: '3534609', name: "Osvaldo Cruz", state: 'SP' },
    { code: '3534708', name: "Ourinhos", state: 'SP' },
    { code: '3534807', name: "Ouro Verde", state: 'SP' },
    { code: '3534757', name: "Ouroeste", state: 'SP' },
    { code: '3534906', name: "Pacaembu", state: 'SP' },
    { code: '3535002', name: "Palestina", state: 'SP' },
    { code: '3535101', name: "Palmares Paulista", state: 'SP' },
    { code: '3535200', name: "Palmeira d'Oeste", state: 'SP' },
    { code: '3535309', name: "Palmital", state: 'SP' },
    { code: '3535408', name: "Panorama", state: 'SP' },
    { code: '3535507', name: "Paraguaçu Paulista", state: 'SP' },
    { code: '3535606', name: "Paraibuna", state: 'SP' },
    { code: '3535705', name: "Paraíso", state: 'SP' },
    { code: '3535804', name: "Paranapanema", state: 'SP' },
    { code: '3535903', name: "Paranapuã", state: 'SP' },
    { code: '3536000', name: "Parapuã", state: 'SP' },
    { code: '3536109', name: "Pardinho", state: 'SP' },
    { code: '3536208', name: "Pariquera-Açu", state: 'SP' },
    { code: '3536257', name: "Parisi", state: 'SP' },
    { code: '3536307', name: "Patrocínio Paulista", state: 'SP' },
    { code: '3536406', name: "Paulicéia", state: 'SP' },
    { code: '3536505', name: "Paulínia", state: 'SP' },
    { code: '3536570', name: "Paulistânia", state: 'SP' },
    { code: '3536604', name: "Paulo de Faria", state: 'SP' },
    { code: '3536703', name: "Pederneiras", state: 'SP' },
    { code: '3536802', name: "Pedra Bela", state: 'SP' },
    { code: '3536901', name: "Pedranópolis", state: 'SP' },
    { code: '3537008', name: "Pedregulho", state: 'SP' },
    { code: '3537107', name: "Pedreira", state: 'SP' },
    { code: '3537156', name: "Pedrinhas Paulista", state: 'SP' },
    { code: '3537206', name: "Pedro de Toledo", state: 'SP' },
    { code: '3537305', name: "Penápolis", state: 'SP' },
    { code: '3537404', name: "Pereira Barreto", state: 'SP' },
    { code: '3537503', name: "Pereiras", state: 'SP' },
    { code: '3537602', name: "Peruíbe", state: 'SP' },
    { code: '3537701', name: "Piacatu", state: 'SP' },
    { code: '3537800', name: "Piedade", state: 'SP' },
    { code: '3537909', name: "Pilar do Sul", state: 'SP' },
    { code: '3538006', name: "Pindamonhangaba", state: 'SP' },
    { code: '3538105', name: "Pindorama", state: 'SP' },
    { code: '3538204', name: "Pinhalzinho", state: 'SP' },
    { code: '3538303', name: "Piquerobi", state: 'SP' },
    { code: '3538501', name: "Piquete", state: 'SP' },
    { code: '3538600', name: "Piracaia", state: 'SP' },
    { code: '3538709', name: "Piracicaba", state: 'SP' },
    { code: '3538808', name: "Piraju", state: 'SP' },
    { code: '3538907', name: "Pirajuí", state: 'SP' },
    { code: '3539004', name: "Pirangi", state: 'SP' },
    { code: '3539103', name: "Pirapora do Bom Jesus", state: 'SP' },
    { code: '3539202', name: "Pirapozinho", state: 'SP' },
    { code: '3539301', name: "Pirassununga", state: 'SP' },
    { code: '3539400', name: "Piratininga", state: 'SP' },
    { code: '3539509', name: "Pitangueiras", state: 'SP' },
    { code: '3539608', name: "Planalto", state: 'SP' },
    { code: '3539707', name: "Platina", state: 'SP' },
    { code: '3539806', name: "Poá", state: 'SP' },
    { code: '3539905', name: "Poloni", state: 'SP' },
    { code: '3540002', name: "Pompéia", state: 'SP' },
    { code: '3540101', name: "Pongaí", state: 'SP' },
    { code: '3540200', name: "Pontal", state: 'SP' },
    { code: '3540259', name: "Pontalinda", state: 'SP' },
    { code: '3540309', name: "Pontes Gestal", state: 'SP' },
    { code: '3540408', name: "Populina", state: 'SP' },
    { code: '3540507', name: "Porangaba", state: 'SP' },
    { code: '3540606', name: "Porto Feliz", state: 'SP' },
    { code: '3540705', name: "Porto Ferreira", state: 'SP' },
    { code: '3540754', name: "Potim", state: 'SP' },
    { code: '3540804', name: "Potirendaba", state: 'SP' },
    { code: '3540853', name: "Pracinha", state: 'SP' },
    { code: '3540903', name: "Pradópolis", state: 'SP' },
    { code: '3541000', name: "Praia Grande", state: 'SP' },
    { code: '3541059', name: "Pratânia", state: 'SP' },
    { code: '3541109', name: "Presidente Alves", state: 'SP' },
    { code: '3541208', name: "Presidente Bernardes", state: 'SP' },
    { code: '3541307', name: "Presidente Epitácio", state: 'SP' },
    { code: '3541406', name: "Presidente Prudente", state: 'SP' },
    { code: '3541505', name: "Presidente Venceslau", state: 'SP' },
    { code: '3541604', name: "Promissão", state: 'SP' },
    { code: '3541653', name: "Quadra", state: 'SP' },
    { code: '3541703', name: "Quatá", state: 'SP' },
    { code: '3541802', name: "Queiroz", state: 'SP' },
    { code: '3541901', name: "Queluz", state: 'SP' },
    { code: '3542008', name: "Quintana", state: 'SP' },
    { code: '3542107', name: "Rafard", state: 'SP' },
    { code: '3542206', name: "Rancharia", state: 'SP' },
    { code: '3542305', name: "Redenção da Serra", state: 'SP' },
    { code: '3542404', name: "Regente Feijó", state: 'SP' },
    { code: '3542503', name: "Reginópolis", state: 'SP' },
    { code: '3542602', name: "Registro", state: 'SP' },
    { code: '3542701', name: "Restinga", state: 'SP' },
    { code: '3542800', name: "Ribeira", state: 'SP' },
    { code: '3542909', name: "Ribeirão Bonito", state: 'SP' },
    { code: '3543006', name: "Ribeirão Branco", state: 'SP' },
    { code: '3543105', name: "Ribeirão Corrente", state: 'SP' },
    { code: '3543204', name: "Ribeirão do Sul", state: 'SP' },
    { code: '3543238', name: "Ribeirão dos Índios", state: 'SP' },
    { code: '3543253', name: "Ribeirão Grande", state: 'SP' },
    { code: '3543303', name: "Ribeirão Pires", state: 'SP' },
    { code: '3543402', name: "Ribeirão Preto", state: 'SP' },
    { code: '3543600', name: "Rifaina", state: 'SP' },
    { code: '3543709', name: "Rincão", state: 'SP' },
    { code: '3543808', name: "Rinópolis", state: 'SP' },
    { code: '3543907', name: "Rio Claro", state: 'SP' },
    { code: '3544004', name: "Rio das Pedras", state: 'SP' },
    { code: '3544103', name: "Rio Grande da Serra", state: 'SP' },
    { code: '3544202', name: "Riolândia", state: 'SP' },
    { code: '3543501', name: "Riversul", state: 'SP' },
    { code: '3544251', name: "Rosana", state: 'SP' },
    { code: '3544301', name: "Roseira", state: 'SP' },
    { code: '3544400', name: "Rubiácea", state: 'SP' },
    { code: '3544509', name: "Rubinéia", state: 'SP' },
    { code: '3544608', name: "Sabino", state: 'SP' },
    { code: '3544707', name: "Sagres", state: 'SP' },
    { code: '3544806', name: "Sales", state: 'SP' },
    { code: '3544905', name: "Sales Oliveira", state: 'SP' },
    { code: '3545001', name: "Salesópolis", state: 'SP' },
    { code: '3545100', name: "Salmourão", state: 'SP' },
    { code: '3545159', name: "Saltinho", state: 'SP' },
    { code: '3545209', name: "Salto", state: 'SP' },
    { code: '3545308', name: "Salto de Pirapora", state: 'SP' },
    { code: '3545407', name: "Salto Grande", state: 'SP' },
    { code: '3545506', name: "Sandovalina", state: 'SP' },
    { code: '3545605', name: "Santa Adélia", state: 'SP' },
    { code: '3545704', name: "Santa Albertina", state: 'SP' },
    { code: '3545803', name: "Santa Bárbara d'Oeste", state: 'SP' },
    { code: '3546009', name: "Santa Branca", state: 'SP' },
    { code: '3546108', name: "Santa Clara d'Oeste", state: 'SP' },
    { code: '3546207', name: "Santa Cruz da Conceição", state: 'SP' },
    { code: '3546256', name: "Santa Cruz da Esperança", state: 'SP' },
    { code: '3546306', name: "Santa Cruz das Palmeiras", state: 'SP' },
    { code: '3546405', name: "Santa Cruz do Rio Pardo", state: 'SP' },
    { code: '3546504', name: "Santa Ernestina", state: 'SP' },
    { code: '3546603', name: "Santa Fé do Sul", state: 'SP' },
    { code: '3546702', name: "Santa Gertrudes", state: 'SP' },
    { code: '3546801', name: "Santa Isabel", state: 'SP' },
    { code: '3546900', name: "Santa Lúcia", state: 'SP' },
    { code: '3547007', name: "Santa Maria da Serra", state: 'SP' },
    { code: '3547106', name: "Santa Mercedes", state: 'SP' },
    { code: '3547403', name: "Santa Rita d'Oeste", state: 'SP' },
    { code: '3547502', name: "Santa Rita do Passa Quatro", state: 'SP' },
    { code: '3547601', name: "Santa Rosa de Viterbo", state: 'SP' },
    { code: '3547650', name: "Santa Salete", state: 'SP' },
    { code: '3547205', name: "Santana da Ponte Pensa", state: 'SP' },
    { code: '3547304', name: "Santana de Parnaíba", state: 'SP' },
    { code: '3547700', name: "Santo Anastácio", state: 'SP' },
    { code: '3547809', name: "Santo André", state: 'SP' },
    { code: '3547908', name: "Santo Antônio da Alegria", state: 'SP' },
    { code: '3548005', name: "Santo Antônio de Posse", state: 'SP' },
    { code: '3548054', name: "Santo Antônio do Aracanguá", state: 'SP' },
    { code: '3548104', name: "Santo Antônio do Jardim", state: 'SP' },
    { code: '3548203', name: "Santo Antônio do Pinhal", state: 'SP' },
    { code: '3548302', name: "Santo Expedito", state: 'SP' },
    { code: '3548401', name: "Santópolis do Aguapeí", state: 'SP' },
    { code: '3548500', name: "Santos", state: 'SP' },
    { code: '3548609', name: "São Bento do Sapucaí", state: 'SP' },
    { code: '3548708', name: "São Bernardo do Campo", state: 'SP' },
    { code: '3548807', name: "São Caetano do Sul", state: 'SP' },
    { code: '3548906', name: "São Carlos", state: 'SP' },
    { code: '3549003', name: "São Francisco", state: 'SP' },
    { code: '3549102', name: "São João da Boa Vista", state: 'SP' },
    { code: '3549201', name: "São João das Duas Pontes", state: 'SP' },
    { code: '3549250', name: "São João de Iracema", state: 'SP' },
    { code: '3549300', name: "São João do Pau d'Alho", state: 'SP' },
    { code: '3549409', name: "São Joaquim da Barra", state: 'SP' },
    { code: '3549508', name: "São José da Bela Vista", state: 'SP' },
    { code: '3549607', name: "São José do Barreiro", state: 'SP' },
    { code: '3549706', name: "São José do Rio Pardo", state: 'SP' },
    { code: '3549805', name: "São José do Rio Preto", state: 'SP' },
    { code: '3549904', name: "São José dos Campos", state: 'SP' },
    { code: '3549953', name: "São Lourenço da Serra", state: 'SP' },
    { code: '3550001', name: "São Luiz do Paraitinga", state: 'SP' },
    { code: '3550100', name: "São Manuel", state: 'SP' },
    { code: '3550209', name: "São Miguel Arcanjo", state: 'SP' },
    { code: '3550308', name: "São Paulo", state: 'SP' },
    { code: '3550407', name: "São Pedro", state: 'SP' },
    { code: '3550506', name: "São Pedro do Turvo", state: 'SP' },
    { code: '3550605', name: "São Roque", state: 'SP' },
    { code: '3550704', name: "São Sebastião", state: 'SP' },
    { code: '3550803', name: "São Sebastião da Grama", state: 'SP' },
    { code: '3550902', name: "São Simão", state: 'SP' },
    { code: '3551009', name: "São Vicente", state: 'SP' },
    { code: '3551108', name: "Sarapuí", state: 'SP' },
    { code: '3551207', name: "Sarutaiá", state: 'SP' },
    { code: '3551306', name: "Sebastianópolis do Sul", state: 'SP' },
    { code: '3551405', name: "Serra Azul", state: 'SP' },
    { code: '3551603', name: "Serra Negra", state: 'SP' },
    { code: '3551504', name: "Serrana", state: 'SP' },
    { code: '3551702', name: "Sertãozinho", state: 'SP' },
    { code: '3551801', name: "Sete Barras", state: 'SP' },
    { code: '3551900', name: "Severínia", state: 'SP' },
    { code: '3552007', name: "Silveiras", state: 'SP' },
    { code: '3552106', name: "Socorro", state: 'SP' },
    { code: '3552205', name: "Sorocaba", state: 'SP' },
    { code: '3552304', name: "Sud Mennucci", state: 'SP' },
    { code: '3552403', name: "Sumaré", state: 'SP' },
    { code: '3552551', name: "Suzanápolis", state: 'SP' },
    { code: '3552502', name: "Suzano", state: 'SP' },
    { code: '3552601', name: "Tabapuã", state: 'SP' },
    { code: '3552700', name: "Tabatinga", state: 'SP' },
    { code: '3552809', name: "Taboão da Serra", state: 'SP' },
    { code: '3552908', name: "Taciba", state: 'SP' },
    { code: '3553005', name: "Taguaí", state: 'SP' },
    { code: '3553104', name: "Taiaçu", state: 'SP' },
    { code: '3553203', name: "Taiúva", state: 'SP' },
    { code: '3553302', name: "Tambaú", state: 'SP' },
    { code: '3553401', name: "Tanabi", state: 'SP' },
    { code: '3553500', name: "Tapiraí", state: 'SP' },
    { code: '3553609', name: "Tapiratiba", state: 'SP' },
    { code: '3553658', name: "Taquaral", state: 'SP' },
    { code: '3553708', name: "Taquaritinga", state: 'SP' },
    { code: '3553807', name: "Taquarituba", state: 'SP' },
    { code: '3553856', name: "Taquarivaí", state: 'SP' },
    { code: '3553906', name: "Tarabai", state: 'SP' },
    { code: '3553955', name: "Tarumã", state: 'SP' },
    { code: '3554003', name: "Tatuí", state: 'SP' },
    { code: '3554102', name: "Taubaté", state: 'SP' },
    { code: '3554201', name: "Tejupá", state: 'SP' },
    { code: '3554300', name: "Teodoro Sampaio", state: 'SP' },
    { code: '3554409', name: "Terra Roxa", state: 'SP' },
    { code: '3554508', name: "Tietê", state: 'SP' },
    { code: '3554607', name: "Timburi", state: 'SP' },
    { code: '3554656', name: "Torre de Pedra", state: 'SP' },
    { code: '3554706', name: "Torrinha", state: 'SP' },
    { code: '3554755', name: "Trabiju", state: 'SP' },
    { code: '3554805', name: "Tremembé", state: 'SP' },
    { code: '3554904', name: "Três Fronteiras", state: 'SP' },
    { code: '3554953', name: "Tuiuti", state: 'SP' },
    { code: '3555000', name: "Tupã", state: 'SP' },
    { code: '3555109', name: "Tupi Paulista", state: 'SP' },
    { code: '3555208', name: "Turiúba", state: 'SP' },
    { code: '3555307', name: "Turmalina", state: 'SP' },
    { code: '3555356', name: "Ubarana", state: 'SP' },
    { code: '3555406', name: "Ubatuba", state: 'SP' },
    { code: '3555505', name: "Ubirajara", state: 'SP' },
    { code: '3555604', name: "Uchoa", state: 'SP' },
    { code: '3555703', name: "União Paulista", state: 'SP' },
    { code: '3555802', name: "Urânia", state: 'SP' },
    { code: '3555901', name: "Uru", state: 'SP' },
    { code: '3556008', name: "Urupês", state: 'SP' },
    { code: '3556107', name: "Valentim Gentil", state: 'SP' },
    { code: '3556206', name: "Valinhos", state: 'SP' },
    { code: '3556305', name: "Valparaíso", state: 'SP' },
    { code: '3556354', name: "Vargem", state: 'SP' },
    { code: '3556404', name: "Vargem Grande do Sul", state: 'SP' },
    { code: '3556453', name: "Vargem Grande Paulista", state: 'SP' },
    { code: '3556503', name: "Várzea Paulista", state: 'SP' },
    { code: '3556602', name: "Vera Cruz", state: 'SP' },
    { code: '3556701', name: "Vinhedo", state: 'SP' },
    { code: '3556800', name: "Viradouro", state: 'SP' },
    { code: '3556909', name: "Vista Alegre do Alto", state: 'SP' },
    { code: '3556958', name: "Vitória Brasil", state: 'SP' },
    { code: '3557006', name: "Votorantim", state: 'SP' },
    { code: '3557105', name: "Votuporanga", state: 'SP' },
    { code: '3557154', name: "Zacarias", state: 'SP' }
  ],

  // TOCANTINS (TO) - 139 municípios
  TO: [
    { code: '1700251', name: "Abreulândia", state: 'TO' },
    { code: '1700301', name: "Aguiarnópolis", state: 'TO' },
    { code: '1700350', name: "Aliança do Tocantins", state: 'TO' },
    { code: '1700400', name: "Almas", state: 'TO' },
    { code: '1700707', name: "Alvorada", state: 'TO' },
    { code: '1701002', name: "Ananás", state: 'TO' },
    { code: '1701051', name: "Angico", state: 'TO' },
    { code: '1701101', name: "Aparecida do Rio Negro", state: 'TO' },
    { code: '1701309', name: "Aragominas", state: 'TO' },
    { code: '1701903', name: "Araguacema", state: 'TO' },
    { code: '1702000', name: "Araguaçu", state: 'TO' },
    { code: '1702109', name: "Araguaína", state: 'TO' },
    { code: '1702158', name: "Araguanã", state: 'TO' },
    { code: '1702208', name: "Araguatins", state: 'TO' },
    { code: '1702307', name: "Arapoema", state: 'TO' },
    { code: '1702406', name: "Arraias", state: 'TO' },
    { code: '1702554', name: "Augustinópolis", state: 'TO' },
    { code: '1702703', name: "Aurora do Tocantins", state: 'TO' },
    { code: '1702901', name: "Axixá do Tocantins", state: 'TO' },
    { code: '1703008', name: "Babaçulândia", state: 'TO' },
    { code: '1703057', name: "Bandeirantes do Tocantins", state: 'TO' },
    { code: '1703073', name: "Barra do Ouro", state: 'TO' },
    { code: '1703107', name: "Barrolândia", state: 'TO' },
    { code: '1703206', name: "Bernardo Sayão", state: 'TO' },
    { code: '1703305', name: "Bom Jesus do Tocantins", state: 'TO' },
    { code: '1703602', name: "Brasilândia do Tocantins", state: 'TO' },
    { code: '1703701', name: "Brejinho de Nazaré", state: 'TO' },
    { code: '1703800', name: "Buriti do Tocantins", state: 'TO' },
    { code: '1703826', name: "Cachoeirinha", state: 'TO' },
    { code: '1703842', name: "Campos Lindos", state: 'TO' },
    { code: '1703867', name: "Cariri do Tocantins", state: 'TO' },
    { code: '1703883', name: "Carmolândia", state: 'TO' },
    { code: '1703891', name: "Carrasco Bonito", state: 'TO' },
    { code: '1703909', name: "Caseara", state: 'TO' },
    { code: '1704105', name: "Centenário", state: 'TO' },
    { code: '1705102', name: "Chapada da Natividade", state: 'TO' },
    { code: '1704600', name: "Chapada de Areia", state: 'TO' },
    { code: '1705508', name: "Colinas do Tocantins", state: 'TO' },
    { code: '1716703', name: "Colméia", state: 'TO' },
    { code: '1705557', name: "Combinado", state: 'TO' },
    { code: '1705607', name: "Conceição do Tocantins", state: 'TO' },
    { code: '1706001', name: "Couto Magalhães", state: 'TO' },
    { code: '1706100', name: "Cristalândia", state: 'TO' },
    { code: '1706258', name: "Crixás do Tocantins", state: 'TO' },
    { code: '1706506', name: "Darcinópolis", state: 'TO' },
    { code: '1707009', name: "Dianópolis", state: 'TO' },
    { code: '1707108', name: "Divinópolis do Tocantins", state: 'TO' },
    { code: '1707207', name: "Dois Irmãos do Tocantins", state: 'TO' },
    { code: '1707306', name: "Dueré", state: 'TO' },
    { code: '1707405', name: "Esperantina", state: 'TO' },
    { code: '1707553', name: "Fátima", state: 'TO' },
    { code: '1707652', name: "Figueirópolis", state: 'TO' },
    { code: '1707702', name: "Filadélfia", state: 'TO' },
    { code: '1708205', name: "Formoso do Araguaia", state: 'TO' },
    { code: '1708304', name: "Goianorte", state: 'TO' },
    { code: '1709005', name: "Goiatins", state: 'TO' },
    { code: '1709302', name: "Guaraí", state: 'TO' },
    { code: '1709500', name: "Gurupi", state: 'TO' },
    { code: '1709807', name: "Ipueiras", state: 'TO' },
    { code: '1710508', name: "Itacajá", state: 'TO' },
    { code: '1710706', name: "Itaguatins", state: 'TO' },
    { code: '1710904', name: "Itapiratins", state: 'TO' },
    { code: '1711100', name: "Itaporã do Tocantins", state: 'TO' },
    { code: '1711506', name: "Jaú do Tocantins", state: 'TO' },
    { code: '1711803', name: "Juarina", state: 'TO' },
    { code: '1711902', name: "Lagoa da Confusão", state: 'TO' },
    { code: '1711951', name: "Lagoa do Tocantins", state: 'TO' },
    { code: '1712009', name: "Lajeado", state: 'TO' },
    { code: '1712157', name: "Lavandeira", state: 'TO' },
    { code: '1712405', name: "Lizarda", state: 'TO' },
    { code: '1712454', name: "Luzinópolis", state: 'TO' },
    { code: '1712504', name: "Marianópolis do Tocantins", state: 'TO' },
    { code: '1712702', name: "Mateiros", state: 'TO' },
    { code: '1712801', name: "Maurilândia do Tocantins", state: 'TO' },
    { code: '1713205', name: "Miracema do Tocantins", state: 'TO' },
    { code: '1713304', name: "Miranorte", state: 'TO' },
    { code: '1713601', name: "Monte do Carmo", state: 'TO' },
    { code: '1713700', name: "Monte Santo do Tocantins", state: 'TO' },
    { code: '1713957', name: "Muricilândia", state: 'TO' },
    { code: '1714203', name: "Natividade", state: 'TO' },
    { code: '1714302', name: "Nazaré", state: 'TO' },
    { code: '1714880', name: "Nova Olinda", state: 'TO' },
    { code: '1715002', name: "Nova Rosalândia", state: 'TO' },
    { code: '1715101', name: "Novo Acordo", state: 'TO' },
    { code: '1715150', name: "Novo Alegre", state: 'TO' },
    { code: '1715259', name: "Novo Jardim", state: 'TO' },
    { code: '1715507', name: "Oliveira de Fátima", state: 'TO' },
    { code: '1721000', name: "Palmas", state: 'TO' },
    { code: '1715705', name: "Palmeirante", state: 'TO' },
    { code: '1713809', name: "Palmeiras do Tocantins", state: 'TO' },
    { code: '1715754', name: "Palmeirópolis", state: 'TO' },
    { code: '1716109', name: "Paraíso do Tocantins", state: 'TO' },
    { code: '1716208', name: "Paranã", state: 'TO' },
    { code: '1716307', name: "Pau D'Arco", state: 'TO' },
    { code: '1716505', name: "Pedro Afonso", state: 'TO' },
    { code: '1716604', name: "Peixe", state: 'TO' },
    { code: '1716653', name: "Pequizeiro", state: 'TO' },
    { code: '1717008', name: "Pindorama do Tocantins", state: 'TO' },
    { code: '1717206', name: "Piraquê", state: 'TO' },
    { code: '1717503', name: "Pium", state: 'TO' },
    { code: '1717800', name: "Ponte Alta do Bom Jesus", state: 'TO' },
    { code: '1717909', name: "Ponte Alta do Tocantins", state: 'TO' },
    { code: '1718006', name: "Porto Alegre do Tocantins", state: 'TO' },
    { code: '1718204', name: "Porto Nacional", state: 'TO' },
    { code: '1718303', name: "Praia Norte", state: 'TO' },
    { code: '1718402', name: "Presidente Kennedy", state: 'TO' },
    { code: '1718451', name: "Pugmil", state: 'TO' },
    { code: '1718501', name: "Recursolândia", state: 'TO' },
    { code: '1718550', name: "Riachinho", state: 'TO' },
    { code: '1718659', name: "Rio da Conceição", state: 'TO' },
    { code: '1718709', name: "Rio dos Bois", state: 'TO' },
    { code: '1718758', name: "Rio Sono", state: 'TO' },
    { code: '1718808', name: "Sampaio", state: 'TO' },
    { code: '1718840', name: "Sandolândia", state: 'TO' },
    { code: '1718865', name: "Santa Fé do Araguaia", state: 'TO' },
    { code: '1718881', name: "Santa Maria do Tocantins", state: 'TO' },
    { code: '1718899', name: "Santa Rita do Tocantins", state: 'TO' },
    { code: '1718907', name: "Santa Rosa do Tocantins", state: 'TO' },
    { code: '1719004', name: "Santa Tereza do Tocantins", state: 'TO' },
    { code: '1720002', name: "Santa Terezinha do Tocantins", state: 'TO' },
    { code: '1720101', name: "São Bento do Tocantins", state: 'TO' },
    { code: '1720150', name: "São Félix do Tocantins", state: 'TO' },
    { code: '1720200', name: "São Miguel do Tocantins", state: 'TO' },
    { code: '1720259', name: "São Salvador do Tocantins", state: 'TO' },
    { code: '1720309', name: "São Sebastião do Tocantins", state: 'TO' },
    { code: '1720499', name: "São Valério", state: 'TO' },
    { code: '1720655', name: "Silvanópolis", state: 'TO' },
    { code: '1720804', name: "Sítio Novo do Tocantins", state: 'TO' },
    { code: '1720853', name: "Sucupira", state: 'TO' },
    { code: '1708254', name: "Tabocão", state: 'TO' },
    { code: '1720903', name: "Taguatinga", state: 'TO' },
    { code: '1720937', name: "Taipas do Tocantins", state: 'TO' },
    { code: '1720978', name: "Talismã", state: 'TO' },
    { code: '1721109', name: "Tocantínia", state: 'TO' },
    { code: '1721208', name: "Tocantinópolis", state: 'TO' },
    { code: '1721257', name: "Tupirama", state: 'TO' },
    { code: '1721307', name: "Tupiratins", state: 'TO' },
    { code: '1722081', name: "Wanderlândia", state: 'TO' },
    { code: '1722107', name: "Xambioá", state: 'TO' }
  ],

};

// Função helper para buscar municípios por estado
export const getMunicipalitiesByState = (stateCode: string): Municipality[] => {
  return BRAZILIAN_MUNICIPALITIES[stateCode.toUpperCase()] || [];
};

// Função para buscar município pelo código IBGE
export const getMunicipalityByCode = (code: string): Municipality | undefined => {
  for (const state in BRAZILIAN_MUNICIPALITIES) {
    const found = BRAZILIAN_MUNICIPALITIES[state].find(m => m.code === code);
    if (found) return found;
  }
  return undefined;
};

// Função para buscar municípios por nome (busca parcial)
export const searchMunicipalitiesByName = (searchTerm: string): Municipality[] => {
  const normalizedSearch = searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const results: Municipality[] = [];
  
  for (const state in BRAZILIAN_MUNICIPALITIES) {
    const matches = BRAZILIAN_MUNICIPALITIES[state].filter(m => 
      m.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(normalizedSearch)
    );
    results.push(...matches);
  }
  
  return results;
};

// Estatísticas
export const getTotalMunicipalitiesCount = (): number => {
  return Object.values(BRAZILIAN_MUNICIPALITIES).reduce((total, municipalities) => 
    total + municipalities.length, 0
  );
};

export const getMunicipalitiesCountByState = (): Record<string, number> => {
  const counts: Record<string, number> = {};
  for (const state in BRAZILIAN_MUNICIPALITIES) {
    counts[state] = BRAZILIAN_MUNICIPALITIES[state].length;
  }
  return counts;
};
